import { DAILY_REWARD_STATUS } from '@Data/Models';
import { IGU_WALLET_TRANSACTIONS } from '@models/gamingWallet';
import {
    MARKETPLACE_ORDERS_SORT_OPTION,
    MARKETPLACE_PET_TYPE,
} from '@models/marketplace';
import {
    GAME_DIFFICULTY,
    LUCKY_STRIKE_GAMES_STATUS,
    MYSTERY_GAMES,
    MYSTERY_LIKES_STATUS,
    NFT_ROYAL_GAME_HISTORY_STATUS,
    NFT_ROYAL_GAME_MODE,
    TOKEN_TELLER_GAME_PREDICTION_DIRECTION,
    TOKEN_TELLER_GAME_STATUS,
    TOKEN_TELLER_HISTORY_GAMES_STATUS,
} from '@models/mysteryGames';
import ROUTES from '@navigation/routes';

const pl = {
    createWalletPassphrase: {
        title: 'Twoja fraza seed',
        text: 'Proszę zapisać te 12 słów na kartce papieru. Przy zapisywaniu pamiętaj o ich kolejności. Przechowuj je w bezpiecznym miejscu.',
        button: 'Kontynuuj',
        loading: 'Generowanie zwrotów nasion..',
    },
    createWalletVerification: {
        title: 'Weryfikacja',
        text: 'Proszę wybrać właściwe słowa na podstawie ich numerów (w kolejności, w jakiej zostały napisane na poprzednim ekranie)',
        button: 'Kontynuuj',
        errors: {
            passphraseNotCorrect:
                'Kolejność słów jest nieprawidłowa. Wybierz właściwe słowa zgodnie z ich kolejnością',
        },
        loading: 'Sprawdzanie zwrotów z nasion..',
    },
    createWalletFirst: {
        title: 'Zapisz swoją frazę seed',
        text: 'Jeśli Twoje urządzenie zostanie zgubione lub skradzione, będziesz mógł odzyskać dostęp do swoich środków za pomocą seed frazy. Jeśli utracisz frazę kluczową, spowoduje to utratę środków.',
        button: 'Jestem gotowy, kontynuuj',
    },
    importWalletInit: {
        title: 'Znaleźliśmy twoje konto',
        text: 'Zalogowałeś się z innego urządzenia i nie masz dostępu do podłączonego portfela. Proszę, podaj 12 słowo seed phrase swojego portfela, aby kontynuować korzystanie z aplikacji',
        pets: 'Zwierzęta domowe',
        import: 'Importuj portfel',
        loading: 'Importowanie portfela..',
    },
    importWalletScreen: {
        title: 'Importuj portfel',
        text: 'Wpisz swoje 12 słów, aby móc korzystać z portfela w aplikacji',
        listTitle: 'Zwrotnik nasienny',
        inputPlaceholder: 'Wpisz tutaj',
        clearAll: 'Wyczyść',
        importWallet: 'Import',
        privateKeyButton: 'Import z klucza prywatnego',
        privateKeyModal: {
            title: 'Import z klucza prywatnego',
            text: 'Jeśli nie posiadasz seed frazy, możesz zaimportować swój portfel za pomocą klucza prywatnego',
            label: 'Klucz prywatny',
            placeholder: 'Wprowadź klucz prywatny',
            button: 'Import',
        },
        errors: {
            mnemonicError:
                'Portfel z tym 12 wyrazem nie istnieje. Proszę sprawdzić to jeszcze raz lub podać inną frazę',
            privateKeyError:
                'Portfel z tym kluczem prywatnym nie istnieje. Prosimy o ponowne sprawdzenie lub podanie innego klucza prywatnego',
            walletNotEqual: 'Podany portfel nie jest zgodny z portfelem konta',
            walletAlreadyVerified:
                'Ten portfel należy do innego konta, nie można go zaimportować',
        },
        success: 'Portfel został pomyślnie zaimportowany',
    },
    createWalletInit: {
        createButton: 'Utwórz portfel',
        importButton: 'Importuj portfel',
        slider: {
            titleSlide1: 'Podłączenie portfela',
            textSlide1:
                'Utwórz nowy portfel lub zaimportuj istniejący, podając swoje 12 słów seed frazy',
            titleSlide2: 'Portfel non-custodial',
            textSlide2:
                'IguVerse działa na zasadzie samowystarczalnego portfela, gdzie masz wyłączną kontrolę nad swoimi kluczami prywatnymi, które z kolei kontrolują Twoją kryptowalutę i udowadniają, że środki są Twoje',
            titleSlide3: 'Przywrócenie konta',
            textSlide3:
                'Jeśli utracisz dostęp do urządzenia i seed frazy, nie będziemy w stanie przywrócić portfela i środki zostaną utracone.',
        },
    },
    createWalletSuccess: {
        title: 'Portfel Stworzony',
        text: 'Gratulacje! Twój portfel został pomyślnie utworzony, możesz zacząć używać swojego konta teraz',
        button: 'Przejdź do ostatniego kroku',
        buttonNew: 'Kontynuuj',
    },
    importWalletSuccess: {
        title: 'Portfel Importowany',
        text: 'Gratulacje! Twój portfel został pomyślnie zaimportowany, możesz zacząć używać swojego konta',
        button: 'Kontynuuj',
        buttonNew: 'Przejdź do ostatniego kroku',
    },
    login: {
        facebook: 'Zaloguj przez Facebook',
        google: 'Zaloguj przez Google',
        apple: 'Zaloguj przez Apple',
        email: 'Zaloguj przez E-mail',
        twitter: 'Kontynuuj z Twitterem',
        emailTitle: 'Zaloguj się / Zarejestruj się',
        creatingAccount:
            'Zakładając konto wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z',
        and: 'oraz',
        privacyPolicy: 'Polityką prywatności',
        termsOfUse: 'Warunkami użytkowania',
        placeholderEmail: 'Wprowadź e-mail',
        labelEmail: 'Email',
        placeholderVerificationCode: 'Wprowadź kod',
        labelVerificationCode: 'Kod zostanie wysłany na Twój e-mail',
        sendCode: 'Wyślij',
        resendIn: 'Przesłać ponownie w',
        seconds: 'sec',
        welcomeTo: 'Witamy w',
        codeSent: 'Hasło jednorazowe wysłane!',
        errors: {
            invalidEmailAddress: 'Nieprawidłowy adres e-mail',
            emailIsRequired: 'Pole Email jest wymagane',
            verificationCodeIsRequired:
                'Hasło jednorazowe jest wymagane do zalogowania się na konto',
            verificationCodeIsBadOrExpired:
                'Hasło jednorazowe jest błędne lub wygasło. Spróbuj ponownie',
            verificationCodeTooMuchAttempts:
                'Za dużo prób. Proszę spróbować ponownie później',
            loginFailed: 'Logowanie nie powiodło się',
            smthWentWrong:
                'Coś poszło nie tak podczas logowania. Spróbuj ponownie później, lub spróbuj innej metody',
        },
        loading: { sendingCode: 'Wysyłanie kodu..', loggingIn: 'Logowanie.' },
    },
    mintPetRank: {
        title: 'Wybierz rangę swojego zwierzęcia',
        text: 'Ranga określa, ile nagród otrzyma Twój zwierzak za wykonanie codziennych zadań',
        free: 'Free',
        roi: 'ROI ≈',
        dailyReward: 'Nagroda dzienna ≈',
        buttonNext: 'Przejdź do następnego kroku',
        disabled: 'Tylko jedna darmowa ranga na konto jest dozwolona',
        info: 'Co to jest Rank?',
        whiteList: 'Whitelist ({{amount}})',
        mysteryBox: 'Mystery Box',
        mysteryBoxWithAmount: 'Mystery Box ({{amount}})',
    },
    mintPickPhoto: {
        title: 'Wybierz swoje zdjęcie zwierzęcia',
        text: 'Zrób zdjęcie swojego pupila lub wybierz ulubione zdjęcie z galerii',
        or: 'lub',
        takePhoto: 'Kamera otwarta',
        selectFromGallery: 'Wybierz z galerii',
        tips: {
            title: 'Wskazówki dotyczące doskonałego zdjęcia',
            visible: 'Prawidłowo',
            cut: 'Cięcie',
            blurry: 'Blurry',
            glare: 'Glare',
            tipOne: 'Dobre światło to podstawa',
            tipTwo: 'Spróbuj zrobić zdjęcie z neutralnym tłem',
            tipThree:
                'Upewnij się, że zwierzę jest jedynym osobnikiem na zdjęciu',
        },
        analyzingPhoto: 'Analizując swoje zdjęcie..',
        errors: {
            explicitContent: {
                title: 'Treść zakazana',
                text: 'Obrazek zawiera niedozwolone treści. Te działania mogą prowadzić do zablokowania konta',
            },
            uploadError: {
                title: 'Przesyłanie nie powiodło się',
                text: 'Sprawdź połączenie internetowe i spróbuj ponownie',
            },
            processImageFailed: {
                title: 'Błąd obrazu',
                text: 'W tej chwili nie możemy przetworzyć Twojego zdjęcia. Spróbuj ponownie lub użyj innego zdjęcia',
            },
            notAnimal: {
                title: 'Nie ma tu zwierząt',
                text: 'Nasze algorytmy nie mogą rozpoznać zwierzęcia na Twoim zdjęciu. Proszę, spróbuj ponownie z innym zdjęciem',
                try: 'Spróbuj jeszcze raz',
                cancel: 'Anuluj',
            },
        },
    },
    mintEditPhoto: {
        title: 'Dostosuj swoje zwierzę',
        text: 'Podnieś tło dla swojego zwierzaka NFT',
        loading: 'Przygotowując swój obraz..',
    },
    mintNamePhoto: {
        title: 'Nadaj zwierzęciu imię',
        text: 'Twoje zwierzę zasługuje na najlepsze imię. Niech Twoje imię nie będzie dłuższe niż 20 znaków',
        inputLabel: 'Nazwa',
        placeHolder: 'np. Charlie',
        buttonNext: 'Przejdź do następnego kroku',
        infoText:
            'Nasze algorytmy są w stanie rozpoznać zwierzęta na zdjęciach z 99% prawdopodobieństwem',
        deleteNFTphoto: 'Usuń zdjęcie',
        deleteNFTphotoText:
            'Czy na pewno chcesz odejść? Twój postęp zostanie utracony',
        yesDelete: 'Tak, zabierz mnie z powrotem',
        noKeep: 'Nie, kontynuuj',
        errors: {
            startSpace: 'Spacja nie może być pierwszym znakiem nazwy',
            specialCharacters: 'Nazwa nie może zawierać znaków specjalnych',
            latinCharacters: 'Nazwa może zawierać tylko znaki od A do Z',
            numbers: 'Nazwa nie może zawierać cyfr',
            doubleSpaces: 'Nazwa nie może zawierać podwójnych spacji',
            maxLength: 'Nazwa nie może być dłuższa niż 20 znaków',
            minLength: 'Nazwa nie może być krótsza niż 2 symbole',
            mint: {
                title: 'Nie udało się zmonetyzować NFT',
                petRankWrongState: 'Ten rank nie jest dostępny dla mintu',
                obscenePetName:
                    'Imię zwierzaka nie może zawierać brzydkich słów. Twoje konto może zostać zbanowane',
            },
        },
    },
    mintCheckout: {
        transaction: 'NFT jako',
        rank: 'Ranga',
        nftCustomization: 'NFT',
        successTitle: 'Stworzenie nowego zwierzaka NFT',
        successText:
            'Stajesz się dumnym właścicielem nowego zwierzaka. Pamiętaj, aby dobrze się nim opiekować!',
        backToPlaying: 'Zacznij grać',
        backToCollection: 'Zobacz kolekcję',
    },
    wallet: {
        screenTitle: 'Portfel',
        loading: 'Ładowanie portfela..',
        emptyTitle: 'Nie można załadować portfela',
        emptyText: 'Błąd podczas ładowania portfela',
        total: 'Razem',
        deposit: 'Wpłać',
        withdraw: 'Wypłać',
        trade: 'Wymiana',
        balances: 'Balans',
        exchanges: 'Giełdy',
        exchangesInfo: 'Możesz kupić nasze tokeny na jednej z poniższych giełd',
        available: 'Dostępne:',
        view: 'Zobacz',
        depositTo: 'Wpłata na',
        depositBEP: 'Wpłata {{coin}} (BEP-20)',
        testnet: 'Testnet',
        testnetWarning:
            'Aplikacja działa obecnie w sieci Testnet, nie należy wpłacać tu prawdziwych tokenów',
        howToPurchaseBNB: 'Jak kupić BNB',
        howToPurchaseIGU: 'Jak kupić IGU',
        warning:
            'Upewnij się, że wpłacasz swoje tokeny na właściwy adres i do właściwej sieci (BEP-20)',
        withdrawFrom: 'Wypłacić',
        transactionHistory: 'Historia transakcji',
        viewOnBscScan: 'Sprawdź na BscScan',
        noTransactionYet: 'Nie ma jeszcze transakcji',
        noTransactionYetInfo: 'Nie dokonałeś jeszcze żadnej transakcji',
        transactionDetails: 'Szczegóły transakcji',
        amount: 'Kwota',
        type: 'Typ',
        date: 'Data',
        fromAddress: 'Z adresu',
        toAddress: 'Na adres',
        blockChainFee: 'Prowizja sieci',
        loadingWithdraw: 'Wykonujemy transakcję..',
        transactions: {
            coin: {
                DEPOSIT: {
                    name: 'Depozyt',
                    text: 'Kryptowaluta została wpłacona do Twojego portfela. Zobacz historię transakcji, aby uzyskać więcej szczegółów',
                },
                WITHDRAW: {
                    name: 'Wypłata',
                    text: 'Kryptowaluta wypłacona z Twojego portfela. Prosimy o kontakt z platformą odbiorczą w celu uzyskania potwierdzenia transakcji',
                },
                SWAP: {
                    name: 'Wymiana',
                    text: 'Kryptowaluta została zamieniona na inną kryptowalutę za pomocą wbudowanego DEX.',
                },
                CLAIM: {
                    name: 'Claim',
                    text: 'Nagroda odebrana i przekazana na saldo portfela',
                },
                NFT_PAYMENT: {
                    name: 'Płatność NFT',
                    text: 'Kryptowaluta została użyta do zapłaty w aplikacji za mint, leczenie lub aktualizację. Zobacz historię transakcji, aby uzyskać więcej szczegółów',
                },
                UNKNOWN: {
                    name: 'Inne',
                    text: 'Każda inna transakcja sieciowa, w tym zatwierdzenie, opłata itp. Zobacz historię transakcji, aby uzyskać więcej szczegółów',
                },
                CONFIRMED: { title: 'Zakończono' },
                FAILED: {
                    title: 'Nie udało się',
                    text: 'Z powodu problemów z siecią nie mogliśmy przetworzyć Twojej transakcji',
                },
                PENDING: {
                    title: 'W oczekiwaniu',
                    text: 'Transakcja nie jest jeszcze potwierdzona przez sieć. Zazwyczaj trwa to od 5 minut do 1 godziny',
                },
            },
            nft: {
                DEPOSIT: {
                    name: 'Wpłata',
                    text: 'NFT zostało wpłacone na Twój portfel. Zobacz historię transakcji, aby uzyskać więcej szczegółów',
                },
                WITHDRAW: {
                    name: 'Wypłata NFT',
                    text: 'NFT przekazane z IguVerse. Prosimy o kontakt z platformą odbiorczą w celu uzyskania potwierdzenia transakcji',
                },
                MINT: {
                    name: 'Mint',
                    text: 'NFT zostało zmintowane w aplikacji IguVerse',
                },
                CONFIRMED: { title: 'Zakończono' },
                FAILED: {
                    title: 'Nie udało się',
                    text: 'Z powodu prac technicznych w sieci, nie mogliśmy przetworzyć Twojej transakcji',
                },
                PENDING: {
                    title: 'W oczekiwaniu na',
                    text: 'Transakcja nie jest jeszcze potwierdzona przez sieć. Zazwyczaj trwa to od 5 minut do 1 godziny',
                },
            },
            reward: {
                GameIterationReward: {
                    title: 'Zadania',
                    text: 'Zadania zablokowane nagroda za wykonanie codziennych zadań',
                },
                ReferralReward: {
                    title: 'Polecania',
                    text: 'Nagroda za polecenie innych działań w aplikacji użytkownika',
                },
                Claim: {
                    title: 'Claim',
                    text: 'Transakcja Claim zamienia dostępne wirtualne nagrody VIGUP na portfel główny IGUP',
                },
                PetLevelUpPayment: {
                    title: 'Level Up',
                    text: 'Płatność wewnętrzna za levelowanie zwierzaka',
                },
                PetRankUpPayment: {
                    title: 'Rank Up',
                    text: 'Wewnętrzna zapłata za uszeregowanie zwierzaka',
                },
                PetRevivePayment: {
                    title: 'Restore',
                    text: 'Płatność wewnętrzna za przywrócenie zwierzęcia do życia',
                },
                PetHealUpPayment: {
                    title: 'Leczenie',
                    text: 'Wewnętrzna zapłata za uzdrowienie zwierzęcia',
                },
                MintBonus: {
                    title: 'Bonus za mint',
                    text: 'Bonusowa nagroda za NFT Mint',
                },
                CharityDonation: {
                    title: 'Dotacja',
                    text: 'Dotacja na rzecz wybranej przez Ciebie organizacji charytatywnej',
                },
                GameIterationRewardSubtransaction: {
                    title: 'Zadania',
                    text: 'Zablokowane nagroda za wykonanie codziennych zadań',
                },
                CONFIRMED: { title: 'Zakończono' },
                PENDING: {
                    title: 'W oczekiwaniu',
                    text: 'Transakcja claim została wystawiona, jednak nie została zakończona. Musisz zakończyć tę transakcję, zanim będziesz mógł złożyć nową',
                },
                UNLOCK: {
                    title: 'Zablokowane nagrody',
                    text: 'Nagrody te są w trakcie realizacji i zostaną odblokowane i będą dostępne dla Claim zgodnie z harmonogramem odblokowania.',
                    locked: '{{amount}} {{coin}} są zablokowane',
                },
                unlockTransactions: { title: 'Transakcje odblokowane' },
                UNKNOWN: { name: 'Inne', text: 'Inny rodzaj transakcji' },
                GameRewardStakeBonus: {
                    title: 'Bonus Booster',
                    text: 'Zamrożone bonusy za booster',
                },
                GameRewardStakeBonusSubtransaction: {
                    title: 'Bonus Booster',
                    text: 'Zamrożone bonusy za booster',
                },
            },
        },
        nft: {
            nft: 'NFT',
            tokenId: 'Identyfikator tokena',
            myCollection: 'Kolekcje',
            tooltip: 'Tutaj możesz obejrzeć swoje kolekcje NFT',
            noNFTYet: 'Żadnych przedmiotów kolekcjonerskich',
            noNFTYetInfo: 'Pusta lista',
            mintNewNft: 'Zmintuj NFT',
            NFTs: '{{balance}} NFT',
            noNFTs: 'N/A',
            deposit: 'Depozyt NFT',
            viewAll: 'Zobacz wszystkie',
            allNFTs: 'Wszystkie NFT',
            withdraw: 'Wypłać NFT',
            withdrawNftLabelAddress: 'Adres',
            withdrawNftPlaceholderAddress: 'Podaj adres',
            withdrawNftTitle: 'Wypłata NFT',
            blockchainFee: 'Prowizja sieci',
            confirmButtonLabel: 'Potwierdź wypłatę',
            confirmModal: {
                title: 'Potwierdzenie wypłaty NFT',
                nftName: 'NFT',
                addressFrom: 'Z (Portfela)',
                addressTo: 'Na adres',
                send: 'Potwierdź',
                cancel: 'Anuluj',
            },
            withdrawSuccess: {
                title: 'Wypłata NFT jest przetwarzana',
                text: 'NFT {{name}} został pomyślnie wycofany. Zazwyczaj trwa to od 5 minut do 1 godziny',
                addressFrom: 'Od (Portfel)',
                addressTo: 'Na adres',
                backToWallet: 'Powrót do portfela',
            },
            transactionNft: 'Wypłata NFT',
            withdrawWarningText:
                'Upewnij się, że wypłacasz swoje tokeny na właściwy adres i do właściwej sieci (BEP-20). Jeśli wyślesz swoje NFT do innej sieci lub portfela giełdowego, możesz je trwale stracić',
            transactionHistory: 'Historia transakcji',
            noTransactionYet: 'Nie ma jeszcze transakcji',
            noTransactionYetInfo:
                'Nie dokonałeś jeszcze żadnej transakcji. Ale to nie problem, zrób to teraz',
        },
        rewards: {
            tooltipText:
                'Przycisk Claim umożliwia konwersję wirtualnych tokenów nagród na token IGUP. Przycisk będzie dostępny, gdy będziesz mieć nagrody do wypłacenia',
            claimButton: 'Claim',
            reclaimButton: 'Ponów Claim',
            stakeButton: 'Boost',
            rewardsWallet: 'Portfel nagród',
            mainWallet: 'Główny portfel',
            transactionHistoryText: 'Historia transakcji',
            rewardsCarousel: {
                availableRewards: 'Dostępne nagrody',
                availableRewards_text:
                    'Nagrody dostępne do wymiany na tokeny IGUP',
                lockedRewards: 'Zablokowane nagrody',
                lockedRewards_text: 'Nagrody będą dostępne z upływem czasu',
                pendingRewards: 'Nagrody w trakcie Claima',
                pendingRewards_text: 'Zakończ swoją transakcję Claim',
                claimReward: 'Odbierz nagrodę',
            },
            transactionHistory: {
                Claim: 'Odebrana nagroda',
                GameIterationReward: 'Nagroda za zadanie',
                ReferralReward: 'Nagroda za polecenie',
                PetLevelUpPayment: 'Level up',
                PetRankUpPayment: 'Rank Up',
                PetRevivePayment: 'Revive',
                PetHealUpPayment: 'Uzdrawianie zwierząt',
                MintBonus: 'Bonus za mint',
                CharityDonation: 'Dotacja',
                GameIterationRewardSubtransaction: 'Zablokowane',
                GameRewardStakeBonus: 'Bonus za Booster',
                GameRewardStakeBonusSubtransaction: 'Zablokowane',
            },
            filter: {
                title: 'Sortowanie',
                ALL: 'Wszystkie',
                Claim: 'Claim',
                GameIterationReward: 'Zadania',
                ReferralReward: 'Polecenia',
                MintBonus: 'Mint Bonus',
                GameRewardStakeBonus: 'Bonus za Booster',
            },
            empty: {
                title: 'Nie ma jeszcze transakcji',
                text: 'Nie martw się i bądź na bieżąco. Kiedy otrzymasz nagrody, będą one wyświetlane tutaj',
                button: 'Odśwież',
            },
            confirmationModal: {
                title: 'Potwierdzenie Claima',
                keys: {
                    from: 'Ze adresu',
                    to: 'Na (Portfelu)',
                    fee: 'Prowizja sieci',
                    total: 'Podsumowanie',
                },
                values: {
                    rewardsWallet: 'Portfel nagród',
                    mainWallet: 'Portfel IGUP',
                },
                warning:
                    'Upewnij się, że masz wystarczającą ilość środków w BNB na pokrycie opłaty transakcyjnej',
            },
            claimSuccess: {
                title: 'Claim jest w trakcie',
                text: 'Zainicjowałeś nową transakcję Claim z portfela nagród. Zazwyczaj proces trwa to od 5 minut do 1 godziny',
                backToWallet: 'Powrót do portfela',
            },
            claimLoading: 'Wykonuje się claim, nie zamykaj aplikacji..',
            claimBusy:
                'Sieć jest obecnie przeciązona, proszę spróbować ponownie po jakimś czasie',
        },
        gaming: {
            gamingWalletChangeFeatureText:
                'Jest to przybliżony stosunek wymiany z IGU na VIGU',
            gamingWalletCarousel: {
                AvailableWallet: {
                    title: 'Dostępny portfel',
                    text: 'Aby wziąć udział w grze, dodaj żetony IGU',
                },
                PendingWallet: {
                    title: 'Portfel na czekanie',
                    text: 'Żetony zostaną zamrożone do czasu zakończenia gry',
                },
            },
            gamingWalletButtons: {
                topUp: 'Uzupełnij',
                withdraw: 'Wypłać',
            },
            TopUpGamingWalletScreen: {
                screenTitle: 'Uzupełnij',
                title: 'Doładuj portfel gier',
                text: 'Aby wziąć udział, doładuj swój portfel gier za pomocą IGU i otrzymaj VIGU',
                infoText: 'Jak to działa',
                button: 'Opłać',
                inputSection: {
                    infoText: 'Wpisz lub wybierz ilość, którą chcesz kupić',
                    errors: {
                        digits: 'Muszą być tylko cyfry',
                        min: 'Kwota musi wynosić co najmniej {{limit}} {{coin}}',
                        max: 'Kwota musi wynosić maksymalnie {{limit}} {{coin}}',
                    },
                },
                howToModal: {
                    title: 'Doładuj portfel gier',
                    text: 'Aby wziąć udział, doładuj swój portfel gier za pomocą IGU i otrzymaj VIGU. Użyj poniższego przycisku, aby doładować tokeny',
                },
            },
            SelectWithdrawTokenModal: {
                title: 'Wybierz token do wypłaty',
                text: 'W głównym portfelu możesz wybrać token, w którym otrzymasz swoje nagrody',
                button: 'Wybrać',
            },
            TopUpSuccessScreen: {
                title: 'Udane doładowanie',
                text: 'Pomyślnie uzupełniłeś swój portfel w grze żetonami. Dołącz teraz do gry!',
                button: 'Poznaj gry',
                button2: 'Wyświetlanie historii transakcji',
                buttonBack: 'Powrót do gry',
            },
            transactionHistory: {
                filter: {
                    title: 'Sortuj według',
                    [IGU_WALLET_TRANSACTIONS.All]: 'Wszystkie',
                    [IGU_WALLET_TRANSACTIONS.Deposit]: 'Uzupełnij',
                    [IGU_WALLET_TRANSACTIONS.Withdraw]: 'Wypłać',
                    [IGU_WALLET_TRANSACTIONS.RevertWithdraw]:
                        'Odzyskać Wypłacić',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGamePayment]:
                        'Płatność',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameRefund]: 'Wygasła',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDraw]: 'Remis',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameWin]: 'Wygrana',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameFee]: 'Wypłata',
                    [IGU_WALLET_TRANSACTIONS.DepositBonus]:
                        'Premia za uzupełnienia',
                },
                transactions: {
                    [IGU_WALLET_TRANSACTIONS.Deposit]: {
                        title: 'Uzupełnij',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.Withdraw]: {
                        title: 'Wypłać',
                        text: 'Kryptowaluty są przenoszone z Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.RevertWithdraw]: {
                        title: 'Odzyskać Wypłacić',
                        text: 'Kryptowaluty są przenoszone z Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDraw]: {
                        title: 'The Mystery Of Likes Remis',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGamePayment]: {
                        title: 'The Mystery Of Likes Płatność',
                        text: 'Kryptowaluty są przenoszone z Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameRefund]: {
                        title: 'The Mystery Of Likes Wygasła',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameWin]: {
                        title: 'The Mystery Of Likes Wygrana',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.DepositBonus]: {
                        title: 'Premia za uzupełnienia',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.DirectReferralDepositBonus]: {
                        title: 'Premia za uzupełnienia (Bezpośredni)',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.IndirectReferralDepositBonus]: {
                        title: 'Premia za uzupełnienia (Pośrednie)',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameFee]: {
                        title: 'The Mystery Of Likes Wypłata',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDirectReferralBonus]:
                        {
                            title: 'Opłaty za skierowanie (Bezpośredni)',
                            text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                        },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameIndirectReferralBonus]:
                        {
                            title: 'Opłaty za skierowanie (Pośrednie)',
                            text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                        },
                    [IGU_WALLET_TRANSACTIONS.Breeding]: {
                        title: 'NFT Evolution Mint',
                        text: 'Kryptowaluty są przenoszone z Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.GamesTurnoverReward]: {
                        title: 'PVP Bonus',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },

                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameDraw]: {
                        title: 'The Grand Race - Remis',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGamePayment]: {
                        title: 'The Grand Race - Płatność',
                        text: 'Kryptowaluty są przenoszone z Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameRefund]: {
                        title: 'The Grand Race - Wygasła',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameWin]: {
                        title: 'The Grand Race - Wygrana',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameFee]: {
                        title: 'The Grand Race - Wypłata',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.LuckyStrikeGameWin]: {
                        title: 'Lucky Strike - Wygrana',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.LuckyStrikeGamePayment]: {
                        title: 'Lucky Strike - Bilet',
                        text: 'Kryptowaluty są przenoszone z Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.QuantumSpinReward]: {
                        title: 'Quantum Disk - Nagroda',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.QuantumSpin]: {
                        title: 'Quantum Disk - Płatność',
                        text: 'Kryptowaluty są przenoszone z Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictWin]: {
                        title: 'Tokenteller - Nagroda',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredict]: {
                        title: 'Tokenteller - Płatność',
                        text: 'Kryptowaluty są przenoszone z Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictFee]: {
                        title: 'Tokenteller - Wypłata',
                        text: 'Kryptowaluty są przenoszone z Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictRefund]: {
                        title: 'Tokenteller - Remis',
                        text: 'Kryptowaluty przenoszą się do Gaming Wallet. Sprawdź więcej szczegółów na bscscan',
                    },
                },
            },
        },

        stakingBanner: {
            title: 'Zwiększ nagrody i zdobądź za to bonusy!',
            text: 'Boost za IGUP jest już dostępny w zakładce "Nagrody"!',
            button: 'Włącz boost',
        },
    },
    trade: {
        poweredBy: 'Powered By',
        from: 'Z',
        to: 'Do',
        estimate: ' (Szacunkowo)',
        enterAmount: 'Wpisz kwotę',
        available: 'Max',
        selectToken: 'Wybierz token',
        deposit: 'Depozyt',
        trade: 'Handel',
        rate: 'Kurs wymiany',
        confirmTrade: 'Potwierdź wymianę',
        cancel: 'Anuluj',
        settings: 'Ustawienia',
        settingTitle: 'Tolerancja poślizgu',
        slippageMainText:
            'Twoja transakcja zostanie cofnięta, jeśli cena zmieni się niekorzystnie o więcej niż procent poniżej',
        save: 'Zapisz',
        percentFour: 'Wprowadź %',
        inputWarning:
            'Tolerancja Poślizgu musi zawierać się w przedziale od {{minAmount}}% do {{maxAmount}}%. Proszę wprowadzić inną wartość procentową',
        checkout: { estimate: 'Płacisz', to: 'Otrzymujesz' },
        processingTrade: 'Wymiana w trakcie..',
        calculatingTrade: 'Obliczanie..',
        button: 'Handluj',
        errors: {
            isRequired: 'Wymagana jest wartość.',
            maxAmountError:
                'Za mało tokenów na saldzie. Wprowadź inną kwotę lub wpłatę',
            minLimit:
                'Kwota zamiany musi wynosić co najmniej {{limit}} {{coin}}',
            bnbNotEnough:
                'Za mało BNB na Twoim saldzie, aby pokryć prowizję. Proszę wprowadzić inną kwotę lub wpłacić BNB',
            transaction: 'Transakcja nie powiodła się',
            DS_MATH_SUB_UNDERFLOW:
                'Ilość tokenów jest zbyt duża, spróbuj wprowadzić inną ilość',
        },
        tradeSuccess: {
            title: 'Wymiana zakończona',
            text: 'Gratulacje! Udało Ci się wymienić tokeny. Twoje tokeny są dostępne na Twoim saldzie. Zobacz więcej w historii transakcji',
            backToWallet: 'Powrót do portfela',
            from: 'Ze strony',
            to: 'Do',
            estimate: '(Szacunkowo)',
            blockchainFee: 'Blockchain Opłata',
            totalSummary: 'Podsumowanie ogółem',
            back: 'Kontynuuj handel',
        },
    },
    tradingView: {
        title: 'Wykres',
        back: 'Wstecz',
    },
    walletSettings: {
        title: 'Ustawienia portfela',
        header: 'Ustawienia bezpieczeństwa',
        description:
            'Obacz swój seed-phrase i klucz prywatny, a także zarządzaj kodem dostępu tutaj',
        backup: {
            title: 'Seed-phrase',
            description:
                'Nigdy nie pokazuj nikomu swój seed-phrase! To kontroluje wszystkie twoje fundusze',
            modal: {
                title: 'Fraza / klucz do odzyskiwania portfela',
                text: 'Upewnij się, że nikt nie może zobaczyć Twoich tajnych danych. Ujawniając je komukolwiek ryzykujesz utratę swoich środków',
                yes: 'Zobacz',
                no: 'Powrót',
                alert: 'Zespół IguVerse nigdy nie zapyta Cię o twoją frazę seed lub klucz prywatny. Jeśli ktoś cię zapyta to na 100% jest to scammer, bądź ostrożny!',
                checkbox:
                    'Potwierdzam, że rozumiem ryzyko, jeśli podzielę się z kimś frazą seed lub kluczem prywatnym moje tokeny i pety mogą być skradzione',
            },
        },
        passcode: {
            title: 'Hasło i biometria',
            description:
                'Ustawienie lub zmiana hasła/włączenie identyfikacji biometrycznej',
        },
    },
    passcode: {
        passcode: 'Hasło',
        modal: {
            title: 'Włącz hasło',
            subTitle:
                'Czterocyfrowy kod zwiększy Twoje bezpieczeństwo i będzie służył do potwierdzania ważnych działań',
        },
        welcome: {
            title: 'Włącz hasło',
            subTitle:
                'Wprowadź hasło, którego będziesz używać do uzyskiwania dostępu do aplikacji i potwierdzania ważnych działań',
        },
        new: {
            title: 'Włącz hasło',
            subTitle:
                'Wprowadź hasło, którego będziesz używać do uzyskiwania dostępu do aplikacji i potwierdzania ważnych działań',
        },
        confirm: {
            title: 'Potwierdź hasło',
            subTitle:
                'Wprowadź hasło, którego będziesz używać do uzyskiwania dostępu do aplikacji i potwierdzania ważnych działań',
            error: 'Nieprawidłowy kod. Wprowadź ten sam kod, co w poprzednim kroku',
        },
        check: {
            title: 'Wpisz kod dostępu',
            subTitle: 'Wprowadź aktualny kod dostępu, aby potwierdzić',
            error: 'Nieprawidłowy kod. Spróbuj ponownie lub użyj identyfikacji biometrycznej',
        },
        success: {
            title: 'Twoje konto jest chronione!',
            subTitle:
                'Teraz Twoje konto i portfel IguVerse są chronione przed złośliwymi działaniami. Zawsze możesz zmienić hasło w Ustawieniach',
        },
        change: {
            title: 'Zmień kod dostępu',
            subTitle:
                'Wprowadź nowe hasło, które będzie używane do potwierdzania ważnych działań',
        },
        faceId: {
            title: 'Włącz identyfikację biometryczną',
            subTitle:
                'Potwierdź ważne działania w prostszy i szybszy sposób. Twoje dane biometryczne nie są gromadzone przez IguVerse',
        },
        settings: {
            turnOff: 'Wyłączyć kod dostępu',
            biometric: {
                title: 'Identyfikacja biometryczna',
                subTitle:
                    'Użyj Face ID lub odcisku palca, aby potwierdzić ważne działania w aplikacji',
            },
        },
        modalRemove: {
            title: 'Wyłączyć kod dostępu?',
            subTitle:
                'Wszystkie Twoje dane są bezpiecznie przechowywane dzięki kodowi dostępu. W każdej chwili możesz go ponownie ustawić w ustawieniach',
        },
        toasts: {
            turnOff: 'Sukces! Kod dostępu wyłączony!',
            biometricOff: 'Sukces! Kod biometryczny wyłączony!',
            biometricOn: 'Sukces! Biometryczny włączony!',
            change: 'Sukces! Kod dostępu zmieniony!',
            biometricError: 'Błąd! Spróbuj ponownie!',
        },
    },
    walletSettingsBackup: {
        mnemonic: {
            title: 'Twoja fraza seed',
            text: 'Proszę zapisać te 12 słów na kartce papieru. Przy zapisywaniu pamiętaj o ich kolejności. Przechowuj je w bezpiecznym miejscu.',
            reveal: 'Przytrzymaj, aby ujawnić frazę',
        },
        privateKey: {
            title: 'Twój klucz prywatny',
            text: 'Klucz prywatny to losowo wygenerowany numer, który daje użytkownikowi kontrolę nad wszystkimi środkami powiązanymi z portfelem. Zachowaj to w tajemnicy',
            reveal: 'Przytrzymaj, aby ujawnić klucz prywatny',
        },
        privateKeyModal: {
            title: 'Klucz prywatny',
            text: 'Zapisz swój klucz prywatny. Przechowuj go w bezpiecznym miejscu',
        },
        buttons: { hidden: 'Przytrzymaj by zobaczyć', visible: 'Ukryj' },
        viewPrivateKey: 'Zobacz swój klucz prywatny',
        emptyTitle: 'Błąd',
        emptyText: 'Nie można załadować portfela',
    },
    withdrawScreen: {
        title: 'Wypłata',
        labelAddress: 'Adres',
        labelAmount: 'Kwota',
        placeholderAddress: 'Podaj adres',
        placeholderAmount: 'Wpisz kwotę',
        labelAvailable: 'Dostępne',
        allButtonLabel: 'Max',
        confirmButtonLabel: 'Potwierdzenie transakcji',
        depositButtonLabel: 'Wpłać',
        depositBEP: 'Wpłać {{coin}} (BEP-20)',
        blockchainFee: 'Prowizja sieci',
        totalSummary: 'Podsumowanie',
        errors: {
            address: 'Adres nie może być pusty',
            amountRequired: 'Kwota nie może być pusta',
            invalidAddress: 'Nieważny adres portfela',
            sameWallet: 'Nie można wypłacić na własny portfel',
            digits: 'Muszą być tylko cyfry',
            maxAmountError:
                'Za mało tokenów na saldzie. Wprowadź inną kwotę lub wpłatę',
            minLimit: 'Wypłata musi wynosić co najmniej {{limit}} {{coin}}',
            bnbNotEnough:
                'Za mało BNB na Twoim saldzie, aby pokryć prowizję sieci. Proszę wprowadzić inną kwotę lub wpłacić BNB',
        },
        withdrawWarningText:
            'Upewnij się, że wypłacasz swoje tokeny na właściwy adres i do właściwej sieci (BEP-20)',
        withdrawWarningTextNFT:
            'Jeśli wyślesz swoje NFT do innej sieci lub portfela giełdowego, możesz je trwale utracić',
        transaction: 'Wycofanie się z umowy',
        withdrawSuccess: {
            title: 'Wypłata tokenów zlecona',
            text: 'Zainicjowałeś nową wypłatę z portfela. Zazwyczaj trwa to od 5 minut do 1 godziny',
            backToWallet: 'Powrót do portfela',
            viewTransactionHistory: 'Wyświetlanie historii transakcji',
        },
    },
    ModalConfirmTransaction: {
        title: 'Potwierdzenie transakcji',
        confirm: 'Potwierdź',
        cancel: 'Anuluj',
    },
    ModalCoinSelect: { select: 'Wybierz token' },
    ModalCropImage: {
        title: 'Kadrowanie obrazu',
        crop: 'Wytnij i kontynuj',
    },
    qrCodeScanner: {
        openSettings: 'Ustawienia',
        noAccessToCamera: 'Brak dostępu do kamery',
        title: 'Umieść QR-Code w ramce',
        wallet: {
            titleScanned: 'Adres zeskanowany',
            text: 'Zeskanuj kod QR adresu tokena. Upewnij się, że wszystkie szczegóły są widoczne',
        },
        referral: {
            titleScanned: 'Zeskanowany kod polecający',
            text: 'Zeskanuj QR-kod kodu polecającego. Upewnij się, że wszystkie szczegóły są widoczne',
        },
        verify: {
            titleScanned: 'Sprawdź, czy kod został zeskanowany',
            text: 'Zeskanuj QR-kod z Pet ID. Upewnij się, że wszystkie szczegóły są widoczne',
        },
    },
    nftSelectGeneration: {
        continue: 'Kontynuuj',
        search: 'Szukaj',
        pageTitle: 'Stwórz swojego zwierzaka NFT',
        pageInfo: 'Możesz wybrać sposób, w jaki zostanie utworzony Twój NFT',
        nftFromPhoto: 'NFT ze zdjęcia',
        nftFromPhotoText:
            'Stwórz piękne NFT z własnego zdjęcia zwierzęcia. Wybierz jedno z naszych wspaniałych teł dla swojego przyszłego towarzysza',
        nftFromImagination: 'NFT z Twojej wyobraźni',
        nftFromImaginationText:
            'Nasze algorytmy AI / ML mogą narysować Twojego wirtualnego zwierzaka dokładnie tak, jak sobie to wyobrażasz. Opisz cechy swojego zwierzaka i ciesz się wynikiem',
        provideMoreInformation: 'Opisz swojego wymarzonego zwierzaka',
        provideMoreInformationInfo:
            'Wybierz jedną z proponowanych poniżej opcji, aby stworzony NFT był idealnie dopasowany do tego, co sobie wyobrażasz',
        selectAccessories: 'Wybierz akcesoria',
        maximumAccessories: 'Można wybrać maksymalnie {{num}} akcesoriów',
        selectGeneratedNFT: 'Wybierz swoje zwierzę',
        selectGeneratedNFTInfo:
            'Stworzyliśmy kilka unikalnych zwierzaków zgodnie z Waszą prośbą. Wybierz tego, który najbardziej Ci się podoba',
        continueNextStep: 'Przejdź do następnego kroku',
        generateNewNFT: 'Jeszcze raz',
        generateNFTButton: 'Generowanie NFT',
        loadingModalText: 'Ładowanie..',
        randomize: 'Randomizuj',
        clear: 'Wyczyść',
        select: 'Wybierz',
        noResult: 'Brak wyników',
        noResultText:
            'Nie znaleziono żadnych wyników dla "{{query}}". Wprowadź inne słowa kluczowe do wyszukiwania',
        form: {
            animal: {
                label: 'Zwierzę',
                placeHolder: 'Wybierz zwierzę',
                modalTitle: 'Wybierz zwierzę',
            },
            'drawing-type': {
                label: 'Rodzaj rysunku',
                placeHolder: 'Wybierz rodzaj rysunku',
                modalTitle: 'Wybierz rodzaj rysunku',
            },
            cat: {
                label: 'Rasa kotów',
                placeHolder: 'Wybierz rasę kota',
                modalTitle: 'Wybierz rasę kota',
            },
            dog: {
                label: 'Rasa psów',
                placeHolder: 'Wybierz rasę psa',
                modalTitle: 'Wybierz rasę psa',
            },
            'maturity-size': {
                label: 'Dojrzałość / wielkość',
                placeHolder: 'Wybierz dojrzałość lub rozmiar',
                modalTitle: 'Wybierz dojrzałość lub wielkość',
            },
            color: {
                label: 'Kolor',
                placeHolder: 'Wybierz kolor',
                modalTitle: 'Wybierz kolor',
            },
            emotion: {
                label: 'Emocje',
                placeHolder: 'Wybierz emocję',
                modalTitle: 'Wybierz Emocje',
            },
            accessories: {
                label: 'Akcesoria',
                placeHolder: 'Wybierz akcesoria',
                modalTitle: 'Wybierz akcesoria',
            },
            context: {
                label: 'Kontekst',
                placeHolder: 'Wybierz kontekst',
                modalTitle: 'Wybierz kontekst',
            },
            style: {
                label: 'Styl',
                placeHolder: 'Wybierz styl',
                modalTitle: 'Wybierz styl',
            },
        },
        errors: {
            maintenance: {
                title: 'Nasze modele AI są przeciążone',
                text: 'Niestety nasze modele AI nie mogły w tej chwili obsłużyć Twojego zapytania. Proszę spróbować ponownie',
            },
        },
    },
    bottomNavigation: {
        play: 'Otwórz',
        charity: 'Charytatywnie',
        statistics: 'Statystyki',
        collection: 'Kolekcja',
        marketplace: 'Rynek',
    },
    playScreen: {
        timeToComplete: 'Runda gry kończy się w',
        startPlaying: 'Zacznij grać',
        howToPlay: 'Jak grać?',
        nftToPlay: 'Twoje zwierzęta',
        edit: 'Edytuj',
        nftToPlayInfo:
            'Wybierz swoje zwierzaki, które będą uczestniczyć w grze i zdobywać nagrody',
        nftToPlayHint:
            'Kolejność Twoich zwierzaków ma znaczenie. Pierwszy zwierzak będzie zwierzakiem widocznym w Twoim Pet ID w grze dzielenia. Pierwszy zwierzak otrzyma również najwięcej doświadczenia za wykonanie zadań',
        noNFTyet: 'Nikt tu nie mieszka',
        noNFTyetInfo:
            'Niestety, nie masz jeszcze zwierzęcego towarzysza. Zdobądź swojego pierwszego zwierzaka i zacznij grać',
        exploreShop: 'Poznaj sklep',
        mintNew: 'Zdobądź swoje pierwsze zwierzę',
        dailyTasks: 'Zadania codzienne',
        dailyTasksInfo:
            'Wykonuj codzienne zadania, aby zdobyć energię, która może być wymieniona na tokeny',
        timeLeftToComplete: 'Runda gry kończy się w',
        selectNFT: 'Dodaj więcej zwierząt',
        playCards: {
            SHARE_title: 'Podziel się swoim zwierzakiem',
            SHARE_info:
                'Twoje zwierzaki potrzebują codziennej uwagi. Podziel się tym w mediach społecznościowych',
            SHARE_button: 'Otwórz zadanie społeczne',
            addSocialAccount: 'Dodaj konto społecznościowe',
            socialAlert:
                'Weryfikacja zadania społecznego może trwać do 12 godzin, ukończenie go później może skutkować przyznaniem Energii w kolejnej iteracji gry',
            MOVE_title: 'Przejdź się ze swoim zwierzakiem',
            MOVE_info:
                'Twoje zwierzęta potrzebują codziennego spaceru. Spaceruj ze swoimi zwierzętami',
            MOVE_button: 'Zacząć spacer',
            PLAY_title: 'Graj ze swoimi zwierzakami',
            PLAY_info: 'Graj ze swoimi zwierzakami w mini-grę',
            PLAY_button: 'Graj w grę',
            VERIFY_title: 'Znajdź inne zwierzęta',
            VERIFY_info:
                'Znajdź zwierzaki innych użytkowników w mediach społecznościowych',
            VERIFY_button1: 'Kontynuuj zadanie',
            VERIFY_button2: 'Znajdź inne zwierzęta',
            completedEnergy:
                '{{energyRewarded}} / {{maxEnergyReward}} Zebrana energia',
            SHARE_failed_title: 'Twój post nie został zweryfikowany',
            SHARE_failed_text:
                'Podczas weryfikacji Twojego postu, innym użytkownikom nie udało się znaleźć lub zobaczyć Twojego Pet ID. Niestety, nie otrzymasz dzisiaj żadnej energii z tego zadania. Proszę, postaraj się być bardziej uważny następnym razem',
            SHARE_failed_button: 'Powrót do gry',
            knowledgeBase: 'Zobacz bazę wiedzy',
            SHARE_failed_reasons: {
                notEnoughFollowers:
                    'Wygląda na to, że Twoje konto nie jest wystarczająco aktywne. Proszę, wybierz inne konto lub spróbuj rozwinąć to',
                petIdNotFound:
                    'Inni użytkownicy powiedzieli, że nie mogą znaleźć Pet ID zamieszczonego na Twoim koncie. Proszę, nie zapomnij zamieścić następnym razem',
                petIdIncorrectPosition:
                    'Twój Pet ID jest umieszczony w taki sposób, że inni użytkownicy nie mogą go odczytać. Postaraj się być bardziej ostrożny następnym razem',
                userNotFound:
                    'Zarówno użytkownicy jak i administratorzy nie mogli znaleźć Twojego konta. Czy coś się z nim stało?',
            },
            SHARE_success_title: 'Udostępnianie udane',
            SHARE_success_text:
                'Gratulacje! Udostępniłeś zdjęcie i przeszło ono weryfikację. Wróć jutro po więcej',
            SHARE_success_button: 'Zobacz szczegóły',
        },
        modalAllDead: {
            title: 'Twoje zwierzęta nie żyją',
            text: 'Nie możesz wykonywać zadań, dopóki przynajmniej jeden z Twoich zwierzaków nie będzie w dobrej formie. Odbuduj swoje zwierzęta i wróć',
            button: 'Przywróć swoich zwierzaków',
        },
        modalSomeDead: {
            title: 'Niektóre z twoich zwierzaków umarły',
            text: 'Niektóre z twoich zwierząt nie żyją i nie będą zdobywać nagród. Czy na pewno chcesz kontynuować?',
            button: 'Przywróć swoich zwierzaków',
            button2: 'Kontynuuj grę',
        },
    },
    collectionsScreen: {
        title: 'Moja kolekcja',
        text: 'To jest dom dla twoich zwierzaków',
        mintNewNft: 'Zdobądź swoje pierwsze zwierzę',
        mintPet: 'Stwórz zwierzaka',
        noCollectionsYet: 'Nikogo tu nie ma',
        noCollectionsYetInfo:
            'Niestety, nie masz jeszcze zwierzęcego towarzysza. Jak można żyć bez zwierzaka?',
        levelUp: 'Podnieś Level',
        rankUp: 'Podnieś Rangę',
        restore: 'Przywróć',
        feed: 'Nakarmij',
        healAllButtonTooltip:
            'Możesz użyć masowego leczenia zwierząt domowych tylko wtedy, gdy masz co najmniej 2 zwierzęta o zdrowiu niższym niż 100%',
    },
    detailedPet: {
        headerSubtitle:
            'To jest twój zwierzak NFT, możesz z jego pomocą wykonywać codzienne zadania i otrzymywać nagrody w postaci tokenów. Dbaj o niego',
        levelXP: {
            title: 'Poziom i XP',
            text: 'Zdobywaj XP za wykonanie zadań i zwiększaj poziom swojego zwierzaka. Po osiągnięciu pewnego poziomu zwierzak może uaktualnić do wyższej rangi',
            textUpgrade:
                'Zdobyłeś już całe doświadczenie na poziomie {{level}}. Podnieś swój NFT na nowy poziom, aby zarobić więcej żetonów',
            upgrade: 'Ulepszenie do poziomu {{level}}',
        },
        animalType: {
            title: 'Rodzaj zwierząt',
            text: 'Nasze algorytmy są w stanie rozpoznać zwierzęta na zdjęciach z dużym prawdopodobieństwem',
        },
        rank: {
            title: 'Ranga {{rank}}',
            text: 'Ranga jest jedną z głównych cech zwierzaka. Wyższe rangi dają więcej nagród i mają wyższy wskaźnik odblokowania nagród',
            upgrade: 'Aktualizacja do rangi "{{rank}}"',
            textUpgrade:
                'Osiągnąłeś wszystkie poziomy w randze "{{rank}}". Podnieś rangę, aby zarobić więcej tokenów',
        },

        age: {
            button: 'Przywróć zwierzaka',
            Baby: 'Dziecko = {{current}} / {{max}} dni',
            Young: 'Młody = {{current}} / {{max}} dni',
            Adult: 'Dorosły = {{current}} / {{max}} dni',
            Old: 'Stary = {{current}} / {{max}} dni',
            description:
                'Wiek twojego zwierzaka jest brany pod uwagę od momentu jego stworzenia. Gdy twój zwierzak się zestarzeje, to umiera od starości i ale będzie możliwość przywrócenia go',
            descriptionDead:
                'Zwierzak żył długie i szczęśliwe życie, ale potem zmarł. Nie musisz się martwić, możesz go ożywić i grać ponownie!',
            dailyUnlock: 'Codzienne odblokowanie = ',
            daysMore: 'dni więcej',

            modalWhatIsAge: {
                title: 'Co to jest wiek?',
                text: 'Po utworzeniu zwierzak zacznie żyć i starzeć się. Gdy dorośnie, w końcu umrze. W takim przypadku trzeba będzie go ożywić. Długowieczność twojego wirtualnego zwierzaka zależy od jego rangi',
                feature: {
                    title: 'Zniżka na odrodzenie = {{discount}}%',
                    text: 'Po naturalnej śmierci NFT można go ożywić z {{discount}}% zniżką (zachowując rangę)',
                    alert: 'Zwiększenie rangi zresetuje wiek twojego NFT z powrotem do 0, a ulepszony wirtualny zwierzak będzie żył zgodnie z limitem wiekowym nowej rangi. Po ożywieniu zwierzak zacznie od pierwszego poziomu',
                },
            },
            modalNFTisAgeDead: {
                button: 'Przywróć',
                title: 'Zwierzak zmarł ze starości!',
                text: 'Zwierak "{{name}}" żył długie i szczęśliwe życie, ale zmarł od starości. Nie musisz się martwić, możesz go ożywić i grać ponownie!',
                feature: {
                    title: 'Zniżka na odrodzenie = {{discount}}%',
                    text: 'Po naturalnej śmierci zwierzaka można go odnowić z {{discount}}% zniżką (zachowując rangę)',
                    alert: 'Zwiększenie rangi zresetuje wiek twojego NFT z powrotem do 0, a ulepszony wirtualny zwierzak będzie żył zgodnie z limitem wiekowym nowej rangi. Po ożywieniu zwierzak zacznie od pierwszego poziomu',
                },
            },
            checkoutAgeRevive: {
                title: 'Przywrócenie zwierzaka',
                text: 'Twój zwierzak umarł ze starości i nie może zarabiać. Przywróć go do gry i zarabiaj dalej',
                restoreTo: 'Przywrócić do',
                transaction: 'Ożywienie zwierzaka "{{name}}"',
                errors: {
                    wrongState: 'Coś jest nie tak, nie można ożywić zwierzaka',
                },
            },
            successAgeRevive: {
                title: 'Zwierzak przywrócony do życia!',
                text: 'Zwierzak został pomyślnie przywrócony. Wykonuj codzienne zadania i zarabiaj jeszcze więcej tokenów',
                backToPet: 'Przejdź do zwierzaka',
            },
        },
        earnings: {
            title: 'Zarobki',
            text: 'Zarobki NFT zależą od rangi i poziomu zwierzaka',
            rank: 'Zarobki = ',
            level: 'Bonus za poziom = ',
        },
        matching: {
            title: 'Mecze',
            text: 'W codziennych zadaniach inni użytkownicy mogą ocenić Twoje NFT',
            like: '{{like}} Polubienia',
            dislike: '{{dislike}} Nie podoba się',
        },
        health: {
            title: 'Zdrowie',
            text: 'Dbaj o to, aby Twój zwierzak był nakarmiony, w przeciwnym razie będzie stracić zdrowie. Kiedy zdrowie zwierzaka osiągnie 0, on umrze',
            titleDead: 'Twój zwierzak zmarł',
            textDead:
                'Nie karmiłeś swojego zwierzaka przez długi czas i on zmarł. Nie będziesz mógł zbierać doświadczenia, nagród i grać ze swoim zwierzakiem. Ale bez obaw, możesz go ożywić i kontynuować grę. Pospiesz się!',
            buttonFeed: 'Nakarmij zwierzaka',
            buttonRestore: 'Ożyw zwierzaka',
            modalWhatIsHealth: {
                title: 'Co to jest zdrowie?',
                text: 'Twój zwierzak traci zdrowie każdego dnia, jeśli go nie karmisz. Utrzymuj swoje zdrowie zawsze na maksymalnym poziomie, aby zarabiać więcej',
                card: {
                    title: 'Zdrowie zwierzęcia = nagroda dzienna',
                    text: 'Nagrody są proporcjonalne do zdrowia, np. mając 80 zdrowia zdobędziesz 80% nagród. Dbaj o swojego zwierzaka!',
                },
            },
            modalNFTisDead: {
                title: 'Twój zwierzak zmarł',
                text: 'Nie karmiłeś swojego zwierzaka "{{petName}" przez długi czas i on zmarł. Nie będziesz mógł zbierać doświadczenia, nagród i grać ze swoim zwierzakiem. Ale bez obaw, możesz go ożywić i kontynuować grę. Pospiesz się!',
                button: 'Ożyw zwierzaka',
            },
            checkoutRevive: {
                title: 'Przywrócenie zwierzaka',
                text: 'Twój zwierzak nie żyje i nie może zarabiać. Przywróć go do gry i zarabiaj dalej',
                restoreTo: 'Przywrócić do',
                transaction: 'Ożywienie zwierzaka "{{name}}"',
                max: '100 Zdrowia',
                errors: {
                    wrongState: 'Coś jest nie tak, nie można ożywić zwierzaka',
                },
            },
            successRevive: {
                title: 'Zwierzak przywrócony do życia!',
                text: 'Zwierzak został pomyślnie przywrócony. Wykonuj codzienne zadania i zarabiaj jeszcze więcej tokenów',
                backToPet: 'Przejdź do zwierzaka',
            },
            checkoutHealUp: {
                title: 'Karmienie zwierzaka',
                text: 'Zdrowie Twojego zwierzaka zależy od codziennego karmienia. Z pełnym zdrowiem, twoje zwierzę zarabia więcej tokenów',
                restoreTo: 'Ozdrowić do',
                transaction: 'Ozdrowienie zwierzaka "{{name}}"',
                max: '{{amount}} Zdrowia',
                errors: {
                    wrongState:
                        'Coś jest nie tak, nie można wyleczyć zwierzaka',
                },
            },
            infoMultipleHealUp: {
                title: 'Nakarm wiele zwierząt',
                text: 'Użyj jednego przycisku, aby nakarmić wszystkie swoje zwierzaki! Zwierzęta będą leczone jedno po drugim. Wszystkie transakcje odbywają się na blockchainie, więc będziesz mógł je śledzić',
                primaryButton: 'Nakarm zwierzaki',
                secondaryButton: 'Nie pokazuj już tego',
            },
            checkoutMultipleHealUp: {
                title: 'Nakarm wiele zwierząt',
                text: 'Przywróć zdrowie wszystkim swoim zwierzakom. NFT z większą ilością zdrowia zdobędą więcej nagród',
                transaction: 'Ozdrowienie {{count}} NFT',
            },
            proceedingMultipleHealUp: {
                title: 'Karmienie w trakcie',
                text: 'Poczekaj chwilę, aż wszystkie transakcje zostaną sfinalizowane. Nie wychodź z ekranu, ponieważ transakcje mogą się nie powieść! Po ich zakończeniu będziesz mógł wyjść z ekranu',
                error: 'Niektóre transakcje NFT nie powiodły się z powodu problemów z blockchainem. Spróbuj ponownie',
            },
            multipleSuccessHealUp: {
                title: 'Przywrócono zdrowie NFT!',
                text: 'Zdrowie twoich zwierzaków zostało przywrócone. Kliknij przycisk poniżej, aby uzyskać więcej informacji na temat każdej transakcji',
                backToCollection: 'Powrót do zwierzaków',
                item: 'Karmienie {{length}} zwierzaków',
            },
            successHealUp: {
                title: 'Zdrowie NFT przywrócone!',
                text: 'NFT został pomyślnie nakarmiony i odzyskał zdrowie. Wykonuj codzienne zadania i zarabiaj jeszcze więcej tokenów',
                backToPet: 'Zobacz zwierzynę',
            },
            healUpAmountChoose: {
                title: 'Karmienie w celu przywrócenia zdrowia',
                text: 'Wybierz opcję z ilością punktów zdrowia, które chcesz przywrócić',
                button: 'Opłać',
                loading: 'Obliczanie opłaty..',
                label: 'Wybierz odpowiednia liczbę',
                errors: {
                    MAX: 'Max. dostępne do przywrócenia {{amount}} zdrowia',
                    MIN: 'Min. dostępne do przywrócenia {{amount}} zdrowia',
                },
            },
            healthPetCollectionList: {
                health: '{{health}} Zdrowia',
            },
            healAllLeave: {
                title: 'Czy na pewno chcesz odejść?',
                text: 'Leczenie Twoich zwierzaków jest w toku, opuszczenie ekranu w trakcie procesu może spowodować błędy, podwójne wydatki lub nieprawidłowe odliczenie salda. Postępuj ostrożnie',
                leave: 'Wyść',
                keep: 'Kontynuuj leczenie',
            },
        },
        blockchainInfo: {
            tokenId: 'Identyfikator tokena',
            title: 'Przegląd NFT',
            description:
                'Aktywa NFT Twojego zwierzaka są przechowywane na blockchainie. Możesz je wypłacić z portfela w dowolnym momencie',
            descriptionFree:
                'Twój zwierzak jest darmowym rangiem i jest wpisem w bazę, a nie faktycznym NFT. Podnieś poziom, a będziesz w stanie stworzyć z niego NFT',
            warningText:
                'Po wypłaceniu NFT przejdzie w tryb Cooldown i nie będzie dostępny do gry przez 24 godziny',
            cooldown: 'Cooldown kończy się w',
            withdraw: 'Wypłać',
        },
    },
    mysteryBoxes: {
        title: 'Mystery Boxes',
        emptyTitle: 'Nie masz tajemniczych pudełek',
        emptyText: 'Nie posiadasz żadnych Tajemniczych Skrzyń',
        emptyButton: 'Zakup pudełka',
        prepareToOpen:
            'Otwarcie pudełka, oczekiwanie na losowy wynik ChainLink Oracle..',
        banner: {
            isComing: {
                title: 'Nadchodzi Wyprzedaż Tajemniczych Pudełek',
                text: ' pozostały czas',
            },
            isStart: {
                title: 'Zakup Tajemniczego Pudełka',
                text: 'Spróbuj szczęścia i wygraj najwyższe rangi',
            },
            isNotAvailable: {
                title: 'Sprzedaż Tajemniczych Pudełek jest zamknięta',
                text: 'Sprzedaż Mystery Boxes to rzadkie okazje i nie jest dostępna do odwołania',
            },
        },
        header: {
            title: 'Mystery Boxes',
            text: 'Twoje zakupione pudełka będą przechowywane tutaj. Otwórz je w każdej chwili i zmintuj NFT',
        },
        mysteryBoxCard: { open: 'Odtwórz', mint: 'Jako NFT' },
        error: {
            title: 'Błąd',
            text: 'Coś poszło nie tak. Spróbuj przeładować',
        },
        openRank: { button: 'Zobacz szczegóły' },
        openBoxModal: {
            title: 'Chcesz otworzyć pudełko?',
            text: 'Po otwarciu pudełka otrzymasz randomizowaną rangę i będziesz mógł tworzyć NFT za darmo',
            button1: 'Tak, otwarte',
            button2: 'Nie, Anuluj',
        },
        purchaseWelcome: {
            stepOne: {
                title: 'Spróbuj szczęścia z Mystery Boxes',
                text: 'Mystery Boxes dają Ci szansę na zdobycie najlepszego NFT Rank za ustaloną cenę. Spróbuj swojego szczęścia!',
            },
            stepTwo: {
                title: 'Szansa na zdobycie najwyższej rangi',
                text: 'Po zakupie Mystery Box można go w każdej chwili otworzyć i kontynuować proces wybijania bez żadnych dodatkowych kosztów',
            },
            stepThree: {
                title: 'Prawdziwa przypadkowość',
                text: 'Szanse Mystery Box na wygranie różnych rang są w pełni losowe i wykorzystują technologię ChainLink Oracle do generowania prawdziwych liczb losowych na blockchainie',
            },
            button: 'Wybierz ilość pudełka',
        },
        purchaseScreen: {
            title: 'Wybierz ilość',
            text: 'Możesz kupić wiele pudełek za jednym razem',
            label: 'Wprowadź lub wybierz kwotę',
            labelNoInput: 'Wybierz ilość pudełek Mystery',
            errors: {
                max: 'Maksymalna dostępna ilość to 10 pudełek',
                min: 'Minimalna dostępna ilość to 1 pudełko',
                noSymbols: 'Dozwolone są tylko liczby',
            },
            button: 'Opłać',
            loading: 'Obliczanie kosztów..',
        },
        purchaseCheckout: {
            title: 'Kupić Pudełka',
            text: 'Mystery Boxy (Pudełka) dają Ci szansę na zdobycie najlepszej rangi NFT za stałą cenę. Spróbuj swojego szczęścia!',
            transactionDetails: {
                label: 'Pudełka',
                text: '{{amount}} Tajemnicze pudełko',
                transaction: 'Zakup {{amount}} Tajemnicze pudełko',
            },
        },
        purchaseSuccess: {
            title: 'Tajemnicze pudełka zakupione!',
            text: 'Tajemnicze pudełka zostały pomyślnie zakupione. Możesz go otworzyć z zakładki Tajemnicze Skrzynki',
            button: 'Zobacz wszystkie',
        },
        comingSoon: {
            title: 'Tajemnicze pudełka już wkrótce',
            text: 'Nadchodzi wyprzedaż Tajemniczych Pudełek. Bądźcie na bieżąco i spróbujcie szczęścia!',
            timer: 'Pozostały czas',
        },
        saleClosed: {
            title: 'Mystery Boxes niedostępne',
            text: 'Sprzedaż Tajemniczych Pudełek jest w tej chwili niedostępna. Bądźcie na bieżąco z oficjalnymi ogłoszeniami',
        },
        errors: {
            forbidden: {
                title: 'Wyprzedaż zakończona',
                text: 'Wyprzedaż zakończona, nie ma już Tajemniczych Pudełek do kupienia. Spróbuj szczęścia następnym razem',
            },
        },
        modalMysteryBoxSaleInfo: {
            title: 'Spróbuj szczęścia z Tajemniczymi Pudełkami',
            text: 'Wartość NFT jest gwarantowana jako nie mniejsza niż cena Pudełka. Pudełka będą sprzedawane w cenie',
            timerTitle: 'Czas do sprzedaży',
            timerText:
                'Jest to wyprzedaż limitowanej kolekcji, która będzie trwała ograniczony czas. Tylko',
            timerAdditionalText: ' dostępnych jest {{amount}} NFT',
            chanceTitle: 'Szanse na wygraną',
            chanceText:
                'Wygraj NFT z określonym prawdopodobieństwem. Oto szanse:',
            button: 'Przejdź do Pudełek',
        },
    },
    errorBoundary: {
        navigation: 'Błąd',
        title: 'Błąd po stronie klienta',
        text: 'Niestety coś poszło nie tak po naszej stronie. Jeśli nadal widzisz ten błąd, skontaktuj się z naszą pomocą techniczną',
        button: 'Przejdź do strony głównej',
        reloadApp: 'Reload App',
    },
    pullToRefresh: {
        reloadBalance: {
            text: 'Aktualizacja balansu..',
            modalText: 'Aktualizacja..',
        },
        reloadPets: {
            text: 'Aktualizcja zwierzaków..',
            modalText: 'Aktualizacja..',
        },
        reloadMysteryBox: {
            text: 'Aktualizcja boxów..',
            modalText: 'Aktualizacja..',
        },
        reloadTasks: {
            text: 'Aktualizacja tasków..',
            modalText: 'Aktualizacja..',
        },
        reloadVerifyUsers: {
            text: 'Szukam zwierząt..',
            modalText: 'Aktualizacja..',
        },
        reloadRewards: 'Aktualizacja nagród..',
        reloadStatistics: 'Aktualizacja statystyk..',
        reloadReferrals: 'Aktualizacja poleconych..',
        loading: 'Aktualizacja..',
        pulling: 'Pociągnij, aby zaktualizować',
        releasing: 'Puść',
    },
    petLevelUp: {
        readyToUpModal: {
            titleStart: 'NFT jest gotowe do',
            titleLevelUp: ' {{level}} Poziom',
            titleEnd: 'W górę',
            subTitleStart: 'Gratulacje! Zebrałeś wszystkie doświadczenia i NFT',
            subTitleEnd: ' jest gotowy, by podnieść poziom',
            button: 'Aktualizacja',
            featureRankEarnings: {
                title: 'Zarobki zależnie od rangi ≈ {{igup}} ≈ ({{usd}}$)',
                text: 'To są Twoje zarobki oparte wyłącznie na randze',
            },
            featureLevelEarnings: {
                title: 'Zarobki zależnie od poziomu',
                text: 'Dodatkowe zarobki, które otrzymujesz zależnie od poziomu swojej NFT. Każdy kolejny poziom zwiększa Twoją kasę',
            },
            featureNextRank: {
                title: '{{levels}} poziom(y) więcej do “{{rankName}}”',
                text: 'Musisz podnieść swoją NFT jeszcze {{levels}} razy, aby móc ją ulepszyć do następnej rangi',
            },
        },
        petLevelUpSuccess: {
            title: 'NFT podniósł się!',
            text: 'NFT {{name}} został pomyślnie ulepszony do poziomu {{level}}. Wykonuj codzienne zadania i zarabiaj jeszcze więcej tokenów dzięki ulepszonemu NFT',
            backToPet: 'Zobacz zwierzynę',
            loading: 'Uaktualnianie zwierząt..',
        },
        headerTitle: 'NFT poziom wyżej',
        checkout: {
            upgrade: 'Uaktualnienie do',
            level: 'Poziom {{level}}',
            transaction: 'Podnieść poziom dla {{name}} NFT',
        },
        errors: { PET_WRONG_STATE: 'Podnoszenie poziomu nie jest dostępne' },
    },
    petRankUp: {
        readyToUpModal: {
            title: 'Podniesienie rangi do {{rank}}',
            subTitle:
                'Osiągnąłeś wszystkie poziomy w randze {{rank}} i Twój Zwierzak jest gotowy do ulepszenia',
            button: 'Aktualizacja',
        },
        petLevelUpSuccess: {
            title: 'NFT Ranked Up!',
            text: 'NFT {{name}} został pomyślnie podniesiony do rangi {{rank}}. Wykonuj codzienne zadania i zarabiaj jeszcze więcej tokenów dzięki ulepszonym NFT',
            backToCollection: 'Powrót do kolekcji',
            loading: 'Zaktualizuj zwierzaka..',
        },
        headerTitle: 'NFT poziom wyżej',
        checkout: {
            upgrade: 'Uaktualnienie do',
            level: 'Poziom {{level}}',
            transaction: 'Podnieść poziom dla {{name}} NFT',
        },
        errors: { PET_WRONG_STATE: 'Ranking w górę niedostępny' },
    },
    petIsPlaying: {
        title: 'Twój zwierzak się bawi',
        text: 'Jeśli wycofasz go z konta przed wykonaniem zadań, nie otrzymasz nagród za dzień dzisiejszy, a Twój zwierzak przejdzie w tryb Cooldown na następne 24 godziny',
        button: 'Rozumiem',
    },
    petOnCooldown: {
        title: 'Cooldown NFT',
        text: 'Twoje NFT zostało przeniesione z innej giełdy i nie jest jeszcze grywalne, szacowany czas transferu jest pokazany powyżej. Postaramy się to zrobić szybciej, dziękujemy za zrozumienie',
    },
    petIsDead: {
        title: 'NFT jest martwe',
        text: 'Nie karmiłeś swojego zwierzaka "{{petName}" przez długi czas i teraz jest martwy. Nie będziesz mógł zbierać doświadczenia, nagród i grać ze swoim zwierzakiem. Ale bez obaw, możesz go ożywić i kontynuować grę. Pospiesz się!',
        errors: {
            PET_WRONG_STATE: 'Przywrócenie zwierząt domowych nie jest dostępne',
        },
    },
    socializeToEarn: {
        welcomeSlidesShare: {
            startSharing: 'Zacznij udostępniać',
            sharing: 'Dzielenie się jest opiekuńcze',
            sharingText:
                'Każdego dnia Twój zwierzak potrzebuje uwagi z Twojej strony. Podaruj mu ją, dzieląc się nią w mediach społecznościowych ze swoimi przyjaciółmi',
            sharingEnergy: ' Energii',
            socialMedia:
                'Udostępnij swojego zwierzaka w mediach społecznościowych',
            socialMediaText:
                'Wybierz swoje konto w mediach społecznościowych i dołącz identyfikator zwierzęcia do swoich treści w mediach społecznościowych, aby inni użytkownicy mogli znaleźć Twoje zwierzę',
            socialMediaEnergy: ' Energii',
            referral: 'Dodaj swój link polecający',
            referralText:
                'Twój link polecający musi być dołączony do ID zwierzaka w historii. Inni gracze nie będą mogli sprawdzić Twojego zadania, jeśli zabraknie tego linku!',
            errors: {
                FORBIDDEN: {
                    text: 'Nie możesz rozpocząć zadania społecznego teraz z tym kontem społecznym. Spróbuj ponownie jutro',
                },
            },
        },
        shareYourPetPhoto: {
            copyToClipboard: 'Nazwa użytkownika skopiowana do schowka',
            title: 'Udostępnij swoje zdjęcie zwierzęcia',
            texts: {
                INSTAGRAM:
                    'Udostępnij swoje treści z dołączonym identyfikatorem zwierzęcia w Instagramie i pozwól innym użytkownikom znaleźć swojego pupila',
                TIKTOK: 'Udostępnij swoje treści z załączonym identyfikatorem zwierzęcia w TikTok i pozwól innym użytkownikom znaleźć swojego pupila',
                TWITTER:
                    'Udostępnij swoją treść z załączonym identyfikatorem zwierzęcia na Twitterze i pozwól innym użytkownikom znaleźć swojego pupila',
                FACEBOOK:
                    'Udostępnij swoją treść z załączonym identyfikatorem zwierzęcia na Facebook i pozwól innym użytkownikom znaleźć swojego pupila',
            },
            info: 'Jak się dzielić?',
            download: 'Pobierz',
            share: 'Podziel się',
            createPhoto: 'Otwarty edytor',
            button: 'Podziel się i zakończ',
            warningText:
                'Upewnij się, że identyfikator Twojego zwierzęcia jest dostępny i łatwy do znalezienia dla innych użytkowników do czasu zakończenia zadania',
            selectCreationMethod: 'Wybierz zdjęcie',
            creationMethod: {
                camera: 'Zrób zdjęcie',
                gallery: 'Wybierz z galerii',
            },
            modalPetIdVisible: {
                title: 'Czy Pet ID i link są dobrze widoczne?',
                text: 'Twoja historia zostanie sprawdzona przez innych użytkowników. Jeśli nie znajdą identyfikatora zwierzęcia, linku lub nie zobaczą treści, zadanie zostanie uznane za niewykonane',
                button1: 'Tak, kontynuuj',
                button2: 'Nie, sprawdź jeszcze raz',
            },
            modalShareYourPhoto: {
                title: 'Wybierz metodę udostępniania',
                shareTemplate: {
                    title: 'Wykorzystaj Szablon',
                    text: 'Użyj szablonu, który stworzyliśmy, aby szybciej podzielić się swoim identyfikatorem dla zwierząt',
                },
                editToShare: {
                    title: 'Otwórz edytor zdjęć',
                    text: 'Prześlij obraz z galerii lub zrób zdjęcie i użyj naszego wbudowanego edytora',
                },
                downloadPetId: {
                    title: 'Pobierz identyfikator zwierzęcia',
                    text: 'Stwórz publikację bez użycia naszych narzędzi',
                },
                submit: 'Zrobiłem/am publikację',
                loading: 'Przygotowanie treści..',
                saveSuccess: 'Zdjęcie zostało pomyślnie zapisane',
            },
            petIdVisibleLoading: 'Tworzenie zadania Find..',
            shareSuccess: {
                title: 'Znajdź inne zwierzęta',
                text: 'Udało Ci się udostępnić zdjęcie swojego zwierzaka. Twoje zadanie jest w trakcie weryfikacji i zazwyczaj trwa to od 6 do 12 godzin. Teraz Twoja kolej, aby znaleźć inne zwierzaki w mediach społecznościowych',
                button1: 'Znajdź inne zwierzęta',
                button2: 'Powrót do dzielenia się',
                button3: 'Powrót do zadań',
                toastSuccess: 'Wszystkie zadania weryfikacyjne wykonane',
            },
            alert: 'Do poprawnego wykonania zadania należy w relacji umieścić link do aplikacji',
        },
        createShareTemplate: {
            screenTitle: 'Udostępnianie szablonów',
            title: 'Użyj szablonu do dzielenia się',
            text: 'Skorzystaj z naszego wstępnie zaprojektowanego szablonu, aby szybko i wygodnie udostępniać treści',
            shareTemplate: {
                Default: 'Codziennie Gram IguVerse i Zarabiam Kryptowalutę',
                BinanceNft: 'Zarabiaj NFT ze swoim zwierzakiem dzięki IguVerse',
                BnbChain: 'Zarabiaj NFT ze swoim zwierzakiem dzięki IguVerse',
                Okx: 'IGU przygotowuje się do lądowania na Księżycu na OKX',
                KuCoin: 'IGU przygotowuje się do lądowania na Księżycu na KUCOIN',
                Bybit: 'Głosuj za IguVerse\nna ByBit i rozdziel\n$121 000!',
            },
            placeForLink: 'Miejsce na link',
            socialCardTemplate: {
                Default: 'Gram IguVerse\ni Zarabiam Kryptowalutę',
                Bybit: 'Głosuj za IguVerse\nna ByBit i rozdziel\n$121 000!',
            },
        },
        welcomeSlidesVerify: {
            startVerify: 'Rozpocznij wyszukiwanie Zadanie',
            find: 'Znajdź inne zwierzęta',
            findText:
                'Twój zwierzak potrzebuje uwagi innych zwierzaków. Znajdź zwierzaki innych graczy i cieszcie się wspólnie nagrodami. Nie popełniaj błędu podczas szukania innych zwierząt, one polegają na Tobie. Twoim codziennym celem jest znalezienie wszystkich zwierzaków.',
            findEnergy: ' Energii',
            beResponsible: 'Bądź odpowiedzialny',
            beResponsibleText:
                'Graj uczciwie i nie próbuj oszukiwać, wprowadzając w błąd system poprzez podawanie błędnych ID lub twierdzenie, że nie możesz znaleźć. Twoje konto może zostać oflagowane, gdy to zrobisz',
            beResponsibleEnergy: ' Energii',
        },
        verifyUser: {
            title: 'Znajdź zwierzaka',
            text: 'Musisz znaleźć i wpisać identyfikator użytkownika Pet, który można znaleźć w mediach społecznościowych. Za każde udane dopasowanie otrzymasz {{energy}} energii',
            info: 'Jak znaleźć identyfikator zwierzęcia?',
            label: 'Identyfikator zwierzęcia',
            placeHolder: 'Wprowadź identyfikator',
            question: 'Jak znaleźć identyfikator?',
            buttonVerify: 'Zweryfikuj',
            buttonNotFound: 'Nie znaleziono',
            errorMessage:
                'Nieprawidłowy kod identyfikacyjny zwierzęcia. Proszę spróbować ponownie. Pozostały próby {{attempts}}!',
            loadingVerifyUser: 'Sprawdzanie..',
            errors: {
                noTasksText1: 'Brak dostępnych obecnie zadań',
                noTasksText2: 'Wróć później',
                gameIterationExists1: 'Nie wolno tworzyć',
                gameIterationExists2: 'więcej zadań w tej iteracji gry',
            },
            toastNoPetVerification: {
                title: 'Błąd',
                text: 'Nie ma dostępnego zwierzęcia do weryfikacji',
            },
            toastSuccess:
                'Gratulacje!!! Użytkownik {{user}} został zweryfikowany',
            toastFailedVerify: 'Fail!!! Użytkownik {{user}} nie zweryfikowany',
            regexError: 'Dozwolone są tylko cyfry i znaki A-Z',
            verifyEmpty: {
                title: 'Nikogo Nie Ma',
                text: 'Wygląda na to, że nikt już nie gra. Powiadomimy Cię, gdy więcej zwierzaków będzie dostępnych',
                button1: 'Poznaj inne zadania',
                button2: 'Spróbuj ponownie',
                refresh: 'Odśwież',
            },
            verifyNotFound: {
                title: 'Nie znaleziono zwierzęcia',
                text: 'Mam nadzieję, że miałeś rację. Jeśli pet naprawdę tam był, to damy ci ostrzeżenie',
                button1: 'Znajdź następnego',
                button2: 'Zakończ grę',
            },
            verifyAlreadyCompleted: {
                title: 'Już zakończone',
                text: 'Tekst już uzupełniony',
                button1: 'Weryfikuj dalej',
                button2: 'Zakończ grę',
            },
            verifyMatch: {
                title: 'Zwierzęta dopasowane!',
                text: {
                    step1: 'Gratulacje! Twój zwierzak',
                    step2: ' dopasowany do zwierzęcia',
                    step3: '! Teraz będziesz mógł się połączyć wewnątrz aplikacji',
                },
                button1: 'Znajdź następny',
                button2: 'Zakończ grę',
                like: 'Lubię',
                dislike: 'Nie lubię',
                alreadyRate: 'Nie możesz zmienić swojej decyzji',
            },
            verifyFailed: {
                title: 'Nie udało się',
                text: 'Niestety nie podałeś prawidłowego kodu identyfikacyjnego zwierzęcia',
                button1: 'Znajdź następny',
                button2: 'Zakończ grę',
            },
            modalPetIdNotFound: {
                title: 'Nie znaleziono identyfikatora zwierzęcia?',
                text: 'Proszę spróbować znaleźć ID zwierzęcia na zdjęciu użytkownika. Jeśli ID zwierzaka tam było, a Ty go nie podałeś, to nie otrzymasz punktów za energię i możesz otrzymać ostrzeżenie.',
                button1: 'Tak, potwierdzić',
                button2: 'Anuluj',
            },
            tips: {
                title: 'Wskazówki dotyczące weryfikacji',
                alert: "Jeśli Pet ID nie spełnia zasad, kliknij przycisk 'Nie znaleziono'",
                post: 'Pet ID musi znajdować się w story',
                picture:
                    'Pet ID i wszystkie informacje na jego temat powinny być łatwo czytelne na zdjęciu',
                changes:
                    'Pet ID można zmieniać, ale zmiany nie powinny być sprzeczne z innymi zasadami',
                cropping:
                    'Zakazane jest przycinania się lub ukrywania zdjęcia lub jego fragmentów',
                overlaying:
                    'Zakazane jest nakładanie lub nadmierne zmniejszanie rozmiaru',
            },
        },
        petCardId: {
            link: 'Pobierz aplikację IguVerse ',
            earnStart: 'Moje zwierzaki zarabiają ',
            earnEnd: ' codziennie',
            freeEarn: 'Mój darmowy zwierzak zarabia ',
            donateMessage:
                'Część moich zarobków idzie na wsparcie organizacji ',
            binanceMessage: 'IguVerse x Binance NFT Sprzedaż',
            bnbMessage:
                'IguVerse x BNB Chain: Dołącz do nowego trendu w Web3 i mediach społecznościowych',
            okxKuCoinMessage: 'Token IGU uruchamia się ',
            defaultMessage:
                'Budujemy rynek AI i sieć reklamową - dołącz do nas!',
        },
    },
    moveToEarn: {
        welcomeSlides: {
            walkPet: 'Przejdź się ze swoim zwierzakiem',
            walkPetText:
                'Twoje zwierzaki potrzebują codziennych spacerów, aby zachować zdrowie tak samo jak Ty. Spaceruj ze swoim zwierzakiem, a zostaniesz nagrodzony punktami energii',
            energyTotal: ' Energii',
            complete: 'Zrealizuj swój cel spacerowy',
            completeText:
                'Zrealizuj swój cel spacerowy, śledź swoje wyniki i ciesz się zdrowym stylem życia',
            antiCheating: 'Algorytmy przeciwdziałające oszustwom',
            antiCheatingText:
                'Nasze algorytmy anty-oszukujące są w stanie wykryć podejrzaną aktywność użytkownika. Użytkownicy, którzy oszukują, tracą swoje punkty energii',
        },
        modals: {
            prepare: 'Przygotuj się do spaceru',
            prepareText:
                'Zadanie chodzenia możesz wykonać raz dziennie. Po zakończeniu lub zamknięciu zadania, nie będziesz mógł grać więcej tego dnia',
            leave: 'Chcesz odejść?',
            leaveText:
                'Zakończysz zadanie z aktualnym postępem energii. Możesz rozpocząć zadanie ponownie jutro',
            leaveBtn1: 'Tak, zostaw',
            leaveBtn2: 'Nie, kontynuuj',
            prepareBtn1: 'Zacznij chodzić',
            prepareBtn2: 'Anuluj',
            permissionsInfoText:
                'IguVerse zbiera dane o lokalizacji nawet wtedy, gdy aplikacja jest zamknięta lub nie jest używana. Aplikacja może uzyskiwać dostęp do lokalizacji użytkownika w tle, aby zapewnić funkcjonalność zadania Chodzenie',
            permissionsInfoBtn1: 'Kontynuuj',
            permissionsInfoBtn2: 'Anuluj',
            leaveWithOutFinish: 'Chcesz wyjść?',
            leaveWithOutFinishText:
                'Po zamknięciu zadania postępy znikną i trzeba będzie zacząć od nowa',
            leaveWithOutFinishBtn1: 'Wyjście',
            leaveWithOutFinishBtn2: 'Anuluj',
        },
        notSupported: {
            title: 'Geolokalizacja niedostępna',
            text: 'Twoje urządzenie nie obsługuje API geolokalizacji, nie możesz wykonać zadania Chodzenie',
            button: 'OK',
        },
        locationProblem: {
            title: 'Problem geolokalizacji',
            text: 'Zauważyliśmy, że funkcja geolokalizacji w Twoim urządzeniu przestała działać zgodnie z oczekiwaniami, musisz ponownie uruchomić zadanie',
            button: 'Got It',
        },
        progress: {
            paused: 'Wstrzymane',
            walking: 'Chodzący',
            stopped: 'Zatrzymał się',
            tooFast: 'Za szybko',
            title: 'Spacer z pupilem',
            timeLeft: 'Time Left to Walk',
            tooFastMessage:
                'Twoja prędkość nie może być większa niż 20 km/h. Postęp zostanie wznowiony, gdy prędkość stanie się mniejsza',
            walkStoppedMessage:
                'Wygląda na to, że przestałeś chodzić. Twój postęp zostanie wznowiony, gdy będziesz kontynuował chodzenie',
        },
        summary: {
            title: 'Statystyki dotyczące chodzenia',
            youEarned: 'Zarobiłeś',
            energy: 'Energia',
            subtitle:
                'Gratulacje! Znalazłeś wszystkie zwierzaki. Wróć jutro po więcej',
            distance: 'Odległość',
            steps: 'Kroki',
            averageSpeed: 'Średnia prędkość',
            viewMoreTasks: 'Zobacz więcej zadań',
            finishPlaying: 'Zakończ grę',
        },
        startWalking: 'Zacznij chodzić',
        skip: 'Stuknij, aby pominąć',
        km: 'km',
        kmH: 'km/h',
    },
    playToEarn: {
        welcomeSlides: {
            energy: 'Odzyskaj energię',
            energyText:
                'Zbieraj owoce i skacz przez przeszkody, aby odzyskać swój dzienny poziom energii. Uważaj, masz tylko jedną próbę dziennie',
            energyAgainText:
                'Ćwicz swoje umiejętności w grze, aby zdobyć więcej nagród. Zadanie jest dostępne raz dziennie, jednak możesz ćwiczyć grę w dowolnym momencie',
            energyTotal: ' Energii',
            energyAgainTotal: 'Ćwiczenie',
            avoid: 'Unikaj przeszkód',
            avoidText:
                'Twoim głównym celem jest przeskakiwanie przez przeszkody i zbieranie punktów. Bądź ostrożny!',
            food: 'Zbierz jedzenie',
            foodText:
                'Zebrane jedzenie daje dodatkowe punkty. Po osiągnięciu docelowego wyniku gra się kończy, a Twój poziom Energii zostaje natychmiast przywrócony',
        },
        modals: {
            prepareToPlay: {
                title: 'Prepare to Play',
                text: 'W swojej pierwszej grze będziesz grał, aby przywrócić energię. Jeśli nie uda Ci się zebrać całej energii, będziesz mógł grać, ale bez postępu energetycznego',
                accept: 'Zacznij grać',
                cancel: 'Anuluj',
            },
            playAgain: {
                title: 'Prepare to Play',
                text: 'Masz już zebrane energii w tej grze dzisiaj. Teraz możesz po prostu grać dla aktualizacji umiejętności na następne dni',
                accept: 'Zacznij grać',
                cancel: 'Anuluj',
            },
            loading: { text: 'Przygotowanie gry..' },
            gameTimer: {
                text: 'Dotknij ekranu, aby przeskoczyć przez przeszkody. Zdobywaj punkty i zbieraj owoce',
                textWebDesktop:
                    'Naciśnij spację lub kliknij lewym przyciskiem myszki, aby przeskoczyć przez przeszkody. Zdobywaj punkty i zbieraj owoce',
                textWebMobile:
                    'Dotknij ekranu, aby przeskoczyć przez przeszkody. Zdobywaj punkty i zbieraj owoce',
            },
            pause: {
                title: 'Chcesz odejść?',
                text: 'Twoje obecne postępy zostaną zamienione na energię, jednak tego dnia nie będziesz mógł już grać',
                accept: 'Tak, zostaw',
                cancel: 'Nie, kontynuuj',
            },
            win: {
                title: 'Zadanie zakończone',
                text: 'Gratulacje! Pomyślnie ukończyłeś swoje dzienne zadanie. Możesz kontynuować grę dla zabawy, jednak nie będzie to miało wpływu na Twój poziom energii',
                accept: 'Zakończyć',
                cancel: 'Zagraj więcej',
            },
            loose: {
                title: 'Gra została ukończona',
                text: 'Nie udało Ci się wykonać swojego dziennego zadania. Możesz kontynuować grę dla zabawy, jednak nie będzie to miało wpływu na Twój poziom energii',
                accept: 'Zakończyć',
                cancel: 'Zagraj więcej',
            },
            score: 'Twój wynik',
            energy: 'Przywrócona energia',
            savedLives: 'Ocalone życia',
            fruitCollected: 'Zebrane owoce',
        },
        summary: {
            title: 'Statystyki dotyczące gry',
            score: 'Twój Wynik',
            lives: 'Ocalone życia',
            fruitCollected: 'Zebrane owoce',
        },
        startPlaying: 'Zacznij grać',
        loadingStatuses: {
            downloading: 'Pobieranie zasobów',
            preparing: 'Przygotowanie tekstur',
            loadingGraphics: 'Ładowanie grafiki',
            spawning: 'Spawnowanie obiektów gry',
            loading: 'Ładowanie (nie zamykaj aplikacji)',
        },
    },
    editNFTsScreen: {
        title: 'Wybierz zwierzęta do zabawy',
        dragText:
            'Zwierzaki, które będą brały udział w grach. Przeciągnij je, aby zmienić kolejność',
        selectList: 'Wybierz zwierzęta z listy',
        warningMessage:
            'Pierwszy zwierzak w kolejności będzie użyty w Twoim zadaniu społecznym jako ID zwierzaka',
        cooldownMessage:
            'Twój NFT jest w trybie Cooldown i nie może brać udziału w grze. Poczekaj aż tryb Cooldown wygaśnie',
        button: 'Zapisz',
        errors: {
            saveChanges: {
                title: 'Niezapisane zmiany',
                text: 'Masz niezapisane zmiany, czy na pewno chcesz wyjść?',
                button1: 'Zostaw',
                button2: 'Wróć i zapisz',
            },
        },
        loading: 'Oszczędzanie zmian..',
        success: 'Zamówienie NFT uratowane!',
    },
    statuses: {
        COMPLETED: { title: 'Zakończono' },
        AWAITS_VERIFICATION: { title: 'Oczekuje na weryfikację' },
        MODERATOR_VERIFICATION_REQUIRED: { title: 'Oczekuje na weryfikację' },
        FAILED: { title: 'Nie udało się' },
    },
    profile: {
        title: 'Ustawienia',
        logOut: 'Wyloguj się',
        deleteAccount: 'Usuń konto',
        logOutModal: {
            title: 'Już wyjeżdżasz?',
            description:
                'Będziesz musiał zalogować się ponownie lub założyć nowe konto, aby korzystać z IguVerse App',
            okText: 'Tak, wyloguj się',
            cancelText: 'Anuluj',
        },
        deleteAccountModal: {
            title: 'Usunąć konto?',
            description:
                'Możesz trwale usunąć swoje konto, ale pamiętaj, że nie będziesz mógł się już na nie zalogować i z niego korzystać',
            okText: 'Usuń konto',
            inputLabel: 'Fraza potwierdzająca',
            placeholder: 'Wprowadź frazę potwierdzającą',
            preConfirmationPhrase: 'Typ',
            afterConfirmationPhrase: ' potwierdzenie działania',
            success: 'Twoje konto zostało pomyślnie usunięte',
            loading: 'Usunięcie konta..',
        },
        lightTheme: 'Light',
        darkTheme: 'Dark',
        menuItems: {
            admin: {
                title: 'Zweryfikuj użytkowników',
                description:
                    'Zweryfikuj użytkowników w mediach społecznościowych',
            },
            security: {
                title: 'Bezpieczeństwo',
                description: 'Dostosuj ustawienia zapezpieczenia',
            },
            socialAccounts: {
                title: 'Konta społecznościowe',
                description:
                    'Połącz swoje media społecznościowe, aby wziąć udział w grze społecznej',
            },
            assignRole: {
                title: 'Przypisz rolę',
                description: 'Wybierz i przypisz użytkownikowi rolę konta',
            },
            language: {
                title: 'Język',
                description: 'Ustawianie języka wyświetlania',
            },
            theme: {
                title: 'Interfejs',
                description: 'Wybierz temat interfejsu',
            },
            notifications: {
                title: 'Powiadomienia',
                description:
                    'Wybierz rodzaje powiadomień, które chcesz otrzymywać z aplikacji',
            },
            support: {
                title: 'Live chat',
                description:
                    'Zostaw swoje zapytanie, a nasz specjalista odpowie Ci poprzez czat',
            },
            supportEmail: {
                title: 'Zostaw email',
                description: 'Zostaw nam email, jeśli potrzebujesz pomocy',
            },
            knowledgeBase: {
                title: 'Baza wiedzy',
                description:
                    'Sprawdź inne pomocne informacje o aplikacji IguVerse, aby dowiedzieć się więcej o naszej prywatności',
            },
            privacyPolicy: {
                title: 'Polityka prywatności',
                description: 'Sprawdź więcej o naszej polityce prywatności',
            },
            termsOfUse: {
                title: 'Regulamin',
                description: 'Sprawdź więcej o naszych Warunkach Użytkowania',
            },
            appVersion: {
                title: 'Wersja aplikacji',
                description: 'Najnowsza {{version}}',
            },
            webVersion: {
                title: 'Web App',
                description: 'Logowanie do aplikacji internetowej',
            },
            accessibility: {
                title: 'Dostępność',
                description: 'Dostosuj interfejs do swoich preferencji',
            },
            socialMedia: {
                title: 'Nasze media społecznościowe',
                description:
                    'Śledź IguVerse na mediach społecznościowych, aby być na bieżąco',
            },
            adminSendPushNotification: {
                title: 'Wyślij mass Push',
                description:
                    'Utwórz mass push powiadomienia, które będą wyświetlane wszystkim użytkownikom',
            },
            adminReverification: {
                title: 'Ponowna weryfikacja',
                description:
                    'Jako administrator możesz wysłać konto społecznościowe do ponownej weryfikacji',
            },
            adminBlockUser: {
                title: 'Zablokować użytkownika',
                description: 'Zablokuj konto, które naruszyło zasady IguVerse',
            },
            adminMaintenanceMode: {
                title: 'Tryb konserwacji',
                description:
                    'W przypadku prac technicznych przełącz aplikację w tryb konserwacji',
            },
            adminAssignWhiteList: {
                title: 'Przypisz białą listę',
                description:
                    'Wybierz liczbę i rangę NFT, aby wysłać Białą listę do zwycięzcy',
            },
        },

        languageSettings: {
            title: 'Języki',
            subtitle: 'Wybierz język',
            description:
                'Możesz wybrać preferowany język do wyświetlania treści w aplikacji IguVerse',
            options: {
                pl: {
                    name: 'Polski',
                    change: 'Polski',
                },
                en: {
                    name: 'Angielski',
                    change: 'Angielski',
                },
                ru: {
                    name: 'Rosyjski',
                    change: 'Rosyjski',
                },
                uk: {
                    name: 'Ukraiński',
                    change: 'Ukraiński',
                },
                cn: {
                    name: 'Chiński',
                    change: 'Chiński',
                },
                id: {
                    name: 'Indonezyjski',
                    change: 'Indonezyjski',
                },
                es: {
                    name: 'Hiszpański',
                    change: 'Hiszpański',
                },
                tr: {
                    name: 'Turecki',
                    change: 'Turecki',
                },
            },
            switchLanguageModal: {
                title: 'Przełączenie na język {{localeId}}',
                description:
                    'Wszystkie treści w aplikacji IguVerse zostaną przełączone na {{localeId}}. Możesz to zmienić w każdej chwili',
            },
        },
        notificationsSettings: {
            title: 'Powiadomienia',
            pushNotificationTitle: 'Powiadomienia push',
            emailNotificationTitle: 'Powiadomienia e-mail',
            notifications: {
                pushDailyReminder: 'Codzienne przywitanie',
                pushRewardEarned: 'Nagroda',
                pushSocialTaskCompleted: 'Zadanie społeczne zakończone',
                pushPetLowHealth: 'Niski poziom zdrowia',
                pushPetDead: 'Zwierzak nie żyje',
                pushMysteryLikesGame: 'The Mystery Of Likes',
                emailPetDead: 'Zwierzak nie żyje',
                emailSocialTaskCompleted: 'Zadanie społeczne zakończone',
            },
            saved: 'Ustawienia powiadomień zapisane!',
        },
        socialAccountsSettings: {
            title: 'Konta społecznościowe',
            headerTitle: 'Połącz serwisy społecznościowe',
            headerText:
                'Połącz swoje konto społecznościowe, aby móc wykonać zadanie społecznościowe. Przeczytaj więcej o wymaganiach dotyczących konta w bazie wiedzy',
            headerInfo: 'Zobacz bazę wiedzy',
            alert: 'Po podłączeniu konta musisz wykonać zadanie, aby konto zostało zweryfikowane',
            modal: {
                title: 'Dokończ weryfikację',
                text: 'Twoje konto zostało pomyślnie podłączone. Wykonaj zadanie społeczne, aby zweryfikować się!',
                button: 'Nawigacja do zadań',
            },
        },
        roles: {
            PLAYER: 'Gracz',
            ADMIN: 'Admin',
            MODERATOR: 'Moderator',
        },
        support: {
            success: {
                title: 'Wiadomość wysłana!',
                text: 'Odezwiemy się do Ciebie wkrótce',
            },
            notSent: { text: 'Komunikat nie został wysłany' },
            errorOpen: {
                text: 'Błąd podczas otwierania aplikacji klienta poczty',
            },
        },
        accessibilitySettings: {
            title: 'Ustawienia aplikacji',
            faceId: 'Face ID / Kod dostępu',
            shake: 'Pokazywać okno z feedbackiem',
            vibration: 'Wibracje',
            saved: 'Ustawienia zapisane!',
        },
        socialMediaSettings: {
            screenTitle: 'IguVerse Media',
            communities: {
                title: 'Wspólnoty urzędowe',
                text: 'Dołącz do naszej niesamowitej społeczności miłośników zwierząt, uzyskaj pomoc i nawiąż kontakty towarzyskie',
                socials: {
                    discord: 'Discord',
                    telegram: 'Telegram',
                },
            },
            media: {
                title: 'Oficjalne media',
                text: 'Śledź nasze kanały mediów społecznościowych, aby otrzymywać najnowsze wiadomości i ogłoszenia',
                socials: {
                    twitter: 'Twitter',
                    instagram: 'Instagram',
                    youtube: 'Youtube',
                    tiktok: 'TikTok',
                    website: 'Strona',
                    facebook: 'Facebook',
                },
            },
            telegram: {
                title: 'Wspólnoty Telegramu',
                main: 'Kanał oficjalny',
                en: 'Angielski czat',
                uk: 'Ukraiński czat',
                ru: 'Rosyjski czat',
                cn: 'Chiński czat',
                tr: 'Turecki czat',
                id: 'Indonezyjski czat',
                kr: 'Koreański czat',
                jp: 'Japoński czat',
                ab: 'Arabski czat ',
                in: 'Indyjski czat',
                pp: 'Filipiny czat',
                vt: 'Wietnamski czat',
                bg: 'Bangladeski czat',
                pl: 'Polski czat',
                es: 'Hiszpański czat',
                fr: 'Francuski czat',
                pt: 'Portugalski czat',
            },
        },
        adminSendPushNotification: {
            title: 'Wyślij powiadomienie Push',
            text: 'Utwórz jednorazowe powiadomienie, które będzie wyświetlane wszystkim użytkownikom',
            button: 'Wyślij',
            selectLanguage: {
                label: 'Język',
                placeHolder: 'Wybierz język powiadomienia',
                modalTitle: 'Wybierz język',
                button: 'Zapisz',
                title: '{{amount}} Język wybrany',
            },
            titleInput: {
                label: 'Tytuł (mniej niż {{amount}} symboli)',
                placeHolder: 'Nowa aktualizacja!',
            },
            bodyInput: {
                label: 'Opis (mniej niż {{amount}} symboli)',
                placeHolder:
                    'Poznaj naszą nową aktualizację z tajemniczymi skrzynkami',
            },
            errors: {
                required: 'To pole jest wymagane',
            },
        },
        adminReverification: {
            screenTitle: 'Ponowna weryfikacja',
            title: 'Wyślij do weryfikacji',
            text: 'Wybierz sieć społecznościową i wprowadź nazwę użytkownika, aby wysłać konto do weryfikacji',
            button: 'Wyślij',
            labelSocial: 'Sieć społeczna',
            labelInput: 'Link do konta',
            placeHolder: 'Wpisz link do konta',
            socialMediaModal: {
                title: 'Wybierz sieć społecznościową',
            },
            checkModal: {
                title: 'Sprawdź szczegóły profilu',
                text: 'Spójrz na poniższe konto społecznościowe i sprawdź, czy jest właściwe. Uważaj, ponieważ tej czynności nie można cofnąć',
                button1: 'Wyślij do weryfikacji',
                button2: 'Niewłaściwe konto, Anuluj',
            },
            toastSuccess: 'Konto zostało przesłane do ponownej weryfikacji',
        },
        adminBlockUser: {
            screenTitle: 'Zablokować użytkownika',
            title: 'Wprowadź adres portfela',
            text: 'Wprowadź portfel powiązany z kontem, które naruszyło zasady IguVerse',
            button: 'Zablokować',
            modal: {
                title: 'Zablokować użytkownika?',
                text: 'Upewnij się, że blokujesz właściwego użytkownika. Powinieneś być bardzo ostrożny z użytkownikami, których blokujesz. Tej czynności nie można cofnąć!',
                button1: 'Wyślij',
                button2: 'Anuluj',
            },
            toastSuccess: 'Użytkownik został pomyślnie zablokowany',
            toastError: 'Nie można znaleźć użytkownika',
            banReason: {
                screenTitle: 'Wybierz przyczynę zablokowania',
                label: 'Powód zablokowania',
                placeHolder: 'Wybierz przyczynę zablokowania',
            },
            banComment: {
                label: 'Komentarz',
                placeHolder: 'W razie potrzeby dodaj komentarz',
            },
            error: {
                banComment: 'Należy dodać komentarz',
                banReason: 'Proszę wybrać powód wprowadzenia zakazu',
            },
        },
        adminMaintenanceMode: {
            screenTitle: 'Tryb konserwacji',
            on: {
                title: 'Włącz tryb konserwacji',
                text: 'Możesz wprowadzić aplikację w tryb konserwacji, a użytkownicy nie będą mogli uzyskać do niej dostępu. Aby udostępnić użytkownikom, kliknij Wyłącz tryb konserwacji w Ustawieniach',
                button: 'Włączyć coś',
                modal: {
                    title: 'Włącz tryb konserwacji?',
                    text: 'Użytkownicy nie będą mogli uzyskać dostępu do aplikacji, jeśli włączysz tryb konserwacji. Aby ponownie udostępnić aplikację, kliknij Wyłącz tryb konserwacji w Ustawieniach',
                    button1: 'Włączyć coś',
                    button2: 'Anuluj',
                },
                toastSuccess: 'Tryb konserwacji włączony',
            },
            off: {
                title: 'Wyłącz tryb konserwacji',
                text: 'Aplikacja jest w trybie konserwacji i użytkownicy nie mogą w tym czasie uzyskać do niej dostępu. Wyłącz go, gdy tylko prace techniczne zostaną zakończone, klikając przycisk poniżej. Nie zapomnij potwierdzić!',
                button: 'Wyłączyć',
                modal: {
                    title: 'Wyłącz tryb konserwacji?',
                    text: 'Upewnij się, że prace techniczne zostały zakończone, a aplikacja będzie działać poprawnie. Aby ponownie udostępnić aplikację, kliknij przycisk poniżej',
                    button1: 'Wyłączyć',
                    button2: 'Anuluj',
                },
                toastSuccess: 'Tryb konserwacji Wył',
            },
        },
        adminAssignWhiteList: {
            screenTitle: 'Przypisz białą listę',
            button: 'Przypisz',
            title: 'Przypisz białą listę',
            text: 'Wprowadź portfel adres użytkownika i wybierz Ranking i Ilość NFT',
            rank: {
                label: 'Ranking NFT',
                placeHolder: 'Wybierz Rangę',
            },
            quantity: {
                label: 'Ilość',
            },
            modal: {
                screenTitle: 'Wybierz Rangę',
                title: 'Przypisz białą listę?',
                text: 'Sprawdź dokładnie wszystko: Ranking NFT i liczbę NFT, a także adres portfela. Powinieneś być pewny, kiedy potwierdzasz tę czynność, ponieważ nie można jej cofnąć',
                button1: 'Przypisz',
                button2: 'Anuluj',
            },
            toastSuccess: 'Whitelista została pomyślnie przypisana',
            error: {
                quantity: {
                    max: 'Maksymalna kwota {{quantity}}',
                    min: 'Minimalna kwota {{quantity}}',
                    numbers: 'Tylko liczby',
                },
                rank: 'Należy wybrać rangę',
            },
            toastError: 'Nie można znaleźć użytkownika',
        },
        adminAssignRole: {
            screenTitle: 'Przypisz rolę',
            button: 'Przypisz',
            title: 'Przypisz rolę',
            text: 'Wprowadź portfel adres użytkownika i rolę do przypisania',

            role: {
                label: 'Rola',
                placeHolder: 'Wybierz rolę',
            },
            roleModal: {
                title: 'Wybierz rolę',
            },
            attentionModal: {
                title: 'Przypisz rolę?',
                text: 'Dokładnie sprawdź wszystkie podane dane: adres portfela i rolę. Upewnij się, że nie popełniasz błędu. Tej czynności nie można cofnąć!',
                button1: 'Przypisz',
                button2: 'Anuluj',
            },
            error: {
                role: 'Należy wybrać rolę',
            },
            success: 'Rola została pomyślnie przypisana',
            toastError: 'Nie można znaleźć użytkownika',
            toastSuccess: 'Rola została pomyślnie przypisana',
        },
        walletInput: {
            label: 'Adres portfela',
            placeHolder: 'Wprowadź adres portfela',
        },
        walletInputError: 'Nie jest adresem portfela',
    },
    admin: {
        title: 'Administrator',
        verify: {
            title: 'Zweryfikuj użytkowników',
            subtitle: 'Zweryfikuj media społecznościowe użytkownika',
            text: 'Otwórz konto w mediach społecznościowych i podaj identyfikator zwierzęcia w celu pomyślnej weryfikacji',
            emptyTitle: 'Nie ma więcej zadań',
            emptyText: 'Nie ma dostępnych zadań do sprawdzenia, wróć później',
            messages: {
                error: 'Nieprawidłowy identyfikator zwierzęcia, spróbuj ponownie',
                success: 'Gratulacje! Użytkownik został zweryfikowany',
                notFound: 'Użytkownik zostaje odrzucony',
                failed: 'Wystąpił błąd, proszę zgłosić go do administratora',
            },
            modalPetIdNotFound: {
                title: 'Nie znaleziono identyfikatora zwierzęcia?',
                text: 'Prosimy o dokładne sprawdzenie Pet ID i jeśli nie jesteś w stanie zweryfikować, wybierz jeden z następujących powodów niepowodzenia weryfikacji',
                reasons: {
                    notEnoughFollowers: {
                        title: 'Not Enough Followers',
                        text: 'Your account is not active enough on social media, is not open and/or has few followers',
                    },
                    petIdNotFound: {
                        title: 'Pet ID Not Found',
                        text: 'Pet ID is not visible in the picture or has not been posted',
                    },
                    petIdIncorrectPosition: {
                        title: 'Pet ID Incorrect Position',
                        text: 'Pet ID is cropped or is incorrectly placed, so that it is not possible to see the code',
                    },
                    userNotFound: {
                        title: 'User Could Not Be Found',
                        text: 'The account with the post has been either deleted or linked incorrectly and can not be checked',
                    },
                },
                button1: 'Tak, potwierdzić',
            },
            label: 'Identyfikator zwierzęcia',
            placeHolder: 'Wprowadź identyfikator zwierzęcia',
            buttonVerify: 'Zweryfikuj',
            buttonNotFound: 'Nie znaleziono identyfikatora zwierzęcia',
            loadingVerifyUser: 'Sprawdzanie..',
            regexError: 'Dozwolone są tylko cyfry i znaki A-Z',
        },
    },
    socialMediaConnect: {
        addSocialAccount: 'Dodaj konto społecznościowe',
        selectAccountToShare: 'Wybierz konto do udostępnienia',
        select: 'Wybierz',
        connect: 'Połącz',
        disconnect: 'Odłączenie',
        unavailable: 'Obecnie niedostępny',
        status: {
            moderating:
                'Twoje konto zostało dodane i zostanie sprawdzone, gdy opublikujesz Pet ID za wykonanie zadania społecznościowego!',
            success:
                'Konto zostało pomyślnie zweryfikowane przez naszych moderatorów. Teraz możesz użyć go do wykonania zadania Socialize to Earn',
            reject: 'Konto nie zostało zatwierdzone przez naszych moderatorów. Prosimy o podłączenie konta zgodnego z naszym regulaminem',
        },
        modalTerms: {
            start: 'Podłączając konto społecznościowe wyrażam zgodę na ',
            and: ' oraz ',
            privacyPolicy: 'Polityka prywatności',
            termOfUse: 'Warunki użytkowania',
        },
        connectTiktokModal: {
            title: 'Połącz konto TikTok',
            label: 'Username',
            placeHolder: 'Wprowadź nazwę użytkownika',
            button: 'Połącz',
            errors: {
                notExist:
                    'To konto nie istnieje. Proszę wprowadzić poprawną nazwę użytkownika TikTok',
                somethingWrong: 'Coś poszło nie tak, proszę spróbować ponownie',
                likeFollowers:
                    'Za mało aktywności na koncie. Można podłączyć tylko konto live',
                cannotLoad:
                    'Nie można załadować konta użytkownika. Proszę spróbować ponownie',
                alreadyLinked:
                    'Podana nazwa użytkownika jest już używana przez innego użytkownika',
                notLinked: 'Konto jest już odłączone',
            },
        },
        socialPreview: {
            checkProfile: 'Sprawdź swój profil',
            takeALook: `Spójrz na poniższe konto w mediach społecznościowych i sprawdź, czy to Twoje konto`,
            view: 'Zobacz',
        },
        connectInstagramModal: {
            title: 'Połącz konto na Instagramie',
            label: 'Username',
            placeHolder: 'Wprowadź nazwę użytkownika',
            addAccount: 'To ja, dodaj konto',
            cancel: 'To nie ja, anuluj',
            button: 'Połącz',
            errors: {
                somethingWrong: 'Coś poszło nie tak, proszę spróbować ponownie',
                alreadyLinked:
                    'Podana nazwa użytkownika jest już używana przez innego użytkownika',
            },
            viaInstagram: 'lub Zaloguj się przez Instagram',
        },
        connectTwitterModal: {
            title: 'Połącz konto na Twitterze',
            label: 'Username',
            placeHolder: 'Wprowadź nazwę użytkownika',
            button: 'Połącz',
            errors: {
                notExist:
                    'To konto nie istnieje. Podaj poprawną nazwę użytkownika na Twitterze',
                alreadyLinked:
                    'Podana nazwa użytkownika jest już używana przez innego użytkownika',
                somethingWrong: 'Coś poszło nie tak, proszę spróbować ponownie',
            },
        },
        connectFacebookModal: {
            title: 'Połącz konto na Facebook',
            label: 'Username',
            placeHolder: 'Wprowadź nazwę użytkownika',
            button: 'Połącz',
            errors: {
                notExist:
                    'To konto nie istnieje. Podaj poprawną nazwę użytkownika na Facebook',
                alreadyLinked:
                    'Podana nazwa użytkownika jest już używana przez innego użytkownika',
                somethingWrong: 'Coś poszło nie tak, proszę spróbować ponownie',
            },
            via: 'lub Zaloguj się przez Facebook',
        },
        terms: {
            instagram: {
                one: 'Profil publiczny',
                two: 'Aktywne konto z co najmniej 100 followersami',
                three: 'Co najmniej 5 postów starszych niż 3 miesiące',
            },
            tikTok: {
                one: 'Co najmniej 500 zwolenników',
                two: 'Aktywne konto z co najmniej 5 filmami starszymi niż 3 miesiące',
                three: 'Co najmniej 500 polubień na koncie',
            },
            twitter: {
                one: 'Profil publiczny',
                two: 'Aktywne konto z co najmniej 500 followersami',
                three: 'Co najmniej 5 postów starszych niż 3 miesiące',
            },
            facebook: {
                one: 'Profil publiczny',
                two: 'Aktywne konto z co najmniej 100 znajomymi',
                three: 'Co najmniej 5 postów starszych niż 3 miesiące',
                four: 'Historie powinny być publiczne',
            },
        },
        errors: {
            duplicate: {
                title: 'Twój {{social}} jest już połączony z innym kontem',
                text: 'Twój profil w mediach społecznościowych jest połączony z innym kontem. Rozłącz go najpierw i spróbuj ponownie',
                button: 'Zamknij',
            },
            disconnect: {
                title: 'Odłączyć konto?',
                text: 'Stare konto zostanie automatycznie rozłączone jutro i będzie możliwość podłączenia nowego',
                button1: 'Tak, odłączyć',
                button2: 'Nie, zostaw',
            },
            userNameError:
                'Zabronione symbole. Dozwolone są tylko znaki łacińskie, cyfry, kropki i podkreślenia',
        },
        success: {
            linkInstagram: 'Instagram połączony pomyślnie',
            unLinkInstagram: 'Instagram odłączony',
            linkTiktok: 'Udane połączenie z TikTok',
            unLinkTiktok: 'TikTok rozłączony',
            linkTwitter: 'Udane połączenie z Twitterem',
            unLinkTwitter: 'Twitter odłączony',
            linkFacebook: 'Udane połączenie z Facebook',
            unLinkFacebook: 'Facebook odłączony',
        },
    },
    playTasksHistory: {
        title: 'Historia zadań',
        info: 'Tutaj możesz zobaczyć historię swoich zadań i postępy',
        historyCard: {
            SocialTask: 'Zadanie społeczne',
            VerificationTask: 'Znajdź zadanie',
            MoveTask: 'Chodzenie Zadanie',
            PlayTask: 'Rozgrywka Zadanie',
        },
        emptyState: {
            title: 'Nie ma jeszcze zadań',
            text: 'Nie wykonałeś jeszcze żadnego z codziennych zadań. Ale to nie problem, zróbmy to teraz',
            button: 'Zacznij grać',
        },
        historyTaskDetails: {
            title: 'Szczegóły zadania',
            text: 'Zebrana energia zostanie zamieniona na tokeny w Twoim portfelu nagród. Zobacz więcej szczegółów na temat zadań poniżej',
            collectedEnergy: '{{earnedEnergy}} / {{maxEnergy}} Zebrana energia',
            viewRewardWaller: 'Przejdź do nagród',
            details: {
                type: 'Typ:',
                type_SocialTask: 'Zadanie społeczne',
                type_VerificationTask: 'Znajdź zwierzaków',
                type_MoveTask: 'Spacer',
                type_PlayTask: 'Gra',
                petExp: 'Zebrane doświadczenie:',
                exp: '{{exp}} XP',
                date: 'Data:',
            },
        },
    },
    successTaskEnergyBlock: {
        text: 'Energia',
        collectedEnergy: '{{earnedEnergy}} / {{maxEnergy}} Zebrana energia',
    },
    successTaskPetsExp: {
        text: 'Zebrane XP',
        collectedExp: '{{collectedExp}} XP',
    },
    checkout: {
        title: 'Weryfikuj transakcję',
        text: 'Sprawdź dwukrotnie informacje i potwierdź transakcję',
        confirm: 'Potwierdzenie i zakup',
        try: 'Spróbuj jeszcze raz',
        cancel: 'Anuluj',
        purchasingFrom: 'Sposób płatności',
        available: 'Saldo',
        deposit: 'Wpłać',
        wallet: '{{coin}} Portfel',
        loadingPurchasing:
            'Finalizuję transakcję, proszę nie zamykać aplikacji..',
        free: 'Free',
        whiteList: 'Whitelist (1)',
        explorerUrl: 'Zobacz na BscScan',
        fields: {
            transaction: 'Transakcja',
            value: 'Wartość',
            amount: 'Kwota',
            totalSummary: 'Podsumowanie',
            from: 'Z (Portfela)',
            to: 'Na adres',
            fee: 'Prowizja sieci',
            modalTitle: 'Potwierdzenie Claima',
            toWallet: 'Do (Portfel)',
            gamingWallet: 'Portfel dla graczy',
            mainWallet: 'Główny portfel',
            confirm: 'Potwierdzić',
            commissionFee: 'Prowizji',
            nft: 'NFT',
            nftWallet: 'Portfel NFT',
            nftMarketplace: 'Rynek NFT',
        },
        errors: {
            notEnoughCoinFunds:
                'Za mało środków. Wprowadź środki do swojego portfela',
            notEnoughCoinFundsMulti:
                'Za mało środków. Wybierz inną opcję płatności lub wpłać środki do portfela',
            bnbNotEnough:
                'Za mało BNB na Twoim saldzie, aby pokryć prowizję sieci. Proszę wpłacić BNB do portfela',
            notEnoughBalanceFunds: 'Niewystarczające fundusze',
            notEnoughBalanceFundsMulti:
                'Za mało środków. Wybierz inną opcję płatności',
            insufficientVirtualBalance:
                'Niewystarczająca ilość środków na wirtualnym saldzie',
        },
        purchasingFromCoins: {
            coins: 'Tokeny',
            virtual: 'E-Wallet',
            inapp: { ios: 'Apple', android: 'Google Pay' },
        },
        storePurchase: {
            loadings: {
                PURCHASE:
                    'Po zakończeniu płatności, proszę nie zamykać aplikacji..',
                FINALIZE:
                    'Finalizując transakcję, proszę nie zamykać aplikacji..',
            },
            button: 'Dobra',
            storePurchaseError: {
                PURCHASE: {
                    title: 'Coś poszło nie tak',
                    message:
                        'Coś poszło nie tak podczas procesu zakupu. Proszę spróbować ponownie\n' +
                        'Kod błędu: {{code}}',
                },
                FINALIZE: {
                    title: 'Coś poszło nie tak',
                    message:
                        'Coś poszło nie tak podczas finalizowania transakcji. Proszę spróbować ponownie',
                },
            },
        },
    },
    charity: {
        title: 'Charytatywnie',
        description:
            'Użytkownicy IguVerse przekazują darowizny ze swoich codziennych dochodów na rzecz jednej, wybranej wcześniej organizacji charytatywnej',
        current: 'Mój wybór',
        dailyDonation: 'Codzienne darowizny z Twoich nagród',
        howItWorks: 'Jak to działa?',
        selectedOrganization: 'Wybrana organizacja',
        edit: 'Edytuj',
        organizations: 'Organizacje',
        viewAll: 'Zobacz wszystkie',
        donated: 'przekazano',
        buttonSave: 'Zapisz',
        loadingPercentage: 'Przetwarzanie..',
        saveSuccess: 'Zmieniono procentowy udział dziennych darowizn',
        organizationsTitle: 'Wszystkie organizacje',
        infoRows: {
            address: 'Adres',
            website: 'Strona',
            email: 'Email',
            instagram: 'Instagram',
            twitter: 'Twitter',
        },
        readMore: 'Czytać więcej',
        hide: 'Ukryj',
        donations: 'Darowizny',
        totalSummary: 'Podsumowanie ogółem',
        time: {
            minuteAgo: 'minutę temu',
            minutesAgo: 'minuty temu',
            hourAgo: 'godzinę temu',
            hoursAgo: 'godziny temu',
            dayAgo: 'dzień temu',
            daysAgo: 'dni temu',
        },
        payout: 'Wypłata na cele charytatywne',
        noDonations: 'Nie ma jeszcze darowizn',
        allDonations: 'Wszystkie darowizny',
        modals: {
            confirmPercentage: {
                title: 'Potwierdź swoje działanie',
                text: 'Procent darowizny wpłynie na Twoje zarobki i przekaże je bezpośrednio do organizacji charytatywnej, czy na pewno chcesz zmienić procent darowizny?',
            },
        },
        editOrganization: 'Organizacja',
        editOrganizationNotChosen:
            'Musisz wybrać minimum jedną organizację, której chcesz przekazać darowiznę',
        loadingOrganizationChange: 'Przetwarzanie..',
        changeOrganizationSuccess: 'Uratowana organizacja charytatywna',
        organizationDetails: 'Szczegóły dotyczące organizacji',
        selectDescription: 'Wybierz organizację z poniższej listy',
        chooseOrganization: 'Wybierz organizację',
    },
    Marketplace: {
        title: 'Rynek',
        text: 'Możesz kupować lub sprzedawać zwierzęta innym użytkownikom na rynku',
        description: 'Już wkrótce',
    },
    Feed: {
        title: 'Social Feed',
        text: 'Możesz zobaczyć wszystkie dostępne zwierzęta i wejść z nimi w interakcję',
        description: 'Już wkrótce',
    },
    Leaderboard: {
        [ROUTES.LEADERBOARD_DAILY_TASKS]: {
            title: 'Liderzy zadań',
            text: 'Śledź postępy innych użytkowników i rywalizuj z nimi wykonując codzienne zadania',
            emptyList: {
                title: 'Brak użytkowników w Liderzy zadań',
                text: 'Przykro mi to mówić, ale żaden użytkownik nie wykonał jeszcze żadnego zadania. Ale bez obaw, zostanie to szybko naprawione',
            },
            energy: 'Zebrana energia',
            task: 'Zadania zakończone',
        },
        [ROUTES.LEADERBOARD_PVP_GAMES]: {
            title: 'Liderzy PvP',
            text: 'Śledź postępy innych użytkowników i rywalizuj, wygrywając gry PvP',
            emptyList: {
                title: 'Brak użytkowników w Liderzy PvP',
                text: 'Przykro mi to mówić, ale żaden użytkownik nie wykonał jeszcze żadnego gry. Ale bez obaw, zostanie to szybko naprawione',
            },
            turnover: 'Obroty IGU',
            totalTurnover: 'Całkowity Obroty IGU',
            pnl: 'PNL (zwycięstwa/porażki)',
            games: 'Rozegrane gry',
        },
        emptyScreen: {
            title: 'Ups!',
            text: 'Coś nie tak. Ale bez obaw, zostanie to szybko naprawione. Spróbuj pociągnąć.',
        },
    },

    playCollectedExperience: {
        screenTitle: 'Zebrane doświadczenia',
        title: 'Doświadczenie (XP)',
        text: 'Po wykonaniu zadania Twoje zwierzaki zebrały nowe XP, aby przejść do kolejnego poziomu',
    },
    playSuccessScreen: {
        button: 'Zobacz więcej zadań',
        button2: 'Powrót do głównej',
        emptyStates: {
            VERIFY: {
                title: 'Znajdź zadanie zakończone',
                text: 'Gratulacje! Ukończyłeś zadanie Wyszukiwania na dźisiaj. Wróć jutro po więcej',
                failTitle: 'Wyszukiwanie nie powiodło się',
                failText:
                    'Nie udało ci się znaleźć zwierzaków na dziś. Wróć jutro po więcej',
            },
            MOVE: {
                title: 'Spacer ukończony',
                text: 'Gratulacje! Przeszedłeś dystans w określonym czasie, i wykonałeś zadanie. Wróć jutro po więcej',
                failTitle: 'Zadanie spacerowe nie powiodło się',
                failText:
                    'Nie udało ci się wykonać zadania spacerowego na dziś. Wróć jutro i spróbuj lepiej',
            },
            SOCIAL: {
                title: 'Zadanie społeczne zakończone',
                text: 'Gratulacje! Udostępniłeś zdjęcie i przeszło ono weryfikację. Wróć jutro po więcej',
            },
            PLAY: {
                title: 'Gra zakończona',
                text: 'Gratulacje! Ukończyłeś grę na dziś. Wróć po więcej jutro',
                failTitle: 'Gra nie powiodła się',
                failText:
                    'Niestety nie udało Ci się przejść gry. Następnym razem postaraj się lepiej',
            },
        },
    },
    general: {
        howItWorks: 'Jak to działa',
        comingSoon: 'Już wkrótce',
        comingSoonDesc: 'Ta funkcja nie jest jeszcze gotowa.',
        copiedToClipboard: 'Skopiowane do schowka',
        createPet: 'Stwórz zwierzaka',
        next: 'Następny',
        or: 'lub',
        ok: 'OK',
        loading: 'Ładowanie..',
        loadMore: 'Załaduj więcej',
        errors: {
            unknown: {
                title: 'Nieznany błąd',
                message: 'Proszę spróbować ponownie',
            },
            error: { title: 'Błąd' },
            networkRequestFailed: {
                title: 'Błąd sieci',
                message: 'Żądanie sieci nie powiodło się. Spróbuj ponownie',
            },
            TASK_WRONG_STATE: {
                title: 'Błąd',
                message: 'Zadanie wygasło, proszę spróbować ponownie',
            },
            TASK_CREATE_FORBIDDEN: {
                title: 'Błąd',
                message: 'Zadanie wygasło, proszę spróbować ponownie',
            },
            UNPREDICTABLE_GAS_LIMIT: {
                title: 'Problemy z portfelem',
                message:
                    'Nie można oszacować prowizji dla sieci, transakcja nie przejdzie. Upewnij się, że masz wystarczająco dużo środków i BNB, aby pokryć prowizję, a następnie spróbuj ponownie',
            },
            INSUFFICIENT_FUNDS: {
                title: 'Niewystarczające fundusze',
                message:
                    'Upewnij się, że masz wystarczająco dużo środków i BNB, aby pokryć opłatę transakcyjną. Wprowadź kryptowalutę do portfela i spróbuj ponownie',
            },
            fileIsTooBig: {
                title: 'Plik jest zbyt duży',
                text: 'Plik obrazu musi być mniejszy niż {{size}} MB',
            },
            cantOpenUrl: {
                text: 'Twoje urządzenie nie może otworzyć adresu URL {{url}}. Skopiuj adres URL i wykonaj go ręcznie',
            },
            gameAlreadyStarted: {
                text1: 'Gra już się rozpoczęła',
                text2: 'Proszę wybrać inną grę',
            },
            gameBanned: {
                text1: 'Dostałeś bana w tej grze',
                text2: 'Poczekaj na dalsze powiadomienia',
            },
            wrongGameStatus: {
                text: 'Nieprawidłowy status gry',
            },
            emptyErrorScreen: {
                title: 'Ups!',
                text: 'Coś nie tak. Ale bez obaw, zostanie to szybko naprawione',
            },
            ops: {
                text1: 'Ups!',
                text2: 'Coś poszło nie tak :(',
            },
        },
        success: { title: 'Sukces' },
        socialLoading: 'Linkowanie..',
        cancel: 'Anuluj',
        back: 'Powrót',
        current: 'Aktualne',
        knowledgeBaseButton: 'Dowiedz się więcej w bazie wiedzy',
        timerTitle: 'Pozostały czas',
        hint: '{{hint}}/{{maxHints}} Wskazówki',
        continue: 'Kontynuuj',
        skip: 'Pomiń',
        BUTTONS: {
            mintNewNft: 'Stwórz nowego zwierzaka',
            continue: 'Kontynuuj',
            continueLater: 'Kontynuuj później',
            mintNft: 'Stwórz zwierzaka',
            select: 'Wybierz',
            startPlaying: 'Zacznij grać',
            start: 'Rozpocznij',
            learnMore: 'Dowiedz się więcej',
            playPvpGames: 'Graj w gry PVP',
            goToWallet: 'Przejdź do portfela',
            createNewOrder: 'Utwórz nowe zamówienie',
            apply: 'Zastosuj',
            clear: 'Wyczyść',
            viewProfile: 'Wyświetl profil',
            buyForWithAmount: 'Kup za {{amount}}',
            cancel: 'Anuluj',
            delistNft: 'Usunąć zlecenia',
            delist: 'Usunąć',
            viewMarketplace: 'Wyświetl Marketplace',
            getStarted: 'Rozpocznij',
            reloadApp: 'Przeładuj aplikację',
            createNewGame: 'Stwórz nową grę',
            exploreMoreGames: 'Odkryj więcej gier',
            viewGamesHistory: 'Zobacz historię gier',
            viewStatistics: 'Wyświetl statystyki',
            tryAgain: 'Spróbuj jeszcze raz',
            createGame: 'Tworzyć grę',
            topUpBalance: 'Uzupełnij saldo',
            continueToNextStep: 'Przejdź do następnego kroku',
            continueShopping: 'Kontynuować zakupy',
            enableNow: 'Włącz teraz',
            maybeLater: 'Może później',
            backToSettings: 'Powrót do ustawień',
            turnOff: 'Wyłączyć',
            purchaseFor: 'Zakup na {{amount}}',
            purchase: 'Zakup',
            viewAll: 'Wyświetl wszystko',
            view: 'Zobacz',
            purchaseMore: 'Kup Więcej',
            viewDetails: 'Zobacz szczegóły',
            readMore: 'Czytaj więcej',
            hide: 'Ukryj',
            viewChart: 'Zobacz wykres',
        },
        KEYS: {
            ranks: 'Szeregi',
            price: 'Cena',
            chance: 'Szansa',
            rank: 'Rank',
            sortedBy: 'Posortowane według',
            typeOfNft: 'Typ NFT',
            totalSummary: 'Całkowite podsumowanie',
            totalSuccessfulOrders: 'Całkowite udane zamówienia',
            totalPurchasesSummary: 'Podsumowanie zakupów ogółem',
            NFTs: 'NFTs',
            profile: 'Profil',
            details: 'Szczegóły',
            numberAndLevel: '{{level}} Level',
            numberAndHealth: '{{health}} Zdrowie',
            deadByAge: 'Zwierzę było stare i umarło',
            numberAndDaysAge: '{{days}} Dni wiek',
            yourNFT: 'Twoje NFT',
            vs: 'VS',
            opponentsNFT: 'NFT wroga',
            yourPoints: 'Twoje punkty',
            opponentsPoints: 'Punkty wroga',
            type: 'Typ',
            gameSettings: 'Ustawienia gry',
            difficulty: 'Złożoność',
            mode: 'Tryb',
            livesCount: 'Liczba żyć',
            yourAccount: 'Twoje konto',
            leaderboardPlace: 'Miejsce w tabeli liderów',
            timeLeft: 'Pozostały czas',
            ticketsAmount: 'Ilość biletów',
            tickets: 'Bilety',
            winner: 'Zwycięzca',
            prizes: 'Nagrody',
            won: 'Wygrana',
            hash: 'Hash',
            date: 'Data',
            roundId: 'ID Rundy',
            chainResults: 'Wyniki',
            globalSeed: 'Globalne znaczenie',
            gamesHistory: 'Historia gier',
            users: 'Użytkownicy',
        },
        FILTERS: {
            byDate: {
                Day: 'Ostatnie 24 godziny',
                Week: 'Ostatnie 7 dni',
                Month: 'Ostatnie 30 dni',
            },
        },
        ALERTS: {
            notEnoughCoinsOnGamingWallet:
                'Za mało tokenów w portfelu gry, aby dołączyć do gry. Doładuj swoje konto, aby zacząć grać',
        },
        MERGED: {
            selectText: 'Wybierz {{text}}',
        },
        DECLINATION: {
            Ticket: {
                one: 'Bilet',
                two: 'Bilety',
                five: 'Biletów',
            },
        },
    },
    modal: {
        mintPetLeave: {
            title: 'Chcesz odejść?',
            text: 'Prawie skończyłeś tworzyć swojego zwierzaka. Nie poddawaj się teraz!',
            keep: 'Ukoncz tworzenie zwierzaka',
            leave: 'Tak, zostaw',
        },
        ModalFreeRank: {
            title: 'Brakuje Ci ogromnego bonusu!',
            text: 'Jesteś pewien, że chcesz przegapić {{amount}} IGUP (${{dollarValue}}) bonus za stworzenie zwierzaka najwyższego rangu?',
            highest: 'Zdobądź mój bonus',
            proceed: 'Postępowanie bez premii',
        },
        askForPermissions: 'Zapytaj o pozwolenie',
        goToSettings: 'Przejdź do ustawień',
        try: 'Spróbuj jeszcze raz',
        cancel: 'Anuluj',
        deletePhoto: 'Usunąć zdjęcie NFT?',
        deletePhotoInfo: 'Czy na pewno chcesz usunąć swoje zdjęcie?',
        yesDelete: 'Tak, usuń',
        noCancel: 'Nie, Anuluj',
        changeRank: 'Czy chcesz zmienić rangę?',
        changeRankInfo:
            'Zostaniesz przeniesiony do pierwszego kroku procesu menniczego',
        changeRankGo: 'Zmiana Ranga',
        upgradeRank: {
            title: 'Aktualizacja do rangi "{{slug}}"',
            text: 'Niektóre funkcje są odblokowane z wyższą rangą. Podnieś swoją rangę, aby uzyskać dostęp do tej funkcji',
            upgradeToRank: 'Podniesienie rangi',
        },
        savingName:
            'Zapisywanie nazwy, zajmuje trochę czasu. Proszę nie zamykać aplikacji',
        generatingNFT: 'Robi trochę magii. Zwykle trwa to do kilku minut..',
        generateNewNFT: {
            title: 'Wrócić do poprzedniego kroku?',
            text: 'Zostaniesz odesłany z powrotem i stracisz swoje dotychczasowe postępy. Twoje zwierzę jest unikalne, nie będziemy w stanie stworzyć dokładnie takiego samego',
            yesGenerate: 'Tak, zabierz mnie z powrotem',
            noKeep: 'Nie, zostań tutaj',
        },
        askForCameraPermissions: {
            title: 'Brak uprawnień dla kamery',
            text: 'Musisz przyznać uprawnienia dla kamery, aby móc korzystać z tej funkcji',
        },
        askForLocationPermissions: {
            title: 'Brak uprawnień do lokalizacji',
            text: 'Aby móc korzystać z tej funkcji, należy nadać uprawnienia do lokalizacji',
        },
        askForCameraRollPermissions: {
            title: 'Brak uprawnień dla rolki aparatu',
            text: 'Musisz przyznać uprawnienia dla Rolki z aparatu, aby móc korzystać z tej funkcji',
        },
        askForLocationPermissionsWeb: {
            title: 'Brak uprawnień do lokalizacji',
            text: 'Aby móc korzystać z tej funkcji, należy nadać uprawnienia do lokalizacji',
            additionalText:
                '. Przejdź do ustawień i włącz uprawnienia dla lokalizacji',
            button: 'Zamknij',
        },
        nftPreview: {
            title: 'NFT Preview',
            text: 'To zapowiedź twojego zwierzaka',
        },
        confirmation: {
            title: 'Jesteś pewien?',
            text: 'Proszę potwierdzić swoje działanie, aby kontynuować',
            yes: 'Tak, potwierdzić',
            cancel: 'Anuluj',
        },
        modalChangeLanguage: {
            screenTitle: 'Zmiana języka',
            button: 'Zmiana',
        },
    },
    navigationBar: {
        wallet: {
            MAIN: 'Główny',
            NFT: 'NFT',
            REWARDS: 'Nagrody',
            GAMING: 'Gry',
        },
        tasks: { active: 'Bieżące', history: 'Historia' },
        admin: { verify: 'Zweryfikuj', dashboard: 'Dashboard' },
        referrals: { invites: 'Program referalny', all: 'Moi poleceni' },
        collections: { collection: 'Kolekcja', mystery: 'Pudełka' },
        tooltip:
            'To jest Twój portfel. Kliknij tutaj, aby wejść wewnątrz i zobaczyć swoje nagrody. W tej zakładce możesz wypłacać, wpłacać, claimować i wymieniać tokeny',
    },
    AppState: {
        GameMaintenanceState: {
            title: 'Prace techniczne w Grze',
            text: 'Zadania IguVerse są w trakcie konserwacji i obecnie niedostępne. Przepraszamy za niedogodności i wracamy wkrótce',
            button: 'OK',
        },
        FullMaintenanceState: {
            title: 'Aplikacja jest w trakcie prac technicznych',
            text: 'Aplikacja IguVerse jest w trakcie konserwacji i obecnie niedostępna. Przepraszamy za niedogodności i wracamy wkrótce. Bądź w kontakcie w naszych mediach społecznościowych',
        },
        GlobalErrorState: {
            title: 'Nieplanowane prace techniczne',
            text: 'IguVerse App jest w trakcie rozwoju i obecnie mamy nieplanowane prace techniczne. Przepraszamy za niedogodności i wracamy wkrótce',
            button: 'Przeładować',
        },
        UpdateRequiredState: {
            title: 'Dostępna aktualizacja',
            text: 'Ta wersja aplikacji jest nieaktualna, proszę zaktualizować aplikację z {{store}} Store, aby nadal z niej korzystać',
            button: 'Aktualizacja',
            cancel: 'Nie teraz',
            error: 'Nie możesz otworzyć linku, otwórz ręcznie {{store}} Store i pobierz najnowszą wersję gry',
        },
        UpdateRequiredStateWeb: {
            title: 'Aktualizacja aplikacji..',
            text: 'Aplikacja jest obecnie w trakcie aktualizacji, proszę spróbować ponownie za kilka minut',
            button: 'Spróbuj ponownie',
        },
        NoNetworkConnectionState: {
            title: 'Brak połączenia',
            text: 'Wygląda na to, że masz problemy z połączeniem internetowym. Internet jest wymagany do prawidłowego działania aplikacji',
            button: 'Got It',
            reconnected: 'Ponownie połączony!',
            reconnecting: 'Połączenie utracone. Ponowne połączenie..',
        },
    },
    ranks: {
        rankLongTitle: '{{rank}} Ranga',
        level: '{{level}} LVL',
        upgradeRankButton: 'Upgrade Rangi',
        upgradeText:
            'Osiągnąłeś wszystkie poziomy w swojej obecnej Randze. Nadszedł czas, aby podnieść rangę do {{rank}} i zwiększyć swoją wydajność',
        lockedText:
            '{{rank}} Ranga nie jest dostępna dla mennicy. Można ją osiągnąć poprzez zdobywanie poziomów i postępy w grze',
        perDay: 'Codziennie',
        dailyUnlock: 'Codzienne odblokowanie',
        foodConsumption: 'Dzienne spożycie',
        maxAge: 'Max. Wiek',
        days: 'Dni',
        list: {
            free: {
                title: 'Free',
                infoText:
                    'Ranga Free daje Ci możliwość poznania aplikacji i jej funkcji. Nie możesz jednak otrzymywać i wypłacać nagród, dopóki nie kupisz NFT lub nie podniesiesz rangi darmowego zwierzaka',
            },
            starter: { title: 'Starter' },
            common: { title: 'Common' },
            uncommon: { title: 'Uncommon' },
            unusual: { title: 'Unusual' },
            rare: { title: 'Rare' },
            mystical: { title: 'Mystical' },
            legendary: { title: 'Legendary' },
            epic: { title: 'Epic' },
            exotic: { title: 'Exotic' },
            royal: { title: 'Royal' },
            diamond: { title: 'Diamond' },
        },
        ranksDetailedInfoScreen: {
            button: 'Stwórz zwierzaka',
            current: 'Aktualne',
        },
        rankDetailedInfo: {
            reward: {
                title: 'Nagroda dzienna ≈ {{reward}} ≈ {{usd}}',
                text: 'Szacowana dzienna nagroda w tokenach, jeśli wszystkie zadania dzienne zostaną wykonane',
                warning:
                    'Wartość ta jest jedynie szacunkową oceną możliwości zarobkowych zwierzęcia i może się różnić',
                warningFree:
                    'Ranga Free ma losową szansę na zdobycie nagrody w grze. Nie ma gwarantowanych nagród dla rangi Free',
            },
            rate: {
                title: 'Dzienny wskaźnik odblokowania ≈ {{reward}} ({{rate}}) ≈ {{usd}}',
                text: 'Możesz przekazać {{percent}}% swoich dostępnych nagród VIGUP do swojego głównego portfela. Po złożeniu wniosku, token może zostać wymieniony, wysłany do innego portfela lub wycofany',
                alert: 'Pozostałe tokeny VIGUP są w toku i będą przechowywane w zablokowanym portfelu',
            },
            consumption: {
                title: 'Spożycie żywności = {{consumption}}',
                text: 'Twój zwierzak codziennie zużywa tokeny. Jeśli zwierzę nie jest karmione na czas, traci zdrowie i może umrzeć',
            },
            age: {
                title: 'Maksymalny wiek = {{maxAge}} dni',
                text: 'Gdy twój NFT osiągnie ten wiek, on umrze i będzie musiał zostać ożywiony',
                alert: 'Wyższa Ranga zresetuje wiek twojego NFT z powrotem do 0, a ulepszony wirtualny zwierzak będzie żył zgodnie z limitem wiekowym nowej rangi. Po ożywieniu NFT zaczniesz od pierwszego poziom',
            },
        },
        modalWhatIsRank: {
            title: 'Co to jest Rank?',
            text: 'Ranga wpływa na możliwości zarobkowe Twojego zwierzaka i inne ważne cechy, takie jak dzienny wskaźnik odblokowania i wskaźnik zużycia karmu przez zwierzaka. Im wyższa ranga, tym lepsze charakterystyki',
            buttonAvailable: 'Zobacz dostępne rangi',
            buttonAll: 'Wyświetl wszystkie rangi',
        },
        checkoutUpgradeRank: {
            title: 'Zwiększ rangę',
            text: 'Im wyższa ranga, tym więcej nagród zdobędzie Twój zwierzak',
            upgradeTo: 'Upgrade do',
            transaction: 'Podwyższenie rangi do {{rank}} dla "{{name}}" NFT',
        },
        successUpgradeRank: {
            title: 'Ranga podniesiona!',
            text: 'Ranga NFT została pomyślnie podniesiona. Wykonuj codzienne zadania i zdobywaj jeszcze więcej nagród',
            backToPet: 'Zobacz zwierzaka',
        },
    },
    localNotifications: {
        moveToEarnFinished: {
            title: 'Zadanie spacerowe zakończone',
            message: 'Otwórz aplikację i zobacz ile energii zebrałeś',
        },
        noPets: {
            title: 'Pospiesz się, żeby dostać swojego zwierzaka',
            message:
                'Zdobądź swoje pierwsze zwierzę i rozpocznij niesamowitą podróż w IguVerse',
        },
    },
    monthPicker: {
        month1: 'Styczeń',
        month2: 'Luty',
        month3: 'Marzec',
        month4: 'Kwiecień',
        month5: 'Maj',
        month6: 'Czerwiec',
        month7: 'Lipiec',
        month8: 'Sierpień',
        month9: 'Wrzesień',
        month10: 'Październik',
        month11: 'Listopad',
        month12: 'Grudzień',
        selectMonth: 'Wybierz',
    },
    staking: {
        stakeLoading: 'Włącza się boost, nie zamykaj aplikacji...',
        unStakeLoading: 'Włącza się boost, nie zamykaj aplikacji...',
        general: {
            dailyBoost: 'Dzienny Boost',
            ended: 'Data zakończenia',
            summary: 'Razem',
            days: '{{days}} Dni',
            current: 'Boost teraz',
        },
        plans: {
            title: 'Szczegóły opcji',
            text: 'Każdy opcje boostera określa okres blokady i premię',
            days: ' Dni',
            boost: 'Zwiększenie do {{boost}}%',
        },
        welcomeScreen: {
            title: 'Boost',
            headerTitleStart: 'Zarabiaj ',
            headerTitleCenter: 'do {{number}}%',
            headerTitleEnd: ' z boostem',
            headerText:
                'Możesz zwiększyć nagrody w głównej grze za pomocą boostera, zamrażając tokeny na określony czas',
            stake: {
                title: 'Opcje boostera',
                text: 'Inwestować swoje tokeny IGU lub IGUP i otrzymuj różne bonusy',
            },
            lock: {
                title: 'Okres blokady',
                text: 'Twoje tokeny zostaną zamrożone na czas określony w opcji boostera',
            },
            calculation: {
                title: 'Obliczenie boostu',
                text: 'Boost jest przeliczany każdego dnia w zależności od wybranej opcji boostera',
                alert: 'Jeśli zmieniają się Twoje nagrody (inna ilość zwierzaków, ich zdrowie), zmieni się również boost. Zawsze będzie można zobaczyć aktualną wartość boostu',
            },
            button: 'Włącz boost',
        },
        optionsScreen: {
            toastAlready: 'Ta opcja boostera jest już włączona',
            button: 'Kontynuuj',
            screenTitle: 'Opcje boostera',
            title: 'Wybierz opcję boosta',
            text: 'Wybierz opcję boosta dla swoich tokenów. Można korzystać z wielu opcji jednocześnie.',
            IGUP: {
                title: 'Boost za IGUP',
                text: 'Zablokuj swój IGUP na pewien okres czasu i otrzymaj boost do nagród dziennych za granie',
            },
        },
        plansScreen: {
            button: 'Kontynuuj',
            selectPlan: 'Wybierz opcję',
            title: 'Wybierz opcję boostera',
            headerTitle: 'Wybierz opcję',
            headerText:
                'Kwota, którą wybierzesz, zostanie zablokowana w smart kontrakcie do końca okresu',
            headerInfoText: 'Który plan wybrać?',
            lock: {
                title: 'Okres blokady = {{days}} dni',
                description:
                    'Okres blokady to okres, w którym Twoje tokeny będą zablokowane, a bonus będzie aktywny',
            },
            boost: {
                title: 'Zwiększenie nagród = ~{{boost}} %',
                description:
                    'Zwiększenie nagród jest modyfikatorem, który zwiększa Twoje nagrody w grze o pewien procent',
            },
            calculation: {
                title: 'Codzienny wzrost = ~{{boost}} %',
                description:
                    'Boost jest przeliczany każdego dnia w zależności od wybranej opcji boostera',
                alert: 'Jeśli zmieniły się Twoje nagrody, zmieni się również boost. Zawsze będziesz mógł zobaczyć aktualny boost',
            },
        },
        coinsInputScreen: {
            title: 'Wybierz ilość tokenów',
            button: 'Przedź do obliczeń',
            button2: 'Pomiń krok',
            loading: 'Obliczanie dziennego boostu..',
            available: 'Dostępne ',
            maxButton: 'Max',
            errors: {
                digits: 'Muszą być tylko cyfry',
                max: 'Za mało tokenów na saldzie. Wprowadź inną kwotę lub wpłatę',
                min: 'Liczba tokenów powinna wynosić co najmniej {{limit}} {{coin}}',
                maxStack:
                    'Liczba tokenów nie powinna być większa {{limit}} {{coin}}',
            },
            maxBoost:
                'Inwestować {{amount}} {{coin}} aby otrzymać {{boost}}% podwyżki',
            maxBoostModal: {
                title: 'Maksymalizuj swoje wzmocnienie',
                text: 'Wybierz proponowaną kwotę i uzyskaj najwyższy możliwy boost!',
                button: 'Dodaj monety',
                deposit: {
                    title: 'Optymalny depozyt = {{amount}} {{coin}}',
                    text: 'Optymalna liczba tokenów dla najwyższej wydajności. Wartość zależy od liczby zwierzaków i ich statystyk',
                },
                boost: {
                    title: 'Maksymalna dzienna premia = {{boost}}%',
                    text: 'Stawiany jest dzienny boost po optymalnym depozycie. Wzmocnienie będzie przeliczane każdego dnia w zależności od statystyk twoich zwierzaków. W razie potrzeby zawsze możesz dodać tokeny!',
                },
            },
        },
        dailyBoostScreen: {
            title: 'Daily Boost',
            headerTitle: 'Daily Boost = ',
            headerText:
                'Boost będzie obowiązywać przez pewien czas, po którym będziesz mógł odebrać tokeny',
            button: 'Potwierdź',
            confirmationModal: {
                title: 'Potwierdzenie transakcji',
                keys: {
                    from: 'Ze portfela',
                    duration: 'Czas trwania',
                    endingOn: 'Data zakończenia',
                    dailyBoost: 'Daily Boost',
                    summary: 'Kwota',
                },
                values: {
                    from: 'Główny portfel',
                    duration: '{{plan}}, {{days}} Dni',
                },
            },
        },
        successScreen: {
            title: 'Tokeny, które zostały pomyślnie zablokowane',
            text: 'Twoje tokeny są zainwestowano i będą utrzymywane do końca planu. Po zakończeniu planu, należy użyć przycisku "Pobierz tokeny", aby zwolnić tokeny z powrotem do portfela',
            button: 'Powrót do portfela',
        },
        successUnStakeScreen: {
            title: 'Tokeny zostały odblokowane',
            text: 'Udało Ci się odblokować tokeny. Tokeny są zwracane do Twojego głównego portfela',
            button: 'Powrót do portfela',
        },
        alreadyScreen: {
            title: 'Boost',
            headerTitle: 'Szczegóły planu',
            headerText:
                'Masz swoje tokeny już zainwestowano i one będą utrzymywane do końca planu. Po zakończeniu planu, tokeny mogą zostać uwolnione do portfela głównego',
            headerInfoText: 'Jak to działa?',

            confirmationModal: {
                title: 'Potwierdzenie transakcji',
                keys: {
                    from: 'Do Portfela',
                    duration: 'Czas trwania',
                    endingOn: 'Skończyło się na',
                    dailyBoost: 'Daily Boost',
                    summary: 'Podsumowanie',
                },
                values: {
                    from: 'Portfel nagród',
                    duration: '{{plan}}, {{days}} Dni',
                },
            },
            staked: {
                title: '{{coin}} Boost',
                text: 'Aktywny plan. Możesz dodać więcej tokenów',
                timerTitle: 'Pozostały czas',
                staking: 'Boost:',
                deposit: 'Start:',
                end: 'Kończy się:',
                boost: 'Boost:',
                summary: 'Podsumowanie:',
                buttonAdd: 'Dodaj więcej tokenów',
                buttonUpgrade: 'Upgrade',
                buttonUnstake: 'Pobierz tokeny',

                modalAddCoins: {
                    title: 'Chcesz dodać więcej tokenów?',
                    text: 'Po dodaniu tokenów opcja boosta zostanie ponownie obliczona na podstawie wpłaconej kwoty, a licznik czasu uruchomi się ponownie',
                    button1: 'Dodaj tokeny',
                    button2: 'Anuluj',
                },
                modalUpgrade: {
                    title: 'Plan modernizacji?',
                    text: 'Po dodaniu tokenów opcja doładowania zostanie ponownie obliczona na podstawie wpłaconej kwoty, a licznik czasu uruchomi się ponownie',
                    button1: 'Aktualizacja',
                    button2: 'Anuluj',
                },
            },
        },
    },
    timer: {
        captions: { day: 'Dni', hour: 'Godziny', min: 'Min', sec: 'Sek' },
        newDay: 'Nowy dzień',
        refreshed: 'Twoje zadania odświeżone',
    },
    referrals: {
        myReferrer: 'Jesteś zaproszony(a) przez tego użytkownika',
        referralCode: 'Twój kod',
        referralLink: 'Twój link',
        header: {
            title: 'Zaproś użytkowników',
            text: 'Zaproś innych użytkowników i zarabiaj jeszcze więcej dzięki naszemu programowi poleceń. Zobacz jak to działa poniżej',
            infoText: 'Jak to działa?',
        },
        direct: {
            title: 'Bezpośrednie polecenie - {{directPercentage}}%',
            text: 'Otrzymasz {{directPercentage}}% wszystkich nagród zdobytych przez przyjaciół',
        },
        indirect: {
            title: 'Polecenie pośrednie - {{inDirectPercentage}}%',
            text: 'Otrzymasz {{inDirectPercentage}}% wszystkich nagród zdobytych przez przyjaciół przyjaciół',
        },
        gaming: {
            title: 'Bonusy do gry',
            text: 'Bonusy za polecenie są aktywne zarówno dla gier PvP jak i zadań w grze',
        },
        buttonShare: 'Zaproś użytkowników',
        invitedReferrals: {
            card: {
                direct: 'Polecenia 1 poziomu',
                indirect: 'Polecenia 2 poziomu',
                active: 'Aktywni poleceni (1 poziom)',
                turnover: 'Obrót struktury',
            },
            viewReward: 'Zobacz nagrody',
            indirectModal: {
                title: 'Polecenia 2 poziomu',
                text: 'Ten użytkownik został zaproszony przez jednego z Twoich znajomych',
            },
            header: {
                title: 'Zaproszeni użytkownicy',
                text: 'Tutaj możesz zobaczyć wszystkie zaproszone osoby polecające i swój dzienny boost, jeśli wykonałeś wszystkie warunki',
                infoText: 'Jak działa Daily Boost?',
                list: 'Zaproszeni',
                sort: 'Sortowanie',
                filter: {
                    CreatedAt: 'Najnowsze',
                    UserEnergy: 'Energia',
                },
            },
        },
        emptyScreen: {
            title: 'Ups!',
            text: 'Coś nie tak. Ale bez obaw, zostanie to szybko naprawione. Spróbuj pociągnąć.',
        },
        emptyList: {
            title: 'Nikogo nie zaprosiłeś',
            text: 'Nie zaprosiłeś jeszcze żadnego użytkownika. Ale to nie problem, zrób to teraz',
        },
        allInvitedReferralsScreen: { title: 'Wszystkie zaproszone referencje' },
        inviteUsersScreen: {
            title: 'Zaproś użytkownika',
            text: 'Pobierz aplikację IguVerse i podaj kod polecający',
            myNFT: 'My Pet NFT',
            collectedEnergy: 'Zebrana energia',
            leaderBoard: 'Miejsce w tabeli liderów',
            button: 'Podzielić się kodem',
            download: 'Pobierz aplikację IguVerse',
        },
        referralCard: {
            title: 'Użyj kodu polecającego',
            text: 'Wpisz kod polecającego, aby otrzymać dodatkowe bonusy',
            button: 'Wprowadź kod',
        },
        referrerModal: {
            title: 'Kod polecający',
            text: 'Wpisz kod polecającego, a otrzymasz różne zniżki i bonusy',
            label: 'Kod polecający',
            placeHolder: 'Wpisz kod polecający',
            noCode: 'Nie masz kodu? ',
            apply: 'Czytaj więcej o zaproszeniach',
            button: 'Prześlij kod polecający',
            success: {
                toastSuccess: {
                    title: 'Podany kod referencyjny',
                    text: 'Teraz wszystkie funkcje są dostępne dla Ciebie',
                },
            },
            error: {
                empty: 'Kod polecający nie może być pusty',
                incorrectCode:
                    'Nieprawidłowy kod. Kod polecający nie istnieje lub stracił ważność',
                toastError: {
                    title: 'Nieprawidłowy kod',
                    text: 'Kod polecający nie istnieje lub stracił ważność',
                },
                forbidden: 'Nie można użyć kodu polecającego na tym urządzeniu',
                toastForbidden: {
                    title: 'Zakazane',
                    text: 'Nie można użyć kodu polecającego na tym urządzeniu',
                },
                toastAlreadyLinked: {
                    title: 'Już wykorzystany',
                    text: 'Twoje konto już wykorzystane Kod polecający',
                },
            },
        },
        boostCards: {
            cardTitle: 'Dzienny boost = {{boost}}%',
            cardText: 'Musisz zaprosić ',
            users: ' Użytkowników',
            text: 'Im więcej użytkowników zaprosisz, tym większy boost otrzymasz',
            button: 'Zobacz nagrody',
        },
        howBoostWorks: {
            title: 'Bonus do nagród',
            text: 'Zaproś użytkowników i otrzymaj boost do codziennych zadań po osiągnięciu dokładnej liczby zaproszeń. Boost zostanie automatycznie zastosowany, gdy osiągniesz tą liczbę',
            alert: 'Boost jest obliczany codziennie i jest ważny tylko dla aktywnych poleconych, którzy grają codziennie i osiągają {{rewardEnergyThreshold}} Energii',
        },
        modalReferee: {
            title: 'Poznaj zaporszonego użytkownika',
            text: 'Możesz odwiedzić media społecznościowe zaproszonego użytkownika, aby dowiedzieć się więcej o nim i pomóc w działaniu w firmie',
            energy: 'Zebrana energia (24h)',
        },
    },
    aiQuoteInfo: {
        alertCard: {
            overload: { title: 'System przeciążony' },
            dailyAttempts: { title: '{{attempts}} Pozostało prób' },
        },
        modalInfo: {
            title: 'NFT z Twojej wyobraźni',
            text: 'Można stworzyć NFT za pomocą technologii AI, ale ta operacja jest bardzo kosztowna. Czasami z powodu dużego obciążenia może być tymczasowo niedostępna',
            daily: 'Ostatnie 24 godziny Użytkowanie =',
            dailyText:
                'Możesz wygenerować nie więcej niż {{amount}} unikalnych zwierzątek przy użyciu technologii AI w okresie 24 godzin',
            systemLoad: 'Obciążenie systemu = {{load}}',
            systemLoadText:
                'Czasami system może być przeciążony z powodu dużego zapotrzebowania. Będziesz musiał trochę poczekać',
            load: {
                low: 'Niski',
                medium: 'Medium',
                high: 'High',
                overloaded: 'Przeciążony',
            },
            systemUsage: 'Użycie systemu = {{percentage}}%',
            systemUsageText:
                'System jest w wersji Beta i obecnie jest dostępny tylko w określonych ilościach dziennie',
        },
        modalErrorNoMints: {
            title: 'Nie zostało mintów',
            text: 'Z przykrością informujemy, że wszystkie mennice na dziś zostały wydane. Ale nie martw się, możesz spróbować wybić NFT używając technologii AI jutro',
            button1: 'Mięta z fotografii',
        },
        modalErrorOverLoad: {
            title: 'System przeciążony',
            text: 'Z przykrością informujemy, że AI mint jest teraz przeciążony od innych użytkowników. Damy ci znać, kiedy będzie dostępna',
            button1: 'Mięta z fotografii',
        },
    },
    howTo: {
        fee: {
            stepOne: {
                title: 'Opłata za łańcuch bloków jest przybliżona',
                text: 'Wszystkie transakcje w aplikacji odbywają się na blockchain i mają opłatę prowizyjną w BNB. Suma opłaty może być znana dopiero w momencie realizacji transakcji, a my pokazujemy jedynie domniemaną kwotę',
            },
            stepTwo: {
                title: 'Wyższa opłata za tokeny',
                text: 'Na blockchain musisz zatwierdzić użycie tokenów przed wykonaniem określonej transakcji. Płacenie za pomocą BNB zajmie tylko jedną transakcję, podczas gdy wydawanie innych tokenów wymaga dwóch transakcji: zatwierdzenia i realizacji',
            },
        },
        charity: {
            stepOne: {
                title: 'Pomoc organizacjom prozwierzęcym',
                text: 'Możesz wybrać z listy organizacje charytatywne i przekazać im darowiznę, aby pomóc zwierzętom na całym świecie',
            },
            stepTwo: {
                title: 'Ustawianie preferowanego procentu',
                text: 'Możesz wybrać procent z nagród, które mają być przekazane (od 1% do 100%). Możesz również zmienić tę wartość w dowolnym momencie',
            },
        },
        play: {
            button: 'Zacznij grać',
            stepOne: {
                title: 'Wybierz zwierzęta do wykonania zadań',
                text: 'W poniższej sekcji wybierz zwierzaki, które będą brały udział w grze. Pierwszy zwierzak w zamówieniu zostanie użyty w zadaniu Społecznym i będzie wyświetlany jako Twój główny Zwierzak.',
            },
            stepTwo: {
                title: 'Przywrócić energię',
                text: 'Masz 24 godziny na przywrócenie poziomu Energii poprzez wykonanie zadań przed końcem dnia. 100% Energii oznacza, że zdobędziesz 100% z maksymalnych możliwych nagród opartych na statystykach zwierząt. Każdego dnia, gdy zegar osiągnie 00:00, poziom energii zostanie zresetowany',
            },
            stepThree: {
                title: 'Zdobądź nagrody',
                text: 'Po wykonaniu zadań Twoja energia zostanie zamieniona na nagrody w zależności od statystyk Twojego pupila',
            },
            stepFour: {
                title: 'Ulepszaj swoich zwierzaków',
                text: 'Podnieś poziom swoich zwierzaków, kupuj nowe zwierzaki, ulepszaj rangi, aby cieszyć się większą ilością korzyści. Zdobądź najwyższą pozycję w tabeli liderów i ciesz się jeszcze większymi nagrodami',
            },
        },
        referrals: {
            button: 'Zaproś użytkowników',
            stepOne: {
                title: 'Podziel się swoim kodem polecającym',
                text: 'Zaproś użytkowników do aplikacji IguVerse i zarabiaj na ich grze. Za bezpośrednie polecenie otrzymasz - {{direct}}%, a za pośrednie - {{inDirect}}%',
            },
            stepTwo: {
                title: 'Przyspieszenie realizacji codziennych zadań',
                text: 'Zapraszaj użytkowników i otrzymuj boost do codziennych zadań po osiągnięciu określonej liczby zaproszeń. Więcej szczegółów znajdziesz w zakładce "Moi poleceni"',
            },
            stepThree: {
                title: 'Otrzymaj więcej rabatów',
                text: 'W bloku "NFT do gry" wybierz minimum jedną NFT do gry. Pamiętaj, że pierwsze NFT zbierze najwięcej doświadczenia na poziomie',
            },
            stepFour: {
                title: 'Zdobądź bonusy do gry.',
                text: 'Za każdą wygraną grę i każdy depozyt bezpośredni polecający otrzymają {{direct}}% kwoty, a pośredni polecający - {{inDirect}}%',
            },
        },
        availableRewards: {
            stepOne: {
                titleOne: 'Zdobądź ',
                titleTwo: ' swoich nagród',
                text: 'Możesz przekazać {{percent}}% swoich dostępnych nagród VIGUP do swojego głównego portfela. Po złożeniu wniosku, token może zostać wymieniony, wysłany do innego portfela lub wycofany',
            },
            stepTwo: {
                title: 'Claim',
                text: 'Claim jest operacją blockchain, która daje prawo do konwersji salda VIGUP do głównego portfela IGUP. Po udanym claimie środki są dostępne natychmiast',
            },
            stepThree: {
                title: 'Wymiana VIGUP na ',
                text: 'Będziesz mógł wymienić zarobione tokeny na tokeny IGUAI, gdy platforma handlowa zostanie wydana. Korzystając z aplikacji, stajesz się jednym z pierwszych użytkowników naszego rozwiązania na najwyższym poziomie',
            },
            stepFour: {
                title: 'Saldo ujemne',
                text: 'Czasami Twoje dostępne saldo może być ujemne, co oznacza, że wykorzystałeś zablokowane nagrody na różne transakcje w grze, takie jak Uzdrowienie czy Podniesienie poziomu. Pozwalamy, aby Twoje dostępne nagrody spadły poniżej zera, aż do wartości Twojego zablokowanego salda. Po odblokowaniu tokenów, dostępne saldo również wzrośnie',
            },
            alert: 'Pozostałe tokeny VIGUP są w toku i będą przechowywane w zablokowanym portfelu',
        },
        lockedRewards: {
            stepOne: {
                title: 'Zablokowane nagrody',
                text: 'Zdobyte nagrody są blokowane w zależności od statystyk zwierzaka (Ranga i Poziom). Ulepsz swoje zwierzaki, aby zmniejszyć okres blokady',
            },
            stepTwo: {
                title: 'Przeliczanie na dostępne nagrody',
                text: 'Zablokowane nagrody odblokowują się automatycznie i po odblokowaniu będą dostępne w zakładce Dostępne nagrody',
            },
            stepThree: {
                title: 'Wymiana VIGUP na ',
                text: 'Będziesz mógł wymienić zarobione tokeny na tokeny IGUAI, gdy platforma handlowa zostanie wydana. Korzystając z aplikacji, stajesz się jednym z pierwszych użytkowników naszego rozwiązania na najwyższym poziomie',
            },
        },
        socializeToEarn: {
            CONFIRMED: 'Prawidłowo',
            FAILED: 'Nieprawidłowo',
            step: {
                title: 'Dodano link do IguVerse',
                text: 'Podczas udostępniania Pet ID zawsze dodawaj link do aplikacji IguVerse, który można znaleźć na ekranie udostępniania. Link powinien być dołączony do samej historii.',
            },
            stepOne: {
                title: 'Pet ID i link są w pełni widoczne',
                text: 'Informacje na Pet ID i link powinny być łatwo rozpoznawalne. Link do aplikacji musi być aktywny',
            },
            stepTwo: {
                title: 'Niewielkie modyfikacje są w porządku',
                text: 'Możesz zmienić rozmiar i kolor Pet ID lub jego nachylenie. Oczywiście modyfikacje te nie powinny być sprzeczne z pierwszą zasadą',
            },
            stepThree: {
                title: 'Identyfikator zwierzaka jest trudny do rozpoznania',
                text: 'Nie zezwalamy na żadne modyfikacje Pet ID, w tym przycinanie i ukrywanie obrazka lub jego części. Przesuń, aby dowiedzieć się więcej',
            },
            stepFour: {
                title: 'Identyfikator zwierzaka jest zakryty',
                text: 'Niedopuszczalne jest nakładanie i przemalowywanie obrazu oraz nadmierne zmniejszanie rozmiaru',
            },
        },
        verifyUser: {
            stepOne: {
                title: 'Znajdź Pet ID w mediach społecznościowych',
                text: 'Śledź konto innego użytkownika w mediach społecznościowych i sprawdź jego zawartość, a następnie zlokalizuj Pet ID. Wpisz kod w aplikacji i wykonaj zadanie',
            },
            stepTwo: {
                title: 'Podaj identyfikator znalezionego zwierzęcia',
                text: 'Podaj kod z Pet ID lub zeskanuj go za pomocą skanera kodów QR. W przypadku braku kodu, kliknij przycisk Pet Not Found. Znajdź wszystkich użytkowników do wykonania zadania',
            },
            stepThree: {
                title: 'Bądź odpowiedzialny',
                text: 'Graj uczciwie i nie próbuj oszukiwać, wprowadzając w błąd system poprzez podawanie błędnych ID lub twierdzenie, że nie możesz znaleźć. Twoje konto może zostać oznaczone lub zbanowane, jeśli nadal będziesz to robić',
            },
        },
        purchaseBNB: {
            screenTitle: 'Jak kupić BNB',
            title: 'Zakup BNB na Binance',
            text: 'BNB to kryptowaluta, która służy do uiszczania opłat na Binance Smart Chain, używanym przez nas blockchainie. Obejrzyj poniższy film, aby dowiedzieć się więcej o wpłacaniu BNB do portfela w grze',
            guideBlock: {
                title: 'Przewodnik po zakupach i wypłatach',
                first: 'Zaloguj się do aplikacji Binance. Pobierz, zarejestruj i zweryfikuj się, jeśli jej nie masz',
                second: 'Kupuj kryptowaluty za pomocą karty lub serwisu p2p. Możesz od razu wybrać BNB!',
                third: 'Otwórz zakładkę Portfel i dotknij przycisku Wypłać',
                fourth: 'Wybierz kryptowalutę, którą chcesz wypłacić. W naszym przypadku BNB',
                fiveStepOne:
                    'Wklej adres, na który chcesz się wycofać i wybierz sieć: ',
                fiveBold: 'BNB Smart Chain (BEP-20)',
                fiveStepTwo:
                    '. Twój adres portfela można znaleźć w zakładce portfela w aplikacji IguVerse. Zaczyna się od 0x i jest kombinacją liter i cyfr',
                six: 'Poczekaj kilka sekund na przetworzenie transakcji i gotowe!',
            },
            resourceBlock: {
                title: 'Przydatne zasoby',
                buy: 'Jak kupić BNB (BNB) Przewodnik',
                withdraw: 'Jak wypłacić pieniądze z Binance',
                status: 'Jak sprawdzić status transakcji kryptowalutowych na Blockchainie',
            },
        },
        petOrderId: {
            title: 'Uporządkuj zwierzęta domowe',
            text: 'Wybierz zwierzaków które będą brali udział w grze! Porządek zwierzaków określi ilość otrzymywanego przez nie XP',
            cardFeatureInfo: {
                title: 'Priorytet dla zwierząt domowych',
                text: 'Pierwszy zwierzak będzie reprezentował Cię w Twoim Pet ID, w głosowaniu Petów, w tabeli liderów',
            },
            button: 'Zamówienie zwierząt',
        },
        howToGamingAvailableWallet: {
            screenTitle: 'Dostępny portfel',
            button: 'Uzupełnij',
            stepOne: {
                title: 'Graj w gry konkurencyjne',
                text: 'Portfel gamingowy umożliwia rywalizację z innymi graczami i zdobywanie IGU. Użyj zakładki Gry, aby zobaczyć dostępne gry',
            },
            stepTwo: {
                title: 'Doładuj portfel gier',
                text: 'Aby wziąć udział, doładuj swój portfel gier za pomocą IGU i otrzymaj VIGU. Użyj poniższego przycisku, aby doładować tokeny',
            },
            stepThree: {
                title: 'Wypłata do głównego portfela',
                text: 'Nagrody zdobyte w konkurencyjnych grach będą przechowywane w portfelu gamingowy. Możesz wypłacić te nagrody do głównego portfela w dowolnym momencie',
            },
            stepFour: {
                title: 'Otrzymać premię za polecenie',
                text: 'Za każdą wygraną grę i każdy depozyt bezpośredni polecający otrzymają {{direct}}% kwoty, a pośredni polecający - {{indirect}}%',
            },
        },
        howToGamingPendingWallet: {
            screenTitle: 'Portfel na czekanie',
            alert: 'Tokeny w portfelu zamrażającym nie są kontrolowane przez IguVerse i są zablokowane w inteligentnym kontrakcie na czas trwania gry',
            stepOne: {
                title: 'Zamrożenie podczas gry',
                text: 'Środki w portfelu gamingowy zostaną zamrożone do czasu zakończenia gry. Ten środek został wprowadzony, aby zapobiec oszustwom',
            },
            stepTwo: {
                title: 'Automatyczne odszranianie',
                text: 'Jeśli wygrasz grę, Twoje środki zostaną automatycznie zwrócone do portfela gamingowy. W przeciwnym razie zostaną one przekazane zwycięzcy',
            },
        },
        howToCommissionFee: {
            screenTitle: 'Prowizji',
            stepOne: {
                title: ' Prowizji',
                text: 'Pobieramy prowizję w wysokości {{commission}}% od każdej wypłaty z portfela gry',
            },
            stepTwo: {
                title: 'Poprawiona tokenómika',
                text: 'Gry PvP wykorzystują model ekonomiczny pulu, który przewyższa ekonomię większości projektów GameFi. Prowizja jest odpisywana, aby jeszcze bardziej wzmocnić ekonomię',
            },
        },
        HowToCollections: {
            stepOne: {
                title: 'Wirtualny towarzysz zwierząt',
                text: 'Stwórz zwierzaka NFT z pomocą AI, który pomoże Ci zarabiać na mediach społecznościowych. Możesz również przesłać zdjęcie swojego własnego zwierzaka',
            },
            stepTwo: {
                title: 'Przywrócić energię',
                text: 'Masz 24 godziny na przywrócenie poziomu Energii poprzez wykonanie zadań przed końcem dnia. 100% Energii oznacza, że zdobędziesz 100% z maksymalnych możliwych nagród opartych na statystykach zwierząt. Każdego dnia, gdy zegar osiągnie 00:00, poziom energii zostanie zresetowany',
            },
            stepThree: {
                title: 'Wymiana VIGUP na ',
                text: 'Będziesz mógł wymienić zarobione tokeny na tokeny IGUAI, gdy platforma handlowa zostanie wydana. Korzystając z aplikacji, stajesz się jednym z pierwszych użytkowników naszego rozwiązania na najwyższym poziomie',
            },
        },
    },
    energyInfoScreen: {
        title: 'Zbieraj energię i wymieniaj ją na tokeny',
        text: 'Twój kurs Energii do IGUP zależy od ilości zwierzaków, rang, poziomów i innych modyfikatorów jak np. boost',
        button: 'Zacznij grać',
        features: {
            first: {
                title: '1 Energia ≈ {{amount}} IGUP',
                text: 'Jest to przybliżony kurs wymiany, który może ulec zmianie w zależności od różnych warunków',
            },
            second: {
                title: 'Próg energetyczny = {{energy}}',
                text: 'Jeśli nie osiągniesz minimalnego progu {{energy}} punktów energii, połowa punktów energii zostanie spalona, a kolejna połowa przeniesiona na następny dzień',
            },
        },
    },
    initial: {
        initialMint: {
            title: 'Stwórz swojego pierwszego zwierzaka i rozpocznij swoją podróż w IguVerse',
            text: 'To ostatni krok przed Twoją niesamowitą podróżą w IguVerse. Stwórz swojego pierwszego zwierzaka i zacznij grać i zdobywać nagrody za codzienną aktywność z pupilem',
            button: 'Stwórz swojego zwierzaka',
        },
        initialReferral: {
            title: 'Korzystaj z rabatu na stworzenie zwierzaka!',
            text: 'Zostałeś zaproszony do naszej aplikacji. Korzystaj z rabatów i bonusów za grę w IguVerse. Pospiesz się, aby stworzyć swojego zwierzaka NFT',
            button: 'Kontynuuj',
        },
    },
    ModalShareOrSave: {
        title: 'Zapisz swoją zawartość',
        text: 'Zapisz ulubioną zawartość IguVerse w rolce aparatu lub udostępnij ją znajomym',
        save: 'Zapisz w rolce aparatu',
        share: 'Podziel się',
        loading: 'Przygotowanie treści..',
        saveSuccess: 'Zawartość zapisana w rolce aparatu',
    },
    RelatedApps: {
        downloadApp: {
            titleiOS: 'Aplikacja dostępna na iOS',
            titleAndroid: 'Aplikacja dostępna na Androida',
            description:
                'Ciesz się lepszym doświadczeniem w aplikacji mobilnej',
            buttonOk: 'Pobierz aplikację',
            buttonCancel: 'Nie teraz',
        },
        switchToApp: {
            titleiOS: 'Przełącz się na aplikację iOS',
            titleAndroid: 'Przejdź do aplikacji na Androida',
            description:
                'Ciesz się lepszym doświadczeniem w aplikacji mobilnej',
            buttonOk: 'Przejdź do aplikacji',
            buttonCancel: 'Nie teraz',
        },
    },
    ShareYourFeedback: {
        title: 'Podziel się swoją opinią',
        text: 'Możesz podzielić się z nami swoją opinią, a wysyłając ten formularz prześlesz nam logi po stronie klienta, abyśmy mogli pomóc w zidentyfikowaniu problemu',
        placeholder: 'Opisz szczegółowo swoje problemy',
        button: 'Zgłoś',
        loading: 'Wysyłka..',
        accessibility:
            'Wyłączenie funkcji "Wyślij swoją opinię na temat wstrząsów"',
    },
    ModalMainnet: {
        title: 'Funkcja niedostępna',
        text: 'Funkcja ta jest niedostępna do czasu, gdy IGU wejdzie na giełdy. Dokładna data wejścia na giełdę zostanie ogłoszona wkrótce',
        button: 'OK',
    },
    ModalDailyRewards: {
        [DAILY_REWARD_STATUS.Bonus]: {
            title: 'Bonus PvP zaliczony',
            text: 'Otrzymałeś bonus za swoją aktywność w grach PvP. Żetony znajdują się już w Twoim portfelu w grze',
        },
        [DAILY_REWARD_STATUS.Daily]: {
            title: 'Dzienna nagroda dostępna w Twoim portfelu',
            text: 'Twoje nagrody za wczorajsze zadania dotarły!',
        },
        [DAILY_REWARD_STATUS.Both]: {
            title: 'Otrzymałeś nagrody dzienne i bonus PvP',
            text: 'Nagrody za ukończenie questów zostały już zaliczone i zaczynają się odblokowywać! Otrzymaliście również bonusowe tokeny za udział w grach PvP',
        },
        dailyReward: {
            title: 'Dostępne nagrody {{availableAmount}} / {{totalAmount}} IGUP',
            text: '{{availableAmount}} IGUP dostępne od ręki w Twoim portfelu',
        },
        unlocks: {
            title: 'Zablokowane tokeny',
            text: '{{restAmount}} IGUP będzie odblokowywane stopniowo',
        },
    },
    MintBonusScreen: {
        mintSuccess: { title: 'Program Bonusowy', text: 'Bonus za mint NFT' },
        BonusMintRanksDetailedInfoScreen: {
            title: 'Mint NFT - Zdobądź natychmiastowy Bonus IGUP',
            text: 'Proponujemy Ci stworzyć NFT i otrzymanie bonusu, który możesz wypłacić w przyszłości. Przejdź do następnego kroku i zakończ proces stworzenia NFT',
            button1: 'Przejdź do następnego kroku',
            button2: 'Zobacz wszystkie bonusy',
            timeRemaining: 'Pozostały czas',
            features: {
                bonus: {
                    key: 'Bonus za mint NFT = {{amount}} IGUP (${{dollarValue}})',
                    value: 'Tokeny, które zostaną przelane na Twoje konto po udanym mincie',
                },
                lock: {
                    key: 'Okres blokady = {{days}} dni',
                    value: 'Tokeny będą dostępne do wycofania po zakończeniu okresu blokady',
                },
            },
        },
        BonusMintRanksCarouselScreen: {
            screenTitle: 'Bonus za rangę',
            title: '{{slug}} Ranga',
            button1: 'Wybierz rangę',
            features: {
                bonus: {
                    key: 'Bonus za rangę = {{amount}} IGUP (${{dollarValue}})',
                    value: 'Tokeny, które zostaną przelane na Twoje konto po udanym wybiciu',
                },
                lock: {
                    key: 'Okres blokady = {{days}} dni',
                    value: 'Tokeny będą dostępne do wycofania po zakończeniu okresu blokady',
                },
            },
        },
    },
    YourPetsAreHungry: {
        title: 'Twoje zwierzaki są głodne!',
        text: 'Utrata zdrowia zmniejszy twoje nagrody i może sprawić, że twoje NFT po pewnym czasie staną się bezużyteczne. Karm swoje zwierzaki, aby konsekwentnie zarabiać!',
    },
    priceUpModal: {
        title: 'Wzrost cen na zwierzaków aż na ',
        text: 'Ze względu na duże zapotrzebowanie i szybki rozwój projektu, nasz zespół zdecydował się podnieść ceny NFT, aby nagrodzić wczesnych użytkowników i zapewnić, że ekonomika pozostanie zrównoważona w dłuższej perspektywie',
        priceUpdate: 'Aktualizacja cen startuje za',
        button: 'Stwórz nowego zwierzaka',
    },
    updateModal: {
        banner: {
            title: 'Nowa aktualizacja jest już dostępna!',
            text: 'Sprawdź nową {{version}} wersję aplikacji',
        },
        screen: {
            screenTitle: 'Nowa aktualizacja',
            title: 'Nowa aktualizacja jest już dostępna!',
            text: 'Zespół IguVerse ciężko pracował, aby poprawić komfort korzystania z aplikacji i opracować nowe funkcje. Ciesz się tymi ulepszeniami w nowej wersji{{version}}',
            button: 'Zacznij grać',
        },
    },
    communityModal: {
        title: 'Uzyskaj pomoc od naszej społeczności',
        text: 'Dołącz do naszych oficjalnych media społecznościowych, aby uzyskać odpowiedzi na swoje pytania od innych graczy. Dowiedz się jak grać, zmaksymalizuj swój zysk i ciesz się razem z nami grając w IguVerse!',
        button1: 'Zobacz więcej',
        button2: 'Nie pokazuj tego ponownie',
    },
    socialTooltip: {
        text: 'Kliknij tag „Nie Udało Się”, aby dowiedzieć się, dlaczego Twoje konto lub identyfikator zwierzaka nie spełnia naszych kryteriów i został odrzucony. Będziesz także mieć dostęp do Bazy wiedzy, aby dowiedzieć się, jakie są te kryteria',
    },
    gameIterationText: {
        text: 'Podliczane są wczorajsze nagrody, co zwykle zajmuje około {{minutes}} minut. Po zakończeniu tego procesu będziesz mógł grać ponownie',
        toastErrorTitle: 'Podliczane są wczorajsze nagrody',
    },
    howConnectFacebookModal: {
        info: 'Jak się połączyć',
        screenTitle: 'Jak połączyć się z Facebook',
        title: 'Znalezienie identyfikatora Facebooka',
        text: 'Aby połączyć swoje konto na Facebooku, musisz znaleźć i skopiować swój identyfikator Facebooka. Odwiedź stronę swojego profilu i skopiuj część linku po / - to twój Facebook ID',
        button: 'Połącz konto',
    },
    listingIgu: {
        iguListing: 'IGU Notowania',
        title: ' przed wejściem na giełdę w ',
        textOne: 'Notowanie na giełdzie {{exchange}} odbędzie się na giełdzie ',
        textTwo: '. Zapnijcie pasy, Iguany - nabierają prędkości przed lotem!',
        button: 'Badania na giełdzie',
        listed: {
            title: ' jest notowana na ',
            text: 'Długo oczekiwany start IGU w końcu nadszedł — to dopiero początek naszej Odysei Kosmicznej! Kupuj i wymieniaj monety IGU na giełdzie {{exchange}} już teraz',
        },
    },
    bybitVote: {
        title1: 'Głosuj za IGU na ByBit i rozdziel ',
        title2: '!',
        text: 'IguVerse zostało wybrane do udziału w programie ByVotes - projekt z największą liczbą głosów pojawi się na ByBit!',
        banner: {
            title1: 'Głosuj i rozdziel ',
            title2: '',
        },
        button: 'Więcej',
    },
    howToPurchaseIGU: {
        modalTitle: 'Jak kupić IGU',
        exchangesModalTitle: 'Kupuj IGU na giełdach',
        cardDeposit: {
            title: 'Wpłata',
            text: 'Obsługiwane tokeny możesz wpłacić z dowolnego portfela BSC BEP-20',
        },
        cardExchange: {
            title: 'Kupuj na giełdach',
            text: 'Kupuj i handluj IGU na giełdach, na których był notowany',
        },
        cardTrade: {
            title: 'Handluj w aplikacji',
            text: 'Szybki i wygodny handel IGU bezpośrednio w aplikacji',
        },
    },
    howToClaimFreePet: {
        title: 'Kup NFT, aby otrzymać nagrody',
        text: 'Nie możesz otrzymać nagród, ponieważ na Twoim koncie nie ma NFT. Darmowe zwierzę domowe nie jest NFT, ponieważ nie znajduje się w blockchainie. Kupno zwierzęcia NFT lub ulepszenie istniejącego zwierzęcia da Ci dostęp do nagród',
        alert: 'Przechowujemy informacje o wszystkich Twoich nagrodach i będziesz mógł je odzyskać po zakupie NFT',
        button: 'Zmintuj NFT',
    },
    howToClaimOnButton: {
        titleOne: 'Zdobądź ',
        titleTwo: ' swoich nagród',
        text: 'Możesz przekazać {{percent}}% swoich dostępnych nagród VIGUP do swojego głównego portfela. Po złożeniu wniosku, token może zostać wymieniony, wysłany do innego portfela lub wycofany',
        alert: 'Pozostałe tokeny VIGUP są w toku i będą przechowywane w zablokowanym portfelu',
        button: 'Odbierz swoją nagrodę',
    },
    onBoarding: {
        mainWallet: {
            title: 'Główny portfel',
            stepOne: {
                title: 'Wszystkie Twoje kryptowaluty są tutaj',
                text: 'Ten portfel przechowuje wszystkie obsługiwane tokeny dostępne na Twoim koncie. Nieobsługiwane tokeny nie są wyświetlane. Wszystkie Twoje nagrody będą tutaj po cleima',
            },
            stepTwo: {
                title: 'Nawigacja pomiędzy portfelami',
                text: 'W zakładce "Portfel główny" możesz otworzyć wszystkie inne portfele dostępne na Twoim koncie, przesuwając palcem po ekranie. Pozostałe portfele obejmują portfel NFT, portfel nagród oraz portfel gamingowy',
            },
        },
        login: {
            stepOne: {
                title: 'Nowy sposób na zarabianie krypto',
                text: 'Zamień swoją codzienną rutynę w mediach społecznościowych w sposób na zarabianie pieniędzy! Udostępniaj treści, spaceruj i graj w grę zręcznościową, aby zdobyć nagrody',
            },
            stepTwo: {
                title: 'Wirtualny towarzysz zwierząt',
                text: 'Stwórz zwierzaka NFT z pomocą AI, który pomoże Ci zarabiać na mediach społecznościowych. Możesz również przesłać zdjęcie swojego własnego zwierzaka',
            },
            stepThree: {
                title: 'Konkurencyjne gry',
                text: 'Chcesz zarobić o wiele więcej? Rzuć wyzwanie innym graczom w naszych trybach PvP i wygraj dużo',
            },
            stepFour: {
                title: 'Darowizny dla zwierząt',
                text: '1% Twoich codziennych nagród trafia na cele związane z opieką nad zwierzętami. Możesz zwiększyć kwotę darowizny w aplikacji',
            },
            stepFive: {
                title: 'Przyszłe produkty',
                text: 'Aplikacja jest tylko pierwszym produktem z serii. Bądź jednym z pierwszych użytkowników naszej napędzanej przez AI platformy handlowej i zdecentralizowanej sieci reklamowej, gdy zostaną one wydane',
            },
        },
    },
    HomeScreen: {
        MemsModal: {
            title1: 'Airdrop o wartości ',
            title2: ' w MemeFi Discord!',
            text: 'Zespół MemeFi niedawno rozpoczął kampanię rozdawania NFT na Discordzie. Za wykonanie prostego zadania otrzymasz bilety  na NFT z wbudowanym airdropem  $MEMF',

            button1: 'Otwórz Discord',
            button2: 'Do strony',
            banner: {
                title: '$450.000 Airdrop',
                text: 'Zespół MemeFi niedawno rozpoczął kampanię rozdawania NFT na Discord',
            },
        },
        exploreGames: 'Przeglądaj gry',
        minimalBet: {
            title: 'Minimalny zakład = {{amount}}',
            text: 'Najmniejsza kwota, którą możesz grać',
        },
        WelcomeHeader: {
            title: 'Witamy z powrotem!',
            text: 'Graj i zarabiaj kryptowaluty codziennie',
        },
        ModalGameComingSoon: {
            title: 'Gra już wkrótce',
            text: 'Nasz zespół ciężko pracuje nad nową grą PvP i wkrótce zostanie wydana. Wypróbuj inne ekscytujące gry w naszej bibliotece!',
        },
        GamesBlock: {
            header: 'Konkurencyjne gry',
            button: 'Zagraj w grę',
            buttonContinue: 'Kontynuuj grę',
            buttonComingSoon: 'Już wkrótce...',
            orders: '{{orders}} Pokoje',
            games: {
                [MYSTERY_GAMES.mysteryLikes]: {
                    title: 'The Mystery of Likes',
                    text: 'Odgadnij liczbę polubień na NFT',
                },

                [MYSTERY_GAMES.nftRoyal]: {
                    title: 'The Grand Race',
                    text: 'Dąż do zwycięstwa na ścieżce owoców i jagód',
                },
                [MYSTERY_GAMES.nftEvolution]: {
                    title: 'NFT Evolution',
                    text: 'Krzyżowanie NFT i uzyskiwanie ich potężniejszych wersji',
                },
                [MYSTERY_GAMES.luckyStrike]: {
                    title: 'Lucky Strike',
                    text: 'Kup bilety, aby złapać szczęście i odebrać wszystko w grze, w której rządzi fortuna',
                },
                [MYSTERY_GAMES.quantumSpin]: {
                    title: 'Quantum Disk',
                    text: 'Zakręć kołem kwantowym, aby złapać szczęście',
                },
                [MYSTERY_GAMES.tokenteller]: {
                    title: 'Tokenteller',
                    text: 'Chwyć swoją magiczną piłkę i zgadnij przyszłą cenę IGU',
                },
                socialProof: '{{amount}} wygrało teraz w grze PvP {{game}}',
            },
        },
        GamesFeatures: {
            orders: 'Darmowe sale zabaw',
            prizePool: 'Łączna wartość nagród pieniężnych',
            turnover: 'Obrót {{coin}}',
            totalSlots: 'Łączna liczba rund',
        },
        VacantRoomsEmpty: {
            title: 'Brak wolnych gier',
            text: 'a razie nie ma aktywnych próśb o grę. Czy chcesz go utworzyć? Każdy gracz będzie mógł rzucić ci wyzwanie',
        },
        EmptyGameHistory: {
            title: 'Brak gier',
            text: 'Nigdy nie brałeś udziału w grze ani jej nie stworzyłeś. Utwórz grę teraz i rzuć wyzwanie losowemu graczowi',
        },
        GamesNavigationBar: {
            ORDERS: 'Puste pomieszczenia',
            HISTORY: 'Historia',
            ROUNDS: 'Runda',
            WHEEL: 'Dysk',
        },
        ActiveOrdersFilters: {
            title: 'Puste pomieszczenia',
            modalTitle: 'Sortuj według',
            Newest: 'Najnowszy',
            Oldest: 'Najstarszy',
            Highest: 'Najwyższa nagroda',
            Lowest: 'Najniższa nagroda',
        },
        ConfirmPlayModal: {
            title: 'Zagrać za ',
            title2: 'Obróć za ',
            text: 'Dołączając do gry potwierdzasz, że podany depozyt zostanie przeniesiony na listę oczekujących',
        },
        GamesCreateWelcome: {
            screenTitle: 'Stworzyć grę "{{game}}"',
            title: 'Rzuć wyzwanie innym',
            text: 'Utwórz grę z preferowanym zakładem i ukończ ją, aby inni gracze mogli podjąć Twoje wyzwanie',
        },
        MaxMinimalBetFeature: {
            title: 'Minimalna stawka = {{min}}, Maksymalna stawka = {{max}}',
            text: 'Najmniejsza i największa kwota, jaką można postawić',
        },
        GameTermination: {
            title: 'Automatyczne zakończenie = {{days}} dni',
            text: 'Czas, po którym gra zostanie zakończona, jeśli żaden inny gracz nie rzuci Ci wyzwania',
            alert: 'Jeśli nikt nie rzuci Ci wyzwania w ciągu siedmiu dni, gra zostanie automatycznie usunięta, a depozyt zwrócony do Twojego salda',
        },
        EnterCoinsAmountScreen: {
            screenTitle: 'Wprowadź kwotę monet',
            error: {
                max: 'Niewystarczająca ilość środków, doładuj, aby kontynuować',
                maxStake: 'Maksymalna stawka {{amount}}, zmniejsz stawkę',
                minStake:
                    'Minimalna stawka {{amount}}, proszę zwiększyć stawkę',
                digits: 'Muszą być tylko cyfry',
            },
            confirmTransaction: {
                valueType: 'Tworzenie zamówień dla "{{game}}"',
            },
        },
        PreviousGameModal: {
            title: 'Ukończ poprzednią grę?',
            text: 'Zakończ grę, do której już dołączyłeś, aby inni użytkownicy mogli rzucić Ci wyzwanie. Gra zniknie automatycznie po {{days}} dni',
            button1: 'Ukończ poprzednią grę',
        },
        GameHistoryScreen: {
            title: 'Historia',
            text: 'Tutaj możesz zobaczyć historię ukończonych gier. Możesz je przeglądać według miesięcy',
            status: {
                [MYSTERY_LIKES_STATUS.WaitingForMyself]:
                    'Czekając na twój ruch',
                [MYSTERY_LIKES_STATUS.WaitingForOpponent]:
                    'Oczekiwania przeciwnika',
                [MYSTERY_LIKES_STATUS.Refund]: 'Gra została zakończona',
            },
        },
        MysteryGamesBanner: {
            oneGame: {
                title: 'Kontynuuj grę!',
                text: 'Ukończ grę "{{game}}"',
            },
            more: {
                title: 'Kontynuuj grę!',
                text: 'Macie 2 nieskończone gry',
            },
        },
        MysteryGamesContinueModal: {
            title: 'Kontynuuj grę',
            text: '2 gier nie jest skończono. Dotrzyj do końca i poznaj wyniki',
        },
        MysteryLikes: {
            MysteryLikesHowItWorks: {
                stepOne: {
                    title: 'Odgadnij liczbę polubień',
                    text: 'Każda runda gry składa się z {{gamesAmount}} partii przeciwko innemu graczowi. Zgaduj częściej niż przeciwnik, aby wygrać',
                },
                stepTwo: {
                    title: 'Dołączanie i tworzenie gier',
                    text: 'Użytkownicy mogą dołączać i tworzyć gry. Podczas tworzenia gry należy wybrać kwotę do postawienia w żetonach VIGU. Dołączając do gry, zgadzasz się grać za kwotę żetonów określoną przez twórcę gry',
                },
                stepThree: {
                    title: 'Niemożliwe do oszukania',
                    text: 'Użytkownicy w zasadzie nie mają dostępu do liczby polubień z NFT. Jeśli przegrywasz dużo, to masz po prostu pecha. Pograj trochę dłużej, a sytuacja na pewno się zmieni',
                },
            },
            MysteryLikesCreateGameSuccess: {
                title: 'Gra została stworzona',
                text: 'Z powodzeniem stworzyłeś grę! Proszę dokończyć rundę, abyśmy mogli porównać Twoje odpowiedzi z odpowiedziami przyszłego przeciwnika',
                button: 'Zacznij grać',
            },
            MysteryLikesSelectRange: {
                title: 'Wybierz zakres',
                text: 'Wybierz odpowiedni zakres, który zawiera wartość z właściwą liczbą polubień',
                button: 'Przejdź do następnego zdjęcia',
                toastError: 'Już zagłosowałem',
                buttonFinish: 'Zakończ grę',
                tooltip1:
                    'NFT Twojego przeciwnika. Musisz zgadnąć ile ma polubień. Polubienia są niewidoczne dla Ciebie i Twojego przeciwnika',
                tooltip2:
                    'Aby wybrać liczbę polubień, kliknij na jedną z kart i przejdź do następnego zdjęcia za pomocą przycisku poniżej',
            },
            MysteryLikesSelectRangeFinish: {
                [MYSTERY_LIKES_STATUS.WaitingForOpponent]: {
                    title: 'Czekanie na przeciwnika',
                    text: 'Ukończyłeś grę. Twój przeciwnik musi teraz rzucić ci wyzwanie, abyś dołączył do gry. Jeśli Twój przeciwnik nie ukończy jej w ciągu siedmiu dni, gra zostanie automatycznie zakończona, a Twój depozyt zwrócony',
                },
                [MYSTERY_LIKES_STATUS.Won]: {
                    title: 'Wygrałeś!',
                    textOne:
                        'Gratulacje!!! Udało Ci się pokonać swojego przeciwnika. ',
                    textTwo:
                        ' zostanie natychmiast przekazane do Twojego portfela',
                },
                [MYSTERY_LIKES_STATUS.Draw]: {
                    title: 'Remis!',
                    text: 'Co dziwne, obaj uzyskaliście równe wyniki. Twój zakład został zwrócony do portfela. Czy chciałbyś zagrać w kolejną rundę?',
                },
                [MYSTERY_LIKES_STATUS.Lost]: {
                    title: 'Przegrałeś grę :(',
                    text: 'Niestety, Twojemu przeciwnikowi udało się przebić Twoją ofertę w tej rundzie. Twój zakład został przeniesiony do jego portfela. Pamiętaj, że w następnej grze zawsze możesz wygrać!',
                },
                statistics: 'Twoje statystyki',
                alert: 'Jeśli nikt nie rzuci Ci wyzwania w ciągu siedmiu dni, gra zostanie automatycznie usunięta, a depozyt zwrócony do Twojego salda',
                likes: 'polubienia',
            },
            MysteryLikesConfirmPlay: {
                warning:
                    'Użytkownicy w zasadzie nie mają dostępu do liczby polubień z NFT',
            },

            MysteryLikesLoadingScreen: {
                prepare: {
                    title: 'Przygotowanie NFT',
                    text: 'Tasujemy NFT, abyście otrzymali losowy układ. Przypominamy, że polubienia są niewidoczne dla graczy! Proszę poczekać chwilę i nie wylogowywać się z gry i aplikacji',
                },
                complete: {
                    title: 'Analiza wyników',
                    text: 'Przetwarzanie swoich odpowiedzi i odpowiedzi przeciwnika w celu ogłoszenia wyników. Proszę poczekać chwilę i nie wychodzić z gry lub aplikacji',
                },
            },
        },

        NftEvolution: {
            breedCost: {
                title: 'Koszt Hodowli{{amount}}',
                text: 'Koszt kolejnej Rangi NFT po hodowli z 40% rabatem',
                alert: 'Zdobycie kolejnej rangi nie jest gwarantowane',
            },
            WelcomeNftEvolution: {
                BestRankToBreed: {
                    title: 'Najlepsze kombinacje rang',
                    text: 'Lista najlepszych kombinacji rang do skrzyżowania',
                },
                stepOne: {
                    title: 'Krzyżowanie NFT',
                    text: 'Wybierz i skrzyżuj dwa NFT, a otrzymasz NFT o losowej randze z określonym prawdopodobieństwem. Twoje stare NFT nie znikną!',
                },
                stepTwo: {
                    title: 'Klonowanie DNA',
                    text: 'Nasze zaawansowane technologicznie laboratoria mogą teraz pobrać DNA martwych zwierząt i sklonować je! Weź więc parę martwych NFT i stwórz nowe. Niestety, po sklonowaniu nie zostanie przywrócone zdrowie',
                },
                stepThree: {
                    title: 'Prawdopodobieństwo rangow',
                    text: 'Dowiedz się jakie są szanse na uzyskanie każdej Rangi podczas hodowli. NFT nie muszą być tej samej Rangi. Masz jednak szansę na wygranie NFT o dowolnej Randze, włączając wyższe Rangi',
                },
                stepFour: {
                    title: 'Koszt Hodowli',
                    text: 'Koszt kolejnej Rangi NFT po hodowli z 40% rabatem. Otrzymasz unikalny NFT wygenerowany przez AI. Generowanie ze zdjęcia nie jest dostępne',
                },
            },
            NftEvolutionSelectPets: {
                text: 'Lista najlepszych kombinacji rang do skrzyżowania',
                button: 'Oblicz szanse',
                emptyCard: {
                    first: 'Wybierz pierwszy NFT do przekroczenia',
                    second: 'Wybierz drugi NFT do przekroczenia',
                },
                loading: 'Analiza...',
            },
            NftEvolutionSelectPet: {
                title: 'Wybierz NFT',
            },
            NftEvolutionCheckout: {
                title: 'Szanse wynikające z krzyżowania',
                text: 'Dowiedz się więcej o tym, co można uzyskać z krzyżowania',
                button: 'Cross for {{amount}}',
                loading: {
                    title: 'NFT są skrzyżowane',
                    text: 'Proszę poczekać, aż NFT zostaną przekreślone. Nie należy zamykać aplikacji i zakładki. Proces przekraczania trwa zazwyczaj do pięciu minut',
                },
            },
            ConfirmBreedModal: {
                title: 'Cross for ',
                text: 'Dołączając do gry zgadzasz się na skrzyżowanie dwóch NFT, aby otrzymać nowy NFT o losowej randze',
            },
            NftEvolutionSuccess: {
                title: 'Utworzono {{rank}} rangę NFT!',
                text: 'Gratulacje!!! Z powodzeniem przekroczyłeś swoje NFT i uzyskałeś NFT rangi {{rank}}',
            },
            NftEvolutionMintPet: {
                title: 'Wybór NFT',
                text: 'Automatycznie wygenerowaliśmy dla Ciebie cztery zdjęcia NFT. Wybierz najlepszy z nich i wprowadź nazwę dla swojego nowego zwierzaka NFT',
            },
            noPetModal: {
                title: 'Nie ma wystarczającej liczby NFT, aby wziąć udział w grze',
                text: 'Aby wziąć udział w grze, potrzebujesz co najmniej dwóch zwierzaków. Stwórz nowego i zacznij grać już teraz',
            },
        },

        NftRoyal: {
            lockPeriodWarning:
                'Aby zapobiec czitowaniu, używamy inteligentnego systemu wykrywania czitów',

            NftRoyalHowItWorks: {
                stepOne: {
                    title: 'Pokonaj przeciwników w grze zręcznościowej',
                    text: 'Przekształcona gra z codziennych zadań, w której zmierzysz się z silnymi przeciwnikami. W tej wersji dostępnych jest kilka trybów gry. W każdej grze jest tylko jeden przeciwnik',
                },
                stepTwo: {
                    title: 'Dołączanie i tworzenie gier',
                    text: 'Użytkownicy mogą dołączać i tworzyć gry. Podczas tworzenia gry należy wybrać kwotę do postawienia w żetonach VIGU. Dołączając do gry, zgadzasz się grać za kwotę żetonów określoną przez twórcę gry',
                },
                stepThree: {
                    title: 'Czitowanie jest niemożliwe',
                    text: 'Aby zapobiec czitowaniu, używamy inteligentnego systemu wykrywania czitów, który gwarantuje, że tylko umiejętności i szczęście decydują o zwycięzcy',
                },
            },
            NftRoyalGameSettings: {
                gameMode: {
                    [NFT_ROYAL_GAME_MODE.Score]: {
                        title: 'Punkty',
                        text: 'Rywalizacja o więcej punktów',
                    },
                    [NFT_ROYAL_GAME_MODE.Fruit]: {
                        title: 'Owoce',
                        text: 'Rywalizacja o więcej owoców',
                    },
                },
                difficultyType: {
                    [GAME_DIFFICULTY.Easy]: {
                        title: 'Łatwa',
                        text: 'Niska szybkość postaci i niska szybkość odradzania się kaktusów',
                    },
                    [GAME_DIFFICULTY.Medium]: {
                        title: 'Średnia',
                        text: 'Średnia szybkość postaci i niska szybkość odradzania się kaktusów',
                    },
                    [GAME_DIFFICULTY.Hard]: {
                        title: 'Wysoka',
                        text: 'Wysoka szybkość postaci i niska szybkość odradzania się kaktusów',
                    },
                },
                lives: 'Maksymalna liczba żyć w grze',
            },
            NftRoyalGameSettingsModal: {
                title: 'Ustawienia gry',
                text: 'Grę można dostosować, aby zapewnić wygodniejszą i ciekawszą rozgrywkę',
                feature: {
                    mode: {
                        description:
                            'W pierwszym trybie rywalizujesz o punkty, aw drugim o liczbę zebranych owoców',
                    },
                    difficulty: {
                        description:
                            'Trzy poziomy trudności (łatwy, średni i trudny) kontrolują szybkość gry i liczbę kaktusów',
                    },
                    livesCount: {
                        description:
                            'Liczba żyć w grze. Gra kończy się utratą ostatniego życia przez jednego z graczy',
                    },
                },
            },

            NftRoyalCreateGameSuccess: {
                title: 'Udało ci się stworzyć grę!',
                text: 'Proszę, ukończ grę, abyśmy mogli porównać twoje wyniki z wynikami twojego przyszłego przeciwnika',
            },

            NftRoyalGameHistory: {
                [NFT_ROYAL_GAME_HISTORY_STATUS.WaitingForOpponent]: {
                    title: 'Czekanie na przeciwnika',
                    text: 'Ukończyłeś grę. Twój przeciwnik musi teraz rzucić ci wyzwanie, abyś dołączył do gry. Jeśli Twój przeciwnik nie ukończy jej w ciągu siedmiu dni, gra zostanie automatycznie zakończona, a Twój depozyt zwrócony',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Won]: {
                    title: 'Wygrałeś!',
                    textOne:
                        'Gratulacje! Udało ci się pokonać swojego przeciwnika ',
                    textTwo:
                        ' zostanie przelany na twój portfel gamingowy natychmiast',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Draw]: {
                    title: 'Remis!',
                    text: 'Co dziwne, obaj uzyskaliście równe wyniki. Twój zakład został zwrócony do portfela. Czy chciałbyś zagrać w kolejną rundę?',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Lost]: {
                    title: 'Przegrałeś grę :(',
                    text: 'Niestety, Twojemu przeciwnikowi udało się przebić Twoją ofertę w tej rundzie. Twój zakład został przeniesiony do jego portfela. Pamiętaj, że w następnej grze zawsze możesz wygrać!',
                },
                GameStatistics: {
                    title: 'Statystyki dotyczące gry',
                    score: 'Twój Wynik',
                    lives: 'Ocalone życia',
                    fruitCollected: 'Zebrane owoce',
                },
            },
            NftRoyalLoadingScreen: {
                prepare: {
                    title: 'Przygotowanie gry',
                    text: 'Poczekaj chwilę, aż gra się załaduje i skonfiguruje. To nie potrwa długo!',
                },
                complete: {
                    title: 'Analiza wyników',
                    text: 'Przetwarzamy twój wynik i wynik twojego przeciwnika, aby wybrać zwycięzcę. Proszę, poczekaj chwilę i nie opuszczaj gry lub aplikacji',
                },
            },
            emptyScreen: {
                title: 'Ups!',
                text: 'Coś nie tak. Ale bez obaw, zostanie to szybko naprawione',
            },
        },

        [MYSTERY_GAMES.luckyStrike]: {
            keys: {
                participants: 'Uczestnik',
                winners: 'Zwycięzca',
            },

            purchaseTicket: 'Kup bilety',
            ticketsGrabbed: 'Bilety zakupione',
            soldOut: 'Wszystkie bilety sprzedane',
            LuckyStrikeTimerBlock: {
                title: 'Runda kończy się po',
                text: 'Czas do końca rundy',
            },
            HashSecuritySystem: {
                title: 'Bezpieczny system biletowy',
                text: 'Każdy bilet ma unikalny kod, który jest ukryty przed innymi graczami. Kod określa zwycięzcę!',
            },
            LuckyStrikePricePool: {
                title: 'Nagroda = {{text}}',
                text: 'Całkowita pula otrzymana z nagród za bilety. Jeden zwycięzca bierze wszystko. Nagroda wypłacana jest na portfel gier',
            },
            LuckyStrikeParticipants: {
                title: 'Uczestnik = {{text}}',
                text: 'Gracze biorący udział i Limit graczy. Po osiągnięciu limitu bilety stają się niedostępne do nabycia',
            },
            LuckyStrikeHowItWorks: {
                stepOne: {
                    title: 'Przedstawiamy Lucky Strike',
                    text: 'Weź udział w jednej z rund i wygraj solidną nagrodę! Każdy dodatkowy bilet w którejkolwiek z rund zwiększa twoje szanse na wygraną',
                },
                stepTwo: {
                    title: 'Zwiększ swoje szanse',
                    text: 'Każdy gracz ma szansę wygrać całą pulę zebraną ze środków, na które zakupiono bilety. Im więcej biletów zbierzesz, tym większa szansa na zdobycie nagrody',
                },
                stepThree: {
                    title: 'Oszukiwanie jest niemożliwe',
                    text: 'Ponieważ kod biletu nie jest dostępny dla innych użytkowników, oszustwo nie jest możliwe. Jeśli wydaje ci się, że masz pecha, tak jest. Pobaw się trochę więcej, a sytuacja na pewno się zmieni',
                },
            },
            LuckyStrikeMain: {
                title: 'Runda',
                text: 'Rundy różnią się czasem trwania, liczbą graczy i szansą na wygraną',
                emptyList: {
                    title: 'Brak zwycięzców',
                    text: 'Nie ma jeszcze użytkowników, którzy wygrali rundę. Wkrótce się pojawią.',
                },
            },
            LuckyStrikeWinners: {
                title: 'Zwycięzca',
                text: 'Spójrz na zwycięzców gry!',
            },
            LuckyStrikePurchaseModal: {
                title: 'Kup bilet "{{type}}"',
                text: 'Fundusze są zbierane z puli gier. Zwycięzca bierze całą pulę i jest określany na podstawie hash biletu. Im więcej biletów zbierzesz, tym większa szansa na zdobycie nagrody',
                alert: 'Aby zapobiec oszustwom i poprawić rozgrywkę, nie można kupić więcej niż {{maxTickets}} biletów',
            },
            LuckyStrikeWaitingForResult: {
                title: 'Odliczanie!',
                text: 'Poczekaj na zakończenie rundy, aby poznać wynik gry. Możesz kupić więcej biletów, aby zwiększyć swoje szanse na wygraną',
            },
            LuckyStrikeUserTickets: {
                text: 'Każdy bilet ma unikalny kod, który jest ukryty przed innymi graczami i pomaga nam zagwarantować uczciwość gry',
                alert: 'Masz już nie więcej niż {{text}} biletów na grę',
            },

            LuckyStrikeHistoryItem: {
                [LUCKY_STRIKE_GAMES_STATUS.Won]: '{{round}} wygrany',
                [LUCKY_STRIKE_GAMES_STATUS.Lost]: '{{round}} przegrany',
                [LUCKY_STRIKE_GAMES_STATUS.WaitingForResults]:
                    'Oczekiwanie na wyniki',
            },
            LuckyStrikeHistoryBlockHeader: {
                [LUCKY_STRIKE_GAMES_STATUS.Won]: {
                    title: 'Wygrałeś!',
                    textOne:
                        'Gratulacje! Twój bilet okazał się szczęśliwy i wygrałeś całą pulę nagród. ',
                    textTwo:
                        ' zostaną natychmiast przelane do Twojego portfela',
                },

                [LUCKY_STRIKE_GAMES_STATUS.Lost]: {
                    title: 'Przegrałeś :(',
                    text: 'Niestety tym razem nie udało Ci się wygrać rundy. Powodzenia w następnym!',
                },
            },
            LuckyStrikeGameHistoryInfo: {
                gameType: 'Rodzaj gry',
                correctTicket: 'Zwycięski bilet',
                yourTicket: 'Wasz bilet',
                yourTickets: 'Wasz bilety',
            },

            toasts: {
                soldOut: {
                    text1: 'Błąd!',
                    text2: 'Wszystkie bilety wyprzedane!',
                },
                gameExpired: {
                    text1: 'Blad!',
                    text2: 'Runda się skończyła!',
                },
                gamePending: {
                    text1: 'Ups!',
                    text2: 'Coś poszło nie tak',
                },
            },
        },

        [MYSTERY_GAMES.quantumSpin]: {
            keys: {
                spin: 'Obróć',
                spinning: 'Obraca się',
            },
            QuantumSpinProvablyFair: {
                card: {
                    title: 'Testowalna randomizacja',
                    text: 'Wszystkie wyniki są obliczane za pomocą funkcji kryptograficznej, która pozwala każdemu sprawdzić uczciwość gry',
                },

                title: 'Testowalna randomizacja',
                text: 'Wyniki są połączone w łańcuch kryptograficzny, co uniemożliwia oszukanie systemu. Ponieważ opublikowaliśmy pierwszy hash na Twitterze, możesz sam przekonać się o uczciwości wyników',
                algorithm: {
                    title: 'Algorytm',
                    text: 'Wyniki kolejnych {{rounds}} rund są wstępnie generowane. Przed każdą rundą ujawniamy hash wyniku, co uniemożliwia jego zmianę po fakcie.\n\nWszystkie wyniki są połączone w kryptograficzny "łańcuch", co uniemożliwia ich zmianę. Przed wygenerowaniem łańcucha wyników opublikowaliśmy pierwszy hash na Twitterze, mieszając go z nieznanym wcześniej hashem bloku Bitcoin. W ten sposób wyniki można zweryfikować i są one naprawdę arbitralne.\n\nŁańcuch skrótów został utworzony przed pierwszą rundą gry. Każdy hash jest wartością 256-bitową. Łańcuch zaczyna się od losowo wybranej wartości 256-bitowej, a każda kolejna wartość jest obliczana przy użyciu skrótu BLAKE2b poprzedniej wartości.\n\nKryptograficzna hash-funkcja zapewnia, że można łatwo obliczyć dowolną wartość w łańcuchu przy użyciu poprzedniej wartości, ale nie można obliczyć wartości wstecz. Ostatnia wartość w wstępnie obliczonym hash-łańcuchu, początkowy hash, opublikowaliśmy publicznie i wykorzystaliśmy w pierwszej rundzie gry. W każdej następnej rundzie używana jest poprzednia wartość hash. Przechodząc przez łańcuch w ten sposób, można upewnić się, że wyniki wszystkich poprzednich rund gry są zgodne z wcześniej obliczonym łańcuchem, ale wynik przyszłych rund pozostaje nieprzewidywalny dla użytkowników.\n\nAby wyeliminować możliwość, że celowo utworzyliśmy łańcuch przy użyciu określonej wartości początkowej, która zniekształciłaby wyniki gry na naszą korzyść, każda wartość w łańcuchu jest dodawana do globalnej wartości początkowej, a wynikowa wartość jest ponownie „zahashowana” przy użyciu BLAKE2b do obliczenia wartości końcowej. Tak określa się wynik każdej rundy gry. Ta globalna wartość początkowa odpowiada hashowi bloku Bitcoina, który publicznie wybraliśmy przed jego wydobyciem. Globalna wartość początkowa zapewnia, że wynik gier był dla nas nieznany, gdy opublikowano wartości hash pierwszej gry',
                },
                verification: {
                    title: 'Przykładowa Weryfikacja',
                    text: 'Każdy może sprawdzić, czy wyniki wszystkich poprzednich rund gry zostały wygenerowane przy użyciu sprawdzalnego algorytmu randomizacji za pomocą następującego kodu Pythona',
                },
            },
            QuantumSpinHowItWorks: {
                stepOne: {
                    title: 'Zakręć kołem kwantowym',
                    text: 'Koło znajduje się w superpozycji, więc nie wiadomo z góry, jaki wynik pokaże. Zakręć kołem, aby wyprowadzić go z superpozycji i wygrać największą nagrodę',
                },
                stepTwo: {
                    title: 'Każdy zwrot kwantowy wymaga energii, czyli tokenów',
                    text: 'Twoja nagroda może być niższa lub wyższa niż twoja stawka. Oczywiście możesz otrzymać ogromną nagrodę!',
                },
                stepThree: {
                    title: 'Oszukiwanie jest niemożliwe',
                    text: 'Wyniki tury są ustalane losowo w momencie gry i nie są znane teamu. Cenimy uczciwość i przejrzystość',
                },
            },
            QuantumSuccess: {
                coin: 'Gratulacje! Wygrałeś {{coin}}, który zostanie natychmiast przeniesiony do twojego portfela. Spróbuj szczęścia jeszcze raz i podziel się swoimi wynikami w sieciach społecznościowych',
                rank: 'Gratulacje! Wygrałeś NFT rangi {{coin}} i zostanie ona natychmiast przeniesiona do portfela. Spróbuj szczęścia jeszcze raz i podziel się swoimi wynikami w sieciach społecznościowych',
            },
            QuantumSpinGameHistory: {
                again: 'Obróć ponownie',
            },
            QuantumSpinDetailsModal: {
                button: 'Powrót do dysku',
            },
            QuantumSpinHistory: {
                title: 'Tu jest pusto',
                text: 'Nie zagraliście jeszcze żadnej gry',
            },
        },
        [MYSTERY_GAMES.tokenteller]: {
            predictPrice: 'Przewidzieć cenę',
            addMoreTokens: 'Dodaj więcej tokenów',
            priceDirection: 'Kierunek ceny',

            [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Up]: 'W GÓRĘ',
            [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Down]: 'W DÓŁ',
            TokenTellerConfirmationModal: {
                [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Up]: 'Mnożnik byka',
                [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Down]:
                    'Mnożnik niedźwiedzi',
            },

            TokenTellerHowItWorks: {
                stepOne: {
                    title: 'Tokenteller',
                    text: 'Sprawdź swoje umiejętności przewidywania w dynamicznej grze. Zgadnij ruch cenowy IGU w {{min}}-minutowych rundach. Możesz użyć wszelkich niezbędnych środków: kryształowych kul, wróżbitów, a nawet czarnej magii',
                },
                stepTwo: {
                    title: 'Wielkość nagrody',
                    text: 'W grze wybierasz, czy token spadnie, czy wzrośnie. Wysokość Twojej nagrody zależy od mnożnika, który jest stosunkiem puli byków do puli niedźwiedzi. Mnożnik jest wyświetlany na karcie dołączania do rundy i może się zmieniać przed rozpoczęciem rundy',
                },
                stepThree: {
                    title: 'Oszukiwanie jest niemożliwe',
                    text: 'Używamy solidnej wyroczni, która zapewnia zgodność aktualnej ceny {{coin}} w aplikacji i ceny na giełdach. Zawsze możesz sprawdzić cenę',
                },
            },
            TokenTellerMainScreen: {
                title: 'Rundy',
                text: 'Możesz dołączyć tylko do nadchodzącej rundy',
            },
            TokenTellerPurchaseModal: {
                title: 'Zgadnij ruch cenowy',
                text: 'Dołącz do rundy, aby przewidzieć, dokąd pójdzie {{coin}}. Wybierz stawkę i kierunek poniżej',
                alert: 'Już wybrałeś, że token pójdzie W {{direction}}. Teraz możesz tylko zwiększyć swoją pozycję w tym kierunku',
            },

            TokenTellerPricePool: {
                title: 'Pula = {{text}}',
                text: 'Pula jest zbierana z zakładów użytkowników. Nagroda zależy od relacji między stawkami byków i niedźwiedzimi',
            },
            TokenTellerUpPayout: {
                title: 'Mnożnik byka = {{coefficient}}X',
                text: 'Mnożnik nagrody zwycięzcy przy wzroście ceny',
            },
            TokenTellerDownPayout: {
                title: 'Mnożnik niedźwiedzi = {{coefficient}}X',
                text: 'Mnożnik nagrody zwycięzcy w przypadku spadku ceny',
            },
            TokenTellerParticipants: {
                title: 'Uczestnicy = {{text}}',
                text: 'Liczba graczy biorących udział w rundzie',
            },

            TokenTellerTimerBlock: {
                [TOKEN_TELLER_GAME_STATUS.Pending]: {
                    title: 'Runda zaczyna się za',
                },
                [TOKEN_TELLER_GAME_STATUS.Closed]: {
                    title: 'Runda kończy się za',
                },
            },
            TokenTellerHistoryItem: {
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Won]: 'Wygrana',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Lost]: 'Przegrana',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.WaitingForResults]:
                    'Oczekiwanie na wynik',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Refund]: 'Remis',
            },

            TokenTellerHistoryBlockHeader: {
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Won]: {
                    title: 'Wygrałeś!',
                    textOne: 'Gratulacje! Prawidłowo przewidziałeś ruch cen. ',
                    textTwo:
                        ' zostanie natychmiast przelany do Twojego portfela',
                },

                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Lost]: {
                    title: 'Przegrałeś :(',
                    text: 'Niestety tym razem nie udało Ci się wygrać. Dobra powód, aby sprawdzić się w następnej rundzie!',
                },
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Refund]: {
                    title: 'O rany, to remis!',
                    text: 'Choć może się to wydawać nieprawdopodobne, jest remis. Twoja stawka została zwrócona do portfela',
                },
            },

            TokenTellerGameHistoryInfoItem: {
                iguBefore: 'Cena początkowa',
                iguAfter: 'Cena zamknięcia',
                prediction: 'Pozycja',
                totalPool: 'Ogólna pula',
                participants: 'Uczestnicy',
                upPayout: 'Mnożnik byka',
                downPayout: 'Mnożnik niedźwiedzi',
            },
        },
        DailyTasks: {
            header: 'Zadania codzienne',
            collected: '{{collectedEnergy}} / {{maxEnergy}} Zebrane',
            SocialTask: {
                title: 'Zadanie społeczne',
                text: 'Zrób posty w mediach społecznościowych',
            },
            VerificationTask: {
                title: 'Zlecenie wyszukiwania',
                text: 'Sprawdź wiadomości innych użytkowników',
            },
            MoveTask: {
                title: 'Ruchome zadanie',
                text: 'Ciesz się spacerem na zewnątrz ze swoim zwierzakiem',
            },
            PlayTask: {
                title: 'Misja gry',
                text: 'Zagraj w ekscytującą grę zręcznościową',
            },
        },
        ReferralCard: {
            title: '{{percent}}% zniżki na NFT!',
            text: 'Zaproś nowych użytkowników do aplikacji IguVerse i otrzymaj zniżkę na NFT mint',
            button: 'Zaproś',
        },
        TimerTopUp: {
            title: 'za każdą wpłatę',
            text1: 'Zdeponuj tokeny teraz i otrzymaj {{percent}}% {{coin}} do swojego portfela! Dostępne tylko do:',
            text2: 'Zacznij grać w nasze nowe gry Pvp i zdobądź bonusowe tokeny!',
        },
    },
    pvpBonus: {
        cardButton: 'PVP Bonus',
        title: 'Bonusy PvP',
        text: 'Właściciele NFT mogą otrzymać dodatkowe nagrody za udział w PvP. Zacznij już teraz i zdobądź swoje bonusy!',
        pvpBonusModal: {
            title: 'Jak zarobić więcej w PvP',
            text: 'Przychody IguVerse z PvP będą rozdzielane między graczy proporcjonalnie do obrotów! Załóż NFT, a automatycznie otrzymasz bonusy za każdą grę',
            features: {
                games: {
                    title: 'Licznik gier = {{games}}',
                    text: 'Liczba gier, które dzisiaj rozegrałeś. Co powiesz na jeszcze jedną?',
                },
                bonus: {
                    title: 'Bonusy PvP = {{amount}}',
                    text: 'Są to dodatkowe tokeny, które otrzymujesz za granie w gry PvP pod koniec dnia. Walcz z innymi i zarabiaj jeszcze więcej!',
                },
            },
        },
        pvpBonusModalFreePet: {
            title: 'Podnieś rangę, aby otrzymać więcej tokenów w PvP',
            text: 'Ranga Twojego zwierzaka Free musi zostać podniesiona na wyższą, abyś mógł korzystać z bonusów z PvP',
        },
    },
    MarketPlace: {
        navigationBar: {
            ORDERS: 'Aktywne zlecenia',
            MY_PROFILE: 'Mój profil',
        },
        MarketPlaceActiveOrdersScreen: {
            title: 'Rynek',
            text: 'Miejsce handlu NFT',
            empty: {
                title: 'Brak NFT na sprzedaż',
                text: 'Na razie nie ma zleceń sprzedaży. Stworz zlecenie jako pierwszy!',
            },
            notFound: {
                title: 'Nie znaleziono wyników',
                text: 'Nie znaleźliśmy takich zleceń. Wpisz inne wyszukiwane słowo kluczowe',
            },
        },
        MarketPlaceSearch: {
            modalTitle: 'Filtry',
            placeHolder: 'Szukaj nft, kolekcji, użytkownika...',
            typeSection: {
                [MARKETPLACE_PET_TYPE.AISystem]: 'System AI',
                [MARKETPLACE_PET_TYPE.FromPhoto]: 'Od zdjęcia',
                [MARKETPLACE_PET_TYPE.Alive]: 'Żywy',
                [MARKETPLACE_PET_TYPE.Dead]: 'Martwy',
            },

            sortBySection: {
                [MARKETPLACE_ORDERS_SORT_OPTION.FromHighestPrice]:
                    'Od najwyższej ceny',
                [MARKETPLACE_ORDERS_SORT_OPTION.FromLowestPrice]:
                    'Z najniższej ceny',
                [MARKETPLACE_ORDERS_SORT_OPTION.RecentlyListed]:
                    'Ostatnio notowane',
                [MARKETPLACE_ORDERS_SORT_OPTION.EndingSoon]: 'Wkrótce koniec',
            },
        },
        MarketPlaceWelcomeCreateOrderScreen: {
            screenTitle: 'Złóż nowe zamówienie',
            title: 'Przygotuj NFT na wielką podróż',
            text: 'Tutaj możesz wystawić swój NFT i sprzedać go',
            features: {
                rank: {
                    title: 'Minimalna ranga – {{rank}}',
                    text: 'Twój NFT powinien mieć rangę wyższą niż {{lowRank}}. Tylko NFT zakupione w aplikacji mogą być sprzedawane na Rynek',
                },
                termination: {
                    title: 'Automatyczne zakończenie = {{days}} Dni',
                    text: 'Czas wygaśnięcia zlecenia, jeśli NFT nie został zakupiony wcześniej',
                    alert: 'Jeśli nikt nie zakupi NFT w ciągu {{days}} dni, zamówienie zostanie automatycznie usunięte z Rynek. Podczas wystawienia na sprzedaż możesz kontynuować grę i zarabiać',
                },
                commission: {
                    title: 'Opłata prowizyjna = {{commission}}%',
                    text: 'Za każdy pomyślnie sprzedany NFT pobierana jest prowizja w wysokości {{commission}}%',
                },
            },
        },
        MarketPlaceModalNoPet: {
            title: 'Nie posiadasz ani jednego NFT',
            text: 'Stwórz przynajmniej jeden NFT na sprzedaż. Możesz je kowalski już teraz!',
        },
        MarketPlaceSelectNftScreen: {
            screenTitle: 'Wybierz NFT',
        },
        MarketPlaceSelectNftPriceScreen: {
            screenTitle: 'Wprowadź cenę NFT',
        },
        MarketPlaceCreateOrderSuccessScreen: {
            title: 'Powstało zlecenie na sprzedaż NFT',
            text: 'Pomyślnie umieściłeś swój NFT na rynku. Teraz inni użytkownicy będą mogli go kupić',
        },
        navigationBarOverview: {
            OVERVIEW: 'Przegląd',
            OWNER_HISTORY: 'Historia właściciela',
        },
        MarketPlaceOverview: {
            text: 'To jest NFT innego użytkownika. Możesz zobaczyć jego cechy poniżej:',
            textOwner:
                'To jest Twoje NFT. Możesz zobaczyć jego charakterystykę poniżej:',
            OverviewOwnerSection: {
                profileLabel: 'Profil Właściciela',
            },
            proceedToCheckoutModal: {
                title: 'Przejdź do zakupu?',
                text: 'Po zakupie NFT będzie w trybie pasywnym przez 24 godziny. Przed zakupem sprawdź wszystkie jego właściwości',
            },
        },
        DelistNftModal: {
            title: 'Usunąć zlecenia?',
            text: 'W przypadku wycofania NFT nie będzie już wystawiany na sprzedaż',
        },
        MarketplaceProfile: {
            joined: 'Dołączenie {{date}}',
            myNFTs: 'Moje NFT',
            exploreNFTs: 'Poznaj NFT',
            emptyUser: {
                title: 'Brak zleceń',
                text: 'Nie utworzono jeszcze żadnych zleceń na rynku',
            },
            empty: {
                title: 'Brak zleceń',
                text: 'Ten użytkownik nie utworzył jeszcze żadnego zamówienia',
            },
        },
        MarketPlaceDelistSuccessScreen: {
            title: 'NFT "{{name}}" została pomyślnie usunięta z Rynek',
        },
        MarketPlaceBuySuccessScreen: {
            title: 'Nowy NFT w kolekcji',
            text: 'Pomyślnie kupiłeś nowy NFT! Teraz twoja kolekcja została wzbogacona o nowego zwierzaka i stała się znacznie silniejsza',
        },
        MarketPlaceOverviewOwnerHistoryScreen: {
            empty: {
                title: 'Brak historii NFT',
                text: 'NFT nie było jeszcze przedmiotem obrotu. Możesz być pierwszym, który go kupi!',
            },
        },
        MarketPlaceNoTradeAvalibleScreen: {
            title: 'Targowisko się skończyło!',
            description:
                'Właśnie uruchomiliśmy naszą wewnętrzną platformę transakcyjną, na której możesz handlować swoimi NFT. Otwórz go przez aplikację internetową i stwórz swoje pierwsze zamówienie już teraz!',
            button: 'Eksploruj w aplikacji internetowej',
        },
    },
    SpaceId: {
        card: {
            title: 'Zdobądź swój SPACE ID teraz',
            text: 'Używaj swojego oryginalnego pseudonimu w aplikacji i w całej kryptowalucie',
        },
        how: {
            screenTitle: 'Jak korzystać z SPACE ID',
            title: 'Stwórz cyfrowy identyfikator',
            text: 'Masz dość skomplikowanych nieczytelnych adresów? Zamień swój adres na odpowiednią nazwę domeny z identyfikatorem SPACE!',
            guideBlock: {
                first: 'Zaimportuj swój portfel IguVerse do dowolnego nie-custodialnego DeFi-wallet (np. Trustwallet, Metamask) używając frazy sido',
                second: 'Dodaj sieć BEP-20 i podłącz portfel do witryny',
                third: 'Znajdź odpowiednią nazwę domeny na stronie internetowej',
                fourth: 'Kup odpowiednią nazwę domeny i zaktualizuj aplikację IguVerse. Będziesz mógł zobaczyć swój nick użytkownika w portfelu, w tabeli liderów i wszędzie tam, gdzie jest on używany',
                alert: 'Aby kupić domenę, trzeba mieć w portfelu trochę BNB',
            },
            button1: 'Sprawdź domeny',
        },
        modal: {
            title: 'Unikalny identyfikator SPACE ID!',
            text: 'Pomyślnie zakupiłeś i zarejestrowałeś własną domenę! Od teraz Twoja unikalna nazwa będzie wyświetlana wszędzie w aplikacji. Twój prawdziwy adres pozostanie bez zmian. Aby go skopiować, naciśnij przycisk "Kopiuj" w swoim portfelu',
            link: 'Dowiedz się więcej w SPACE ID',
        },
    },
    Achievements: {
        title: 'Osiągnięcie',
        text: 'Ekscytujące zadania, które pomagają śledzić twoje unikalne postępy i pozwalają pokazać swoje umiejętności i wrażenia z gry',
        unlocked: 'Osiągnięcie {{achievement}} odblokowane!',
        unlockedText:
            'Gratulacje, udało ci się odblokować nowe osiągnięcie. Udostępnij go znajomym w mediach społecznościowych!',
        button: 'Udział w osiągnięciach',
        modal: {
            title: 'Wyróżnij się osiągnięciami',
            text: 'Wykonuj zadania, aby zdobyć osiągnięcia. O wiele ciekawiej jest grać, gdy jest wyzwanie, a do tego skrzynia pełna nagród',
        },
    },
};

export default pl;
